'use strict';

import {CountrySelect} from './mobile/modules/country_select.js';
import {DolStreamPromo} from './mobile/modules/dol_stream_promo.js';
import {AssetsLoader} from './ycomponent/assets_loader.js';
import {StickyHelper} from './mobile/modules/sticky_helper.js';
import {SearchNavigation} from './mobile/modules/searchnavigation.js';
import {Accessibility} from './mobile/modules/accessibility.js';
import {Marquee} from './mobile/modules/marquee.js';
import {AndroidKeyboardCloseDetector} from './mobile/modules/android_keyboard_close_detector.js';
import {FavManager} from './mobile/modules/fav_manager.js';
import {MoleculeGroupPhonecall} from './ycomponent/molecule/molecule_group_phonecall.js';

yalwa.mobile = (function(pub) {

	pub = pub || {};

	var browse_history_key = 'browse_history';
	var location_history_key = 'location_history';
	var $window = null;
	var $document = null;
	var $body = null;
	var $headroom = null;
	var $main_col = null;
	var geoid_chosen = null;
	var supports_passive_event_handler = null;
	var pwa_prompt = null;
	var ajax_login_no_register = false;
	var ptr_active = false;
	var htabs_active = false;
	const fav_manager = new FavManager();

	pub.init = function() {
		// Initial for serverside rendered ycomponents
		const assets_loader = new AssetsLoader();
		assets_loader.init_components().then(() => assets_loader.init_vue_components());
		$window = jQuery(window);
		$document = jQuery(document);
		$body = jQuery('body');
		$headroom = jQuery('.headroom');
		$main_col = jQuery('.js-main_col');
		if (yalwa.v.areaID) {
			yalwa.basics.ls_set('last_areaID', parseInt(yalwa.v.areaID));
		}
		check_supports_passive();
		$document.on('keydown', function(event) {
			if (event.key === 'Enter') {
				jQuery(event.target).trigger('enterdown');
			}
		});
		//check if the clicked element has no_register class
		if (!yalwa.basics.is_logged_in()) {
			jQuery('.no_register').on('click', function() {
				ajax_login_no_register = true;
			});
		}
		yalwa.mobile.htabs.init();
		pub.scroll_check();
		scroll_watch();
		ptr_init();
		plp_init();
		pagination_init();
		popsearch_paning_init();
		attach_goto_ad_handler();
		init_dropdown_buttons();
		init_loc_yalwa();
		if (yalwa.v.is_ios) {
			jQuery('body').addClass('detected_ios');
		}
		if (yalwa.v.read_only_announcement) {
			yalwa.mobile.show_announcement(yalwa.v.read_only_announcement);
		}
		jQuery(document).on('click', '.js-pwa_install', pub.install_pwa);
		jQuery(document).on('click', '.js-app_install_burger', pub.open_or_install_native_app);
		jQuery(document).on('click', '.js-iosapp_install_burger', pub.show_ios_app_install_prompt);
		check_dol_reminder_top();
		check_pa_expired_banner();

		if (yalwa.basics.get_routing() != 'premium_confirm') {
			pub.top_ad_upselling_promo.load_headroom_promo();
		}

		if (yalwa.basics.get_routing() != 'cart' && yalwa.basics.get_routing() != 'checkout') {
			premium.load_cart_headroom_promo();
		}

		if (yalwa.v.ml_token_invalid) {
			yalwa.basics.toast({message: yalwa.v.lang.magic_link_error_expired, type: 'error'});
		}
		init_reveal_password();
		jQuery('.js-lost_pw_ml_btn').on('click', () => {
			yalwa.mobile.auth.show_dialog().done(() => {
				yalwa.mobile.magic_link.toggle_to_ml_form()
			});
		});
		const dol_stream_promo = new DolStreamPromo();
		check_h1_position();
		init_h1_position_observer();
		const search_navigation = new SearchNavigation();
		search_navigation.init();
		init_bst_sliders();
		init_maxlength_textareas();
		const accessibility = new Accessibility();
		accessibility.init();
		jQuery('.js-marquee').each(function () {
			new Marquee(jQuery(this));
		});
		fav_manager.render();
        pub.init_nudge();
		
		jQuery('.js-pa_phone_website_info_expand').on('click',  function() {
			yalwa.basics.bem_modifier(jQuery(this).closest('.js-cart_pa_phone_website_info'), 'expanded', 'toggle');
		});
	};

	pub.get_app_intent_url = function() {
		let package_name = yalwa.v.android_app_package;
		return `intent://#Intent;scheme=locanto;package=${package_name};end;`;
	}

	pub.is_mobile_width = function() {
		return window.innerWidth <= 768;
	}

	pub.show_ios_app_install_prompt = function() {
		yalwa.basics.navigate(yalwa.v.ios_app_url);
	}

	pub.open_or_install_native_app = function(e) {
		if (yalwa.basics.is_safari()) {
			pub.install_pwa(e);
			return;
		}

		let url = pub.get_app_intent_url();
		yalwa.basics.navigate(url);
	}

	pub.assets_loader = function() {
		return new AssetsLoader();
	}

	function init_h1_position_observer() {
		if (!jQuery('.js-headroom').length) {
			return;
		}
		const target_element = jQuery('.js-headroom')[0];
		if (typeof ResizeObserver !== 'undefined') {
			const observer = new ResizeObserver(function(entries) {
				check_h1_position();
			});
			observer.observe(target_element);
		}
	}

	function check_h1_position() {
		const $app_title = jQuery('.js-app_title');
		const $logo_img = jQuery('.js-ovw_logo');
		if ($app_title.length && $logo_img.length) {
			if (pub.matches_breakpoint('desktop') && jQuery('.js-ovw_desktop_header').length) {
				// Check if $app_title is already after $logo_img
				if ($logo_img.next().hasClass('js-app_title')) {
					return;
				}
				// Create a placeholder at the original position
				const $app_title_placeholder = jQuery('<div class="js-app_title_placeholder" style="display: none;"></div>');
				$app_title.after($app_title_placeholder); // Add the placeholder right after the element to remember the position
				// Move $app_title to after $logo_img
				$app_title.insertAfter($logo_img);
			} else {
				// move it back
				const $original_placeholder = jQuery('.js-app_title_placeholder');
				if ($original_placeholder.length) {
					$original_placeholder.before($app_title); // Move $app_title back to the original position
					$original_placeholder.remove(); // Clean up the placeholder
				}
			}
		}
	}

	pub.matches_breakpoint = function(type) {
		return matchMedia('(min-width: ' + jQuery('html').css('--bp_' + type) + ')').matches;
	};

	function init_dropdown_buttons() {
		jQuery('.js-button_dropdown').on('click', function() {
			const $target = jQuery(this).find('.js-button_dropdown_options');
			yalwa.basics.toggle($target);
		});
	}



	pub.install_pwa = (e) => {
		let promo_location = 'header';
		if (e.target.parentNode.classList[0] === 'js-pwa_promotion_burger') {
			promo_location = 'burger_menu';
		}
		yalwa.basics.ga.event({
			category: 'pwa_promo',
			action: 'install',
			label: yalwa.v.is_logged_in === undefined ? 'logged_out' : 'logged_in' + '_' + promo_location
		});
		pwa_prompt && pwa_prompt.prompt();
	};

	function check_dol_reminder_top() {
		const $reminder_dol = jQuery('.js-dol_reminder');
		if (!$reminder_dol.length) {
			return false;
		}
		let dol_reminder_action_count = 0;
		let actual_user_status = $reminder_dol.data('user_status') || false;
		let user_status = yalwa.basics.ls_get('dol_reminder_user_status') || false;
		if (actual_user_status && (actual_user_status !== user_status)) {
			yalwa.basics.set_cookie('dol_reminder_action_count', 0, -1);
		}
		yalwa.basics.ls_set('dol_reminder_user_status', actual_user_status);
		$reminder_dol.velocity('fadeIn', {
			display: '',
			complete: function() {
				jQuery('html').animate({scrollTop: 0}, "slow");
			}
		}).removeClass('invisible');
		$reminder_dol.on('click', function() {
			yalwa.basics.set_cookie('dol_reminder_clicked', dol_reminder_action_count + 1, 86400);
			yalwa.basics.set_cookie('dol_reminder_action_count', (yalwa.basics.get_cookie('dol_reminder_action_count') || 0) + 1);
		});
		jQuery('.js-dol_reminder_close').on('click', function(event) {
			event.preventDefault();
			yalwa.basics.set_cookie('dol_reminder_clicked', dol_reminder_action_count + 1, 86400);
			yalwa.basics.set_cookie('dol_reminder_action_count', (yalwa.basics.get_cookie('dol_reminder_action_count') || 0) + 1);
			yalwa.basics.hide(jQuery('.js-dol_reminder').velocity('fadeOut', {display: ''}));
			jQuery('.js-dol_reminder_clone').remove();
			return false;
		});
	}

	function check_pa_expired_banner() {
		const $banner = jQuery('.js-pa_expired_banner');
		if (!$banner.length) {
			return;
		}
		$banner.velocity('fadeIn', {display: ''}).removeClass('invisible');
		$banner.on('click', function(event) {
			event.preventDefault();
			jQuery.post(
				'/api/ajax/general',
				{
					action: 'renew_pa'
				},
				function(response) {
					if (response.checkout_url) {
						window.location.href = response.checkout_url;
					}
				},
				'json'
			);
		});
		jQuery('.js-pa_expired_banner_close').on('click', function(event) {
			jQuery.post(
				'/api/ajax/general',
				{
					action: 'dismiss_pa_expired_banner'
				},
				function() {
					yalwa.basics.hide($banner.velocity('fadeOut', {display: ''}));
				}
			);
			return false;
		});
	}

	function init_loc_yalwa() {
		ltw.init();
		pub.generic_shadow.init();
		pub.premium_tracking.init();
		check_routing();
		navigation_init();
		init_last_ads_session();
		geolocation_init();
		share_init();
		yalwa.basics.check_sp_params();
		yalwa.basics.init_nickname_dialog();
		if (yalwa.basics.random_percentage(2)) {
			init_mobile_buttons_tracking();
		}
		if (jQuery('.js-book_premium').length) {
			premium.init();
		}
		pwa_init();
		pwa_promo_tracking_init();
		pwa_promo_pageview_count();

		jQuery('.js-generic_tip').on('click', function() {
			var $this = jQuery(this);
			$this.toggleClass('gtip').toggleClass('js-gtip');
			jQuery('.js-gtip').not($this).removeClass('gtip').removeClass('js-gtip');
		});

		pub.check_for_detach();

		jQuery('.js-top_link').on('click', function(e) {
			e.preventDefault();
			yalwa.mobile.mainscroll_set(0);
			jQuery('html').scrollTop(0);
		});

		jQuery('.js-post_similar').on('click', function(e) {
			e.preventDefault();
			yalwa.basics.ls_set('post_similar', true);
			yalwa.basics.navigate(jQuery(this).prop('href'));
		});

		jQuery('.js-geo_change_location').on('click', jump_location_input);

		if (yalwa.v.is_phonegap) {
			yalwa.mobile.cordova.init();
		}

		// sometimes hover effects and other stuff prevents click events firing (and 2 clicks are needed), this should avoid this (needed for ios in particular)
		jQuery('.js-expand_click').on('click', expand_click);

		jQuery('.js-ignore_mfd_toggle').on('click', function() {
			yalwa.mobile.mfd({html: jQuery('.js-ignore_mfd').html()});
			event.preventDefault();
			event.stopPropagation();
			return false;
		});

		if (jQuery('.js-pa_label_mfd').length) {
			jQuery('.js-mfd_pa_label').on('click', function(event) {
				yalwa.mobile.mfd({html: jQuery('.js-pa_label_mfd').first().html()});
				event.preventDefault();
				event.stopPropagation();
				return false;
			});
		}
		if (jQuery('.js-phone_verification_mfd').length) {
			jQuery('.js-phone_verification_promo').on('click', function(event) {
				yalwa.mobile.mfd({html: jQuery('.js-phone_verification_mfd').first().html()});
				event.preventDefault();
				event.stopPropagation();
				return false;
			});
		}
		if (jQuery('.js-pa_see_followers_mfd').length) {
			pub.init_followers_popup();
		}

		var d = document.documentElement.style;
		if (!('flexWrap' in d) && !('WebkitFlexWrap' in d)) {
			$body.addClass('noflexwrap');
		}

		init_default_form_elements();
		if (['mc', 'settings', 'account_activation', 'dol'].indexOf(yalwa.basics.get_routing()) === -1) {
			yalwa.mobile.stop_invisible_start();
		}

		yalwa.basics.state.init();

		$window.on('pageshow', on_pageshow);
		if (yalwa.basics.get_routing() !== 'mc') {
			pub.carousel.init();
		}
		// if (!location.port) {
		// 	console.log('%cAre you a developer? Join us here at Yalwa: https://www.yalwa.info/career/it_1_front-end-software-developer_en.html', 'color:green;');
		// }
		window.addEventListener('beforeinstallprompt', e => {
			// Prevent Chrome from showing the native AppInstall banner
			e.preventDefault();

			// Stash the event so it can be triggered later.
			pwa_prompt = e;
			if (yalwa.basics.get_get('pwa') === '1') {
				jQuery('.js-burger_menu_open').trigger('click');
			}

			yalwa.basics.set_cookie('can_install_pwa', 1, 5184000); // 60 days
		});

		check_heights();
		$window.on('resize', check_heights);
		premium.init_shopping_cart_badge_update();

		jQuery('.js-nlp_categories_image_link').on('mouseover', function() {
			let $title = jQuery(this).closest('.js-nlp_category').find('.js-nlp_title > .h3');
			if ($title.length) {
				$title.css({'text-decoration': 'underline'});
			}
		}).on('mouseout', function() {
			let $title = jQuery(this).closest('.js-nlp_category').find('.js-nlp_title > .h3');
			if ($title.length) {
				$title.css({'text-decoration': 'none'});
			}
		});
	}

	// sometimes viewport and window height are not the same, e.g. iOS showing the bottom tab bar
	function check_heights() {
		var $ruler = jQuery('<div class="js-ruler" style="position:fixed;height:100vh;width:0;top:0;"></div>');
		let $html = jQuery('html');
		$html.append($ruler);
		let axis = Math.abs(window.orientation);
		// let w = axis === 90 ? $ruler[0].offsetHeight : window.innerWidth;
		let h = axis === 90 ? window.innerWidth : $ruler[0].offsetHeight;
		jQuery('.js-ruler').remove();
		$html.toggleClass('viewport_height_trimmed', (axis === 90 && $window.height() !== h));
	}

	function handle_dol_click(event) {
		let url = jQuery(this).attr('href');
		event.preventDefault();
		var $this = jQuery(this);
		if ($this.data('d1')) {
			yalwa.basics.ga.event({category: $this.data('d1'), action: $this.data('d2'), label: $this.data('d3')});
		}
		yalwa.mobile.burger.menu_hide(false, true);
		if (yalwa.basics.is_logged_in()) {
			jQuery.ajax({
				url: '/api/ajax/dol/',
				dataType: 'json',
				type: 'get',
				data: {action: 'is_deleted_profile'}
			}).done(function(response) {
				if (response.success) {
					jQuery('.js-dol_account_cooldown_plp').trigger('plp_show');
				} else {
					yalwa.basics.navigate(url);
				}
			});
		} else {
			yalwa.basics.navigate(url);
		}
	}

	function pwa_init() {
		var cookie_name = 'pwa';
		if (yalwa.basics.is_pwa() && window.navigator.cookieEnabled && !yalwa.basics.get_cookie(cookie_name)) {
			yalwa.basics.set_cookie(cookie_name, yalwa.v.is_ios ? 'ios' : 'android');
			if (yalwa.basics.get_cookie(cookie_name)) {
				yalwa.basics.reload();
				return;
			}
		}
		if (!yalwa.basics.is_pwa() && yalwa.basics.get_cookie(cookie_name)) {
			yalwa.basics.set_cookie(cookie_name, 0, -1);
			if (!yalwa.basics.get_cookie(cookie_name)) {
				yalwa.basics.reload();
				return;
			}
		}
		if (navigator.storage && navigator.storage.persist) {
			navigator.storage.persist();
		}
		if (yalwa.basics.is_pwa()) {
			jQuery('html').addClass('pwa');
		}
	}

	function pwa_promo_tracking_init() {
		if (jQuery('.js-pwa_promotion_burger').length > 0) {
			yalwa.basics.ga.event({
				category: 'pwa_promo',
				action: 'impression',
				label: yalwa.v.is_logged_in === undefined ? 'logged_out' : 'logged_in' + '_burger'
			});
		}
	}

	function pwa_promo_pageview_count() {
		if (yalwa.v.is_logged_in || yalwa.basics.is_pwa()) {
			return;
		}
		if (!yalwa.basics.ss_get('pwa_promo_pageview')) {
			yalwa.basics.ss_set('pwa_promo_pageview', 1);
		} else if (parseInt(yalwa.basics.ss_get('pwa_promo_pageview')) < 5) {
			let current_pageview_count = yalwa.basics.ss_get('pwa_promo_pageview');
			yalwa.basics.ss_set('pwa_promo_pageview', ++current_pageview_count);
		}
	}

	// triggered when page is restored from bfcache
	function on_pageshow(event) {
		if (yalwa.basics.is_back_forward_navigation(event.originalEvent)) {
			shopping_cart_reminder_bfcache_handler();
			premium.shopping_cart_bfcache_handler();
		}
	}

	function shopping_cart_reminder_bfcache_handler() {
		if (parseInt(yalwa.basics.ls_get('cart_count')) < 1) {
			jQuery('.js-reminder_visibility').remove();
		}
	}

	function reminder_visibility_handler() {
		jQuery('.js-reminder_visibility').velocity('fadeIn', {display: ''}).removeClass('invisible');
	}

	pub.force_repaint = function(element, options) {
		// force browser (safari!!!) to repaint visual changes.
		// We also noticed PWAs that the old versions of chrome use, also have the same problem probably. see #41021
		options = options || {};
		var force = options.force || false;
		var type = options.type || 2;
		if (!yalwa.v.is_ios && !force) {
			return;
		}
		switch (type) {
			case 1:
				// force repaint with width change
				jQuery(element).width(jQuery(element).width() + 1);
				window.setTimeout(function() {
					jQuery(element).width(jQuery(element).width() - 1);
				}, 800);
				break;
			case 2:
				// force repaint with max-width change
				var max_width = jQuery(element).css('max-width') || '';
				jQuery(element).css('max-width', jQuery(element).width());
				window.setTimeout(function() {
					jQuery(element).css('max-width', max_width);
				}, 400);
				break;
			case 3:
				window.setTimeout(function() {
					var clone = jQuery(element).clone();
					clone.insertAfter(jQuery(element));
					jQuery(element).remove();
				}, 400);
				break;
			default:
				// force repaint with hide/display change
				jQuery(element).hide();
				window.setTimeout(function() {
					jQuery(element).show();
				}, 400);
		}
	};

	pub.ltabs = (function(pub) {

		pub = pub || {};
		var class_chosen = 'ltabs__item--chosen';
		var class_item = 'js-ltabs_item';
		var class_container = 'js-ltabs';
		var class_track = 'js-ltabs_track';
		const settings = {
			full_width: false
		}

		pub.init = function() {
			setup();
			jQuery('.' + class_container).each(init_instance);
			jQuery('.' + class_item).on('click', item_click);
		};

		function setup() {
			switch(yalwa.basics.get_routing()) {
				case 'checkout_address':
					settings.full_width = true;
					break;
			}
		}

		function init_instance() {
			var $ltabs = jQuery(this);
			var hammertime = new Hammer($ltabs[0], {});
			hammertime.on('swipeleft swiperight', tab_swipe);
			get_track($ltabs).css({
				width: (100 / (get_tab_count($ltabs) * (settings.full_width ? 1 : 2))) + '%',
				transform: 'translateX(' + get_percent($ltabs) + '%)'
			});
		}

		function get_percent($ltabs) {
			var $items = $ltabs.find('.' + class_item);
			var $item_selected = $items.filter('.' + class_chosen);
			settings.percent = 50 + (200 * ($item_selected.index() - 1));
			if (settings.full_width) {
				settings.percent = 100 * ($item_selected.index() - 1);
			}
			return settings.percent;
		}

		function item_click() {
			var $this = jQuery(this);
			$this.siblings('.' + class_item).removeClass(class_chosen);
			$this.addClass(class_chosen);
			var $ltabs = get_container($this);
			move_percent($ltabs);
			$document.trigger($ltabs.data('event'), $this.data('value'));
		}

		function move_percent($ltabs) {
			get_track($ltabs).css({transform: 'translateX(' + get_percent($ltabs) + '%)'});
		}

		function get_tab_count($ltabs) {
			return $ltabs.find('.' + class_item).length;
		}

		function get_track($ltabs) {
			return $ltabs.find('.' + class_track);
		}

		function get_container(element) {
			return jQuery(element).closest('.' + class_container);
		}

		function get_selected($ltabs) {
			return $ltabs.find('.' + class_item).filter('.' + class_chosen);
		}

		function tab_swipe(e) {
			pub.move(get_container(e.target), e.type === 'swipeleft' ? 'right' : 'left');
		}

		pub.move = function($ltabs, direction) {
			var $item_selected = get_selected($ltabs);
			var $next = direction === 'left' ? $item_selected.prev() : $item_selected.next();
			if ($next.length) {
				$next.trigger('click');
			}
		};

		return pub;

	}(pub.ltabs));

	pub.htabs = (function(pub) {

		pub = pub || {};

		var $items;
		var $htabs;
		var $wrap;
		var $track;
		var $sections;
		var class_chosen = 'htabs__item--chosen';
		var max;
		var pan_delta = 0;
		var start = 0;
		var is_back = false;
		var is_init = false;
		var get_parameter_name = 'tab';
		var abort_check = null;
		let $default_selected_item = false;
		let recent_paning = false;
		let is_cats_in_ovw = false;
		let $before_selected = jQuery();
		const static_on_desktop_class = 'js-static_on_desktop';

		pub.init = function() {
			$htabs = jQuery('.js-htabs');
			is_cats_in_ovw = $htabs.hasClass('js-htabs_cats');
			reminder_visibility_handler();
			if (!$htabs.length) {
				return;
			}
			$items = jQuery('.js-htabs_item');
			$wrap = jQuery('.js-htabs_wrap');
			$track = jQuery('.js-htabs_track');
			$sections = jQuery('.js-htab_section');
			max = calc_max();
			$default_selected_item = get_selected();
			if ($htabs.data('get_parameter_name') !== undefined) { // "" means last path item is used
				get_parameter_name = $htabs.data('get_parameter_name');
			}
			$window.on('orientationchange', function() {
				$window.one('resize', function() {// #38391 https://stackoverflow.com/a/49383279/333864
					max = calc_max();
				});
			});

			if (!pub.is_active()) {
				return;
			}
			is_init = true;

			function htabs_panning_needed() {
				let total_width = 0;
				jQuery('.js-htabs_wrap').children().each(function () {
					total_width += jQuery(this).outerWidth(true); // includes margin
				});
				return jQuery('.js-htabs_wrap').width() < total_width;
			}
			$items.on('click', item_click);
			$items.on('keydown', yalwa.basics.keyhandler_for_space_and_enter);
			if (window.innerWidth <= 1080 && htabs_panning_needed()) {
				new Hammer($wrap[0], {}).on('panend', on_panend).on('panleft panright', on_pan);
			}
			should_show_scroll_buttons();
			jQuery(document).on('htabs_settings', change_tab);
			jQuery(document).on('htabs_dol', change_tab);
			jQuery(document).on('htabs_profile', change_tab);
			jQuery(document).on('htabs_search', htabs_search);
			jQuery(document).on('htabs_dol_hashtags', change_tab);
			jQuery(document).on('htabs_easy_lang', change_tab);
			if (history.state && history.state.sectionID_to) {
				var $to_select = get_by_id(history.state.sectionID_to);
				if ($to_select.length) {
					set_selected($to_select);
				}
			}
			if (pub.get()) {
				set_selected(get_by_id(pub.get()));
			}
			if (get_selected().length) {
				$document.trigger($htabs.data('event'), get_selected().data('sectionid'));
				check_pan_position(get_selected());
				move_track();
				if (yalwa.v.is_ios) {
					setTimeout(move_track, 400); // workaround for bug / race condition
				}
			}
			$window.on('resize', () => {
				yalwa.basics.debounce(resize_handler, 200);
			});
			jQuery('.js-htabs_wrap').removeClass('invisible'); // the track will move horizontally - avoid CLS
			yalwa.basics.state.register('htabs', function(a) {
				is_back = true;
				get_by_id(a.sectionID_from).trigger('click');
				is_back = false;
				return true;
			});
			$htabs.removeClass('htabs--init');
			is_init = false;
		};

		function resize_handler() {
			move_track();
			max = calc_max();
			check_pan_position(get_selected());
			static_elements_handler();
			should_show_scroll_buttons();
		}

		function enable_scroll_buttons() {

			const $wrap = jQuery('.js-htabs_wrap');
			const $left = jQuery('.js-htabs_scroll-left');
			const $right = jQuery('.js-htabs_scroll-right');

			const scrollWidth = $wrap[0].scrollWidth;
			const clientWidth = $wrap[0].clientWidth;

			// Only show scroll buttons if content overflows
			const is_scrollable = scrollWidth > clientWidth;

			$left.toggle(is_scrollable);
			$right.toggle(is_scrollable);

			$left.on('click', function () {
				$wrap.css('transform', `translateX(0px)`);
				yalwa.basics.hide($left);
				yalwa.basics.show($right);
			});

			$right.on('click', function () {
				const scroll_position = Math.min(0, clientWidth - scrollWidth);
				$wrap.css('transform', `translateX(${scroll_position}px)`);
				yalwa.basics.hide($right);
				yalwa.basics.show($left);
			});
		}

		function should_show_scroll_buttons() {
			let total_width = 180;
			jQuery('.js-htabs_wrap').children().each(function () {
				total_width += jQuery(this).outerWidth(true);
			});

			enable_scroll_buttons();
			if (jQuery('.js-htabs_wrap').width() < total_width) {
				yalwa.basics.show(jQuery('.js-htabs_scroll-left'));
				yalwa.basics.show(jQuery('.js-htabs_scroll-right'));
				if (get_translate_x(jQuery('.js-htabs_wrap')) === 0) {
					yalwa.basics.hide(jQuery('.js-htabs_scroll-left'));
				}
			} else {
				yalwa.basics.hide(jQuery('.js-htabs_scroll-left'));
				yalwa.basics.hide(jQuery('.js-htabs_scroll-right'));
			}
		}

		function get_translate_x($el) {
			const transform = $el.css('transform');

			if (!transform || transform === 'none') return 0;

			const match = transform.match(/matrix\([^,]+,[^,]+,[^,]+,[^,]+,([^,]+),/);
			return match ? parseFloat(match[1]) : 0;
		}

		pub.is_active = function() {
			return $htabs.length;
		};

		pub.next = function() {
			var $next = get_selected().next();
			if ($next.length) {
				$next.trigger('click');
			}
			yalwa.mobile.gestures.fake_next();
		};

		pub.prev = function() {
			var $prev = get_selected().prev();
			if ($prev.length) {
				$prev.trigger('click');
			}
			yalwa.mobile.gestures.fake_prev();
		};

		pub.get = function() {
			if (get_parameter_name === '') {
				const tmp = document.location.pathname.match(/\/([^\/]+)\/?$/);
				return tmp ? tmp[1] : null;
			} else {
				return yalwa.basics.get_get(get_parameter_name);
			}
		};

		pub.set = function(value) {
			if (value === undefined) {
				return;
			}
			if (get_parameter_name === '') {
				return window.history.replaceState(undefined, null, document.location.href.replace(new RegExp('\\/' + pub.get() + '\\/?'), '/' + value + '/'));
			} else {
				var obj = {};
				obj[get_parameter_name] = value;
				return yalwa.basics.set_get(obj);
			}
		};

		pub.current = function() {
			return get_selected().data('sectionid');
		};

		pub.swipe_next_possible = function() {
			if (!$htabs.length) {
				return false;
			}
			return get_selected().index() < $items.length;
		};

		pub.swipe_prev_possible = function() {
			if (!$htabs.length) {
				return false;
			}
			return get_selected().index() > 1;
		};

		function get_by_id(id) {
			return $items.filter('[data-sectionid="' + id + '"]');
		}

		function static_elements_handler() {
			let $htabs_static_elements_on_desktop = jQuery(`.${static_on_desktop_class}`);
			if (yalwa.basics.current_device_classification() === 'desktop') {
				$htabs_static_elements_on_desktop.removeClass('collapsed').css('opacity', 1);
			} else {
				$htabs_static_elements_on_desktop = $htabs_static_elements_on_desktop.not(`[data-htabs_sectionid="${get_selected().data('sectionid')}"]`);
				$htabs_static_elements_on_desktop.addClass('collapsed').css('opacity', 0);
			}
		}

		function htabs_search(e, sectionID) {
			if (!is_init) {
				const $e = jQuery('.js-htabs_item').filter('[data-sectionid="' + sectionID + '"]').eq(0);
				if ($e.length) {
					let url = $e.data('url');
					const area = yalwa.basics.get_get('area');
					const geoID = yalwa.basics.get_get('geoid');

					if (area && geoID) {
						url += `?area=${area}&geoid=${geoID}`;
					}
					track();
					yalwa.basics.ga.event({category: 'navigation_click', action: 'tab_' + sectionID});
					yalwa.basics.navigate(url);
				}
			}
		}

		pub.register_abort_check = function(callback) {
			abort_check = callback;
		};

		function change_tab(e, sectionID) {

			const hide_class = e.type === 'htabs_profile' ? 'collapsed' : 'hidden';
			const animation = {
				show : '',
				hide : ''
			};
			let $to_hide;
			let $to_show = $sections.filter(`[data-htabs_sectionid="${sectionID}"]`);
			switch(e.type) {
				case 'htabs_profile':
					$to_hide = $sections.not('.' + hide_class);
					if (yalwa.mobile.matches_breakpoint('desktop')) {
						$to_hide = $to_hide.not(`.${static_on_desktop_class}`);
						$to_show = $to_show.not(`.${static_on_desktop_class}`);
						if (is_init) {
							const $static_on_desktop = $sections.filter(`.${static_on_desktop_class}`);
							$static_on_desktop.removeClass('collapsed');
						}
					}
					break;
				default:
					$to_hide = $sections.not('.' + hide_class);
			}

			animation.show = $before_selected.index() > get_selected().index() ? 'slideRightIn' : 'slideLeftIn';
			animation.hide = $before_selected.index() > get_selected().index() ? 'slideLeftOut' : 'slideRightOut';

			$to_show.trigger('htabs_show_start');
			$to_show.each((index, element) => {
				const $element = jQuery(element);
				$element.velocity('transition.' + animation.show, {
					duration: determine_animation_duration($element),
					delay: $to_hide.length ? (determine_animation_duration($element) - 20) : 0,
					display: e.type === 'htabs_profile' ? 'grid' : null,
					begin: function() {
						switch(e.type) {
							case 'htabs_profile':
								$element.removeClass('collapsed');
								break;
							default:
								yalwa.basics.show($element);
						}
						yalwa.mobile.mainscroll_set(0);
						$element.trigger('htabs_show_done');
					}
				});
			})

			if ($to_hide.length) {
				$to_hide.trigger('htabs_hide_start');
				$to_hide.each((index, element) => {
					const $element = jQuery(element);
					$element.velocity('transition.' + animation.hide, {
						duration: determine_animation_duration($element),
						display: e.type === 'htabs_profile' ? 'grid' : null,
						begin: move_track,
						complete: function() {
							switch(e.type) {
								case 'htabs_profile':
									$element.addClass('collapsed');
									break;
								default:
									yalwa.basics.hide($element);

							}
							$element.trigger('htabs_hide_done');
						}
					});
				});

			}
			if (!is_back && !is_init && !$to_show.hasClass('js-no_url_changes')) {
				yalwa.basics.state.push({
					id: 'htabs',
					sectionID_from: $to_hide.data('htabs_sectionid'),
					sectionID_to: $to_show.data('htabs_sectionid')
				});
			}
		}

		function determine_animation_duration($element) {
			let duration = is_init ? 0 : 200;
			if ($element.data('htabs_animation_duration') !== undefined) {
				duration = $element.data('htabs_animation_duration');
			}
			return duration;
		}

		function move_track() {
			if (is_cats_in_ovw) {
				return; // not used here
			}
			var $item_selected = get_selected();
			if ($item_selected.outerWidth()) {
				$track.velocity({
					width: $item_selected.outerWidth(),
					translateX: $item_selected.position().left
				},
				{
					duration: is_init ? 0 : 200
				});
			}
		}
		pub.move_track = move_track;

		var bounce_width = 35;

		function on_pan(a) {
			if (ptr_active) {
				return;
			}
			recent_paning = true;
			htabs_active = true;
			var deltaX = a.deltaX * 1.3 + start;
			if (deltaX > bounce_width) {
				deltaX = bounce_width;
			}
			if (deltaX < bounce_width && deltaX > max - bounce_width) {
				var transform = 'translateX(' + (deltaX).toString() + 'px)';
				pan_delta = deltaX;
				window.requestAnimationFrame(function() {
					$wrap.css({'transform': transform});
				});
			}

		}

		function on_panend(e) {
			if (ptr_active) {
				return;
			}
			htabs_active = false;
			setTimeout(() => {
				recent_paning = false;
			}, 200);
			var going_left = e.additionalEvent === 'panleft';
			var smooth_factor = Math.abs(e.velocityX) * 200;
			var goal = going_left ? pan_delta - smooth_factor : pan_delta + smooth_factor;
			if (goal > 0) {
				goal = 0;
			}
			if (goal < max) {
				goal = max;
			}
			$wrap.velocity({translateX: [goal, pan_delta]}, {duration: 200, easing: 'easeOutQuart'});
			start = goal;
		}

		function calc_max() {
			let items_pixel = 0;
			const gap = parseInt($wrap.css('gap')) || 20;
			$items.each(function(i, e) {
				items_pixel += parseInt(jQuery(e).outerWidth(is_cats_in_ovw), 10);
				if (is_cats_in_ovw) {
					items_pixel += gap;
				}
			});

			if (is_cats_in_ovw) {
				items_pixel += gap;
				items_pixel += parseInt(jQuery('.js-all_categories').outerWidth(is_cats_in_ovw) || 0);
			}
			if ($wrap.width() > items_pixel) {
				return 0;
			}
			return $wrap.width() - items_pixel;
		}

		function item_click() {
			var $item = jQuery(this);
			if (abort_check && typeof (abort_check) === 'function') {
				if (abort_check($item.data('sectionid'))) {
					return false;
				}
			}
			if (is_cats_in_ovw && recent_paning) {
				return false;
			}
			if (set_selected($item, true) === false && !$item.closest('.js-htabs_cats').hasClass('htabs--cats')) {
				return;
			}
			check_pan_position($item);
			const $item_parent_htab = $item.closest('.js-htabs');
			const event = ($item_parent_htab && $item_parent_htab.length) ? $item_parent_htab.data('event') : $htabs.data('event');
			$document.trigger(event, $item.data('sectionid'));
		}

		function track() {
			const $item = get_by_id(yalwa.mobile.htabs.current());
			yalwa.basics.ga.event({
				category: 'htabs',
				action: 'actual_section_' + $default_selected_item.data('sectionid'),
				label: 'clicked_section_' + $item.data('sectionid'),
			});
			if ($item.data('sectionid') === 'dating') {
				yalwa.basics.ga.event({
					category: 'dating_promo',
					action: 'header tab'
				});
			}
		}

		function check_fade_effect($element) {
			const $container = jQuery('.js-htabs_cats');
			if (!$container.length) {
				return;
			}

			const parent_padding_left = parseInt($container.css('padding-left')) || 0;
			const parent_padding_right = parseInt($container.css('padding-right')) || 0;
			$element.css('width', 'auto');
			const boundaries = $element[0].getBoundingClientRect();
			$element[0].style.removeProperty("width");

			const detection = {
				left: boundaries.left < parent_padding_left,
				right: boundaries.right + parent_padding_right > window.innerWidth,
				boundaries: boundaries
			};
			["left", "right"].forEach( side => {
				yalwa.basics.bem_modifier($container, `fade_${side}`, detection[side] ? "add" : "remove");
			});
		}

		function check_pan_position($item) {
			if (!$item || !$item.length) {
				return;
			}
			const tmp = ($window.width() - $main_col.width()) / 2; // when screen is bigger than max_width
			let offset_left;
			offset_left = $item.offset().left - tmp - 10;
			var l = (offset_left - ($item.outerWidth() / 3)) * -1;
			var tra = Math.min(0, Math.max(l + pan_delta, max));
			if ($item.index() === $items.length) {
				tra = max;
			}


			const $container = $wrap;

			// Calculate item's left/right inside container
			const container_left = $container.offset().left;
			const container_right = container_left + $container.outerWidth();

			const item_left = $item.offset().left;
			const item_right = item_left + $item.outerWidth();

			const is_fully_visible =
				item_left >= container_left && item_right <= container_right;

			const is_on_right_side = item_right > 1000;

			// reset on desktop
			if (window.matchMedia('(min-width: 1400px)').matches) {
				tra = 0;
			}

			if (is_on_right_side) {
				setTimeout(function() {
					jQuery('.js-htabs_scroll-right').trigger('click');
				}, 5);
			}

			if (is_fully_visible) {
				tra = 0
			}

			pan_delta = tra;
			const duration = is_init ? 0 : 200;
			$wrap.css({transition: 'transform ' + duration + 'ms'}).css({'transform': 'translateX(' + tra + 'px)'});
			setTimeout(function() {
				$wrap.css({transition: 'none'});
				check_fade_effect($wrap);
			}, duration + 50);
			start = pan_delta;
		}

		function set_selected($new_selected, from_click) {
			if (!$new_selected.length) {
				return false;
			}
			const active_tab_class = $new_selected.closest('.js-htabs').data('active-tab-class');
			class_chosen = (active_tab_class) ? active_tab_class : class_chosen;
			if (class_chosen !== 'htabs__item--chosen') {
				$new_selected.closest('.js-htabs').find('.js-htabs_item').removeClass('htabs__item--chosen');
			}
			if ($new_selected.hasClass(class_chosen)) {
				if (from_click && $htabs.hasClass('js-reload_on_selected')) {
					yalwa.basics.reload();
				}
				if (from_click && $htabs.hasClass('js-fire_on_selected')) {
					return true;
				}
				return false;
			}
			const before = pub.get();
			const $old_selected = jQuery(`.${class_chosen}`);
			$before_selected = $old_selected;
			$items.removeClass(class_chosen);
			$new_selected.addClass(class_chosen);
			$window.on('pageshow', event => {
				if (event.originalEvent.persisted) {
					if (yalwa.basics.get_routing() !== 'accessibility_easy_lang_page') {
						$old_selected.addClass(class_chosen);
						$new_selected.removeClass(class_chosen);
					}
				}
			});
			var sid = $new_selected.data('sectionid');
			if (['settings', 'public_profile', 'dol'].indexOf(yalwa.basics.get_routing()) !== -1) {
				if (!$new_selected.hasClass('js-no_url_changes')) {
					pub.set(sid);
					if (before !== sid && $sections.filter('[data-htabs_sectionid="' + sid + '"]').hasClass('js-htab_section_reload')) {
						yalwa.basics.reload();
					}
				}
			}
			return $new_selected;
		}

		function get_selected() {
			return $items && $items.length ? $items.filter('.' + class_chosen) : jQuery([]);
		}

		return pub;

	}(pub.htabs));

	const init_reveal_password = () => {
		if (yalwa.basics.is_safari()) {
			jQuery('html').addClass('safari');
		}
		jQuery('body').on('touchend click', '.js-reveal_password', function(e) {
			const $icon = jQuery(this).children('.yicon');
			yalwa.basics.yicon_toggle($icon, 'eye-crossed-out', 'eye');
			$icon.toggleClass('eye-crossed-out eye');
			if ($icon.hasClass('eye-crossed-out')) {
				$icon.attr('alt', $icon.data('show_alt_text'));
			} else {
				$icon.attr('alt', $icon.data('hide_alt_text'));
			}
			yalwa.mobile.force_repaint($icon);

			const $input = jQuery(this).closest('label').find('input:visible');
			const type = yalwa.v.is_ios ? $input.attr('type') : $input.prop('type');
			const new_type = type === 'text' ? 'password' : 'text';
			$input.prop('type', new_type).attr('type', new_type);// .attr needed for iOS

			e.preventDefault();
			e.stopPropagation(); // so the keyboard doesn't reveal
		});
	};
	const load_pa_plan_overlay = (tp = '') => {
		yalwa.mobile.burger.menu_hide(false, false);
		yalwa.basics.load_css(yalwa.basics.static_url('css') + 'mobile/sites/info/pa.css');
		jQuery('html').addClass('js-no_scroll');
		if (jQuery('.js-dialog_paplan').length) {
			yalwa.basics.show(jQuery('.js-dialog_paplan'));
		} else {
			yalwa.basics.load_template_once('load_pa_plan_overlay',jQuery('.js-dialog_paplan'),'' , {tp : tp}).then((rs) => {
				yalwa.basics.load_js(yalwa.basics.static_url('js') + 'shared/account_upgrade.js', () => {
					if (tp == 'paf_website_phone_paf' && (yalwa.basics.get_routing() == 'paf' || yalwa.basics.get_routing() == 'PAF_create_new')) {
						// we do not want to redirect in the PAF case, just closing the dialog. 
						// Because at a later point in the PAF, the cart is displayed anyway (after adding other Posting related PFs)
						yalwa.pa.redirect_to_shopping_cart = false;
					}
				}, 'module');
				setTimeout(() => {
					jQuery('.js-dialog_paplan_position').addClass('js-active');
				}, 50);
			});
		}
	}
	pub.load_pa_plan_overlay = load_pa_plan_overlay;
	pub.init_pa_overlay_tp = () => {
		jQuery('.js-show_pa_overlay').off('click').on('click', (e) => {
			load_pa_plan_overlay('instant_notification');
			return false;
		});
	}

	pub.init_followers_popup = (keep_shadow) => {
		keep_shadow = keep_shadow || false;
		if (jQuery('.js-pa_followers_not_premium').length) {
			jQuery('.js-pa_followers_not_premium').off('click').on('click', function(event) {
				let $e = jQuery(this);
				if (yalwa.v.is_pa_rework_testing_active) {
					let touchpointID;
					if ($e.closest('.js-burger_menu').length) {
						touchpointID = yalwa.basics.PREMIUM_TOUCHPOINT.MY_PA_FOLLOWERS_DROPDOWN;
					} else if($e.closest('.js-list_menumy').length) {
						touchpointID = yalwa.basics.PREMIUM_TOUCHPOINT.MY_PA_FOLLOWERS_MENU;
					} else if($e.closest('.js-list_myfollowers').length) {
						touchpointID = yalwa.basics.PREMIUM_TOUCHPOINT.MY_PA_FOLLOWERS_START;
					}
					jQuery('.js-pf_touchpoint_parent').filter(function () {
						const val = jQuery(this).data('touchpoint');
						return val === 19 || val === 20 || val === 21;
					}).attr('data-touchpoint', touchpointID);
					load_pa_plan_overlay(touchpointID);
					return false;
				} else {
					if (window.innerWidth >= 1024) {
						event.preventDefault();
						let href = jQuery(this).prop('href');
						if (!href) {
							href = jQuery(this).find('a').prop('href');
						}
						if (href) {
							window.open(href, '_blank');
						}
					}
				}
			});
			jQuery('.js-user_info_header_overlay').off('click').on('click', function(event) {
				event.preventDefault();
				pub.load_pa_plan_overlay('user_info_header');
			});
		}
		if (jQuery('.js-pa_see_followers_mfd').length) {
			jQuery('.js-mfd_pa_see_followers').off('click').on('click', function(event) {
				const $e = jQuery(this);
				let touchpointID;
				if ($e.closest('.js-burger_menu').length) {
					touchpointID = yalwa.basics.PREMIUM_TOUCHPOINT.MY_PA_FOLLOWERS_DROPDOWN;
				} else if($e.closest('.js-list_menumy').length) {
					touchpointID = yalwa.basics.PREMIUM_TOUCHPOINT.MY_PA_FOLLOWERS_MENU;
				} else if($e.closest('.js-list_myfollowers').length) {
					touchpointID = yalwa.basics.PREMIUM_TOUCHPOINT.MY_PA_FOLLOWERS_START;
				}
				jQuery('.js-pf_touchpoint_parent').filter(function () {
					const val = jQuery(this).data('touchpoint');
					return val === 19 || val === 20 || val === 21;
				}).attr('data-touchpoint', touchpointID);
				yalwa.mobile.burger.menu_hide(false, keep_shadow);
				if (yalwa.v.is_pa_rework_testing_active) {
					load_pa_plan_overlay(touchpointID);
				} else {
					yalwa.mobile.mfd({html: jQuery('.js-pa_see_followers_mfd').first().html()});
				}
				event.preventDefault();
				event.stopPropagation();
				return false;
			});
		} else {
			jQuery('.js-mfd_pa_see_followers_tab').on('click', function(event) {
				yalwa.basics.ss_set('see_followers_tab', true);
			});
		}
	};

	function init_default_form_elements() {
		jQuery('.unified_input--floating_ph').each(function() {
			let $this = jQuery(this);
			let ph = $this.data('placeholder') || $this.attr('placeholder');

			if (ph) {
				$this.after('<label class="unified_input_placeholder" for="' + $this.attr('id') + '">' + ph + '</label>');
			}
		});

		yalwa.mobile.ltabs.init();

		select_followers_tab();

		jQuery('.js-validate_user_or_email').on('enterdown blur', function() {
			if (jQuery(this).val().search('@') === -1) {
				jQuery(this).prop('type', 'text');
			} else {
				jQuery(this).prop('type', 'email');
			}
		});

		jQuery('.unified_input--error').on('input', function() {
			jQuery(this).removeClass('unified_input--error');
		});
		jQuery('.js-spacebar_click').on('keypress', function(e) {
			if (e.keyCode === 32) { //spacebar
				jQuery(this).trigger('click');
				e.preventDefault();
			}
		});
	}

	pub.top_ad_upselling_promo = (function(pub) {

		pub = pub || {};

		pub.init = function() {
			const timer_element = jQuery('.js-top_ad_upselling_timer');
			if (!timer_element.length) return;

			const end_time = yalwa.v.top_ad_upselling_offer_ts * 1000; // Convert to milliseconds
			const original_format = timer_element.html().trim();

			const update_timer = () => {
				const now = Date.now();
				const remaining_ms = end_time - now;

				if (remaining_ms <= 0) {
					jQuery('.js-upselling_info').remove();
					return;
				}

				// Calculate minutes and seconds
				const total_seconds = Math.floor(remaining_ms / 1000);
				const minutes = Math.floor(total_seconds / 60);
				const seconds = total_seconds % 60;

				// Replace placeholders with actual values
				const formatted_time = original_format
					.replace('%1$sm', "<strong>" + minutes + "m</strong>")
					.replace('%2$ss', "<strong>" + seconds + "s</strong>");

				timer_element.html(formatted_time);
				setTimeout(update_timer, 1000);

			}
			update_timer();
			setTimeout(update_timer, 1000);
			jQuery('.js-upselling_info').on('click', () => {
				pub.add_pole_position_to_checkout();
			});
		}

		pub.track_datalayer_event = function(name) {
			yalwa.basics.ga.datalayer({
				event: 'pole_position_upsell',
				pole_position_upsell: name
			});
		}

		pub.load_headroom_promo = function() {
			if (yalwa.v.top_ad_upselling_offer_ts) {
				jQuery.get(
					'/api/ajax/general',
					{
						action:'load_top_ad_upselling_html',
						template:'headroom'
					},
					function (response) {
						jQuery('.js-headroom_infobanners').html(response.html);
						yalwa.mobile.top_ad_upselling_promo.init();
					},
					'json'
				);
			}
		}

		pub.add_pole_position_to_checkout = function(already_tracked = false) {
			if (!already_tracked) {
				if (yalwa.basics.get_routing() == 'premium_confirm') {
					yalwa.mobile.top_ad_upselling_promo.track_datalayer_event('offer_banner_click');
				} else {
					yalwa.mobile.top_ad_upselling_promo.track_datalayer_event('top_of_page_toastr_click');
				}
			}
			jQuery.post(
				'/api/ajax/general',
				{
					action: 'topad_upselling_offer_checkout'
				},
				function(response) {
					if (response.success) {
						yalwa.basics.navigate(response.checkout_url);
					}
				},
				'json'
			);
		}

		return pub;

	}(pub.generic_shadow));




	function init_mobile_buttons_tracking() {
		const name_map = {
			'.js-history_back_tracking': 'head_back',
			'.js-headroom_login_button': 'head_login',
			'.js-logo_link': 'head_logo',
			'.js-country_flag': 'head_flag',
			'.js-b_geolocate': 'head_locate',
			'.js-ofc_home': 'ofc_home',
			'.js-ofc_fav': 'ofc_fav',
			'.js-ofc_post': 'ofc_post',
			'.js-ofc_mc': 'ofc_mc',
			'.js-ofc_mylocantostart': 'ofc_mylocantostart',
			'.js-start_mc': 'mylocantostart_mc',
			'.js-start_fav': 'mylocantostart_fav',
			'.js-ybtb_button_inbox': 'bottombar_mc',
			'.js-ybtb_post': 'bottombar_post',
			'.js-ytbt_home': 'bottombar_home',
			'.js-ytbt_back': 'bottombar_back',
			'.js-ytbt_ads': 'bottombar_ads',
			'.js-burger_menu_open': 'bottom_bar_burger_new',
			'.js-vap_next': 'vap_next',
			'.js-refine_search': 'vap_search'
		};
		const timeouts = {};
		jQuery.each(name_map, function(selector, name_dynamic) {
			jQuery(selector).on('click.tracking', function() {
				if (timeouts[selector]) {
					return;
				}
				timeouts[selector] = true;
				setTimeout(function() {
					timeouts[selector] = false;
				}, 1000);
				yalwa.basics.ga.event({category: 'navigation_click', action: name_dynamic});
			});
		});
	}

	function pagination_init() {
		jQuery('.js-pagination_left').on('click', pagination_prev);
		jQuery('.js-pagination_right').on('click', pagination_next);
		jQuery('.js-pagination_select').on('change', change_page);
	}

	function change_page() {
		var data = {};
		data[jQuery('.pagination').data('keyword') || 'p'] = jQuery(this).val();
		yalwa.basics.set_get(data, true, true);
	}

	function pagination_prev() {
		var data = {};
		data[jQuery('.pagination').data('keyword') || 'p'] = parseInt(jQuery('.js-pagination_select').val()) - 1;
		yalwa.basics.set_get(data, true, true);
	}

	function pagination_next() {
		var data = {};
		data[jQuery('.pagination').data('keyword') || 'p'] = parseInt(jQuery('.js-pagination_select').val()) + 1;
		yalwa.basics.set_get(data, true, true);
	}

	pub.check_for_detach = function() {
		jQuery('.js-detach_body').each(detach_body);
	};

	function detach_body() {
		var $this = jQuery(this);
		if ($this.data('detach_to')) {
			$this.detach().removeClass('js-detach_body').appendTo(jQuery($this.data('detach_to')));
		} else {
			$this.detach().removeClass('js-detach_body').appendTo(jQuery('body'));
		}
	}

	function init_terms_plp() {
		jQuery('.js-term_of_use_btn a').on('click', function(e) {
			const $this = jQuery(this);
			e.stopPropagation();
			e.preventDefault();
			if (yalwa.v.is_phonegap) {
				yalwa.basics.opensecondwebview($this.attr('href'));
			} else {
				jQuery('.js-term_of_use_frame').attr('src', $this.attr('href') + '?embedded=1');
				jQuery('.js-term_of_use_plp .plp__title').html($this.text()); // read the text of the link and assign it to the title
				jQuery('.js-term_of_use_plp').trigger('plp_show');
			}
		});
	}

	function embedded_page_link_handler() {
		jQuery('a').each(function() {
			var href = jQuery(this).attr('href');
			if (!href) {
				return;
			}
			if (href.indexOf('#') === 0) {
				return;
			}

			jQuery(this).attr('target', '_blank');
		});
	}

	function jump_location_input(event) {
		var $location_input = jQuery('.js-places_suggest');
		// Jump in the app to the top (there we have no citylist)
		if ($location_input.length !== 0 && yalwa.v.is_phonegap) {
			$location_input.focus().scrollTop(0);
			event.preventDefault();
			return true;
		}
	}

	let plp_params = {};
	let plp_queue = [];

	function plp_init() { // plp = page load popup
		$body.on('plp_show', '.js-plp', function(event, params = {}) {
			plp_params = params;
			var $this = jQuery(this);
			if (params.is_queued && (yalwa.mobile.generic_shadow.showing() || yalwa.mobile.generic_shadow.show_in_progress || yalwa.mobile.generic_shadow.hide_in_progress)) {
				if (!plp_queue.length || (plp_queue.length && jQuery(this).prop('class') !== plp_queue[0].prop('class'))) {
					plp_queue.push(jQuery(this));
				}
				return;
			}
			if (!$this.hasClass('plp--static')) {
				yalwa.basics.show(jQuery('.js-plp_container'));
				jQuery('.js-plp_container').off('click.default');
				if ($this.hasClass('js-plp_hide_shadowclick') || ($this.find('.js-plp_ok').length && !$this.hasClass('js-plp_no_autohide') && !$this.find('.js-plp_confirm').length)) {
					jQuery('.js-plp_container').on('click.default', function() {
						$this.trigger('plp_hide', [{is_queued: params.is_queued}]);
					});
				}
				yalwa.mobile.generic_shadow[(params.is_queued ? 'show_queued' : 'show')]({
					onclick: function() {
						if (($this.find('.js-plp_close').length || $this.find('.js-plp_ok').length) && !$this.hasClass('js-no_outer_click_hide')) {
							$this.trigger('plp_hide', [{is_queued: params.is_queued}]);
						} else {
							jQuery('.js-generic_shadow').off();
						}
					}
				});
			}

			yalwa.basics.show($this);
			yalwa.basics.overlay.register('plp');
			if (yalwa.v.is_ios) {
				document.querySelectorAll('.js-plp_container').forEach(function(el) {
					el.addEventListener('touchmove', ios_prevent_background_scrolling, { passive: false });
				});
			}
		});
		$body.on('plp_hide', '.js-plp', function(event, params = {}) {
			plp_params = !jQuery.isEmptyObject(params) ? params : plp_params;
			var $this = jQuery(this);
			if (!$this.hasClass('plp--static')) {
				if (jQuery('.plp__close--on_top').length) {
					yalwa.basics.hide(jQuery('.plp__close--on_top'));
				}
				yalwa.basics.hide(jQuery('.js-plp_container'));
				yalwa.mobile.generic_shadow[(params.is_queued ? 'hide_queued' : 'hide')](true);
			}
			yalwa.basics.overlay.unregister('plp');
			yalwa.basics.hide($this);
			$this.trigger('plp_hidden');
		});
		jQuery('.js-plp').not('.js-plp_wait').each(function() {
			jQuery(this).trigger('plp_show', plp_params);
		});
		$body.on('click', '.js-plp_ok,.js-plp_close', function() {
			var $this = jQuery(this);
			var $plp_to_close;
			if ($this.closest('.js-plp').length) {
				$plp_to_close = $this.closest('.js-plp');
			} else {
				$plp_to_close = $this.parent().find('.js-plp');
			}
			$plp_to_close.trigger('plp_hide', plp_params);
			if ($this.hasClass('js-plp_ok')) {
				$plp_to_close.trigger('plp_ok');
			}
		});
		$body.on('click', '.js-plp_confirm', function() {
			var $tmp = jQuery(this).closest('.js-plp');
			if ($tmp[0] && $tmp[0].fn_validate && !$tmp[0].fn_validate()) {
				return;
			}
			$tmp.trigger('plp_confirm');
			if (!$tmp.hasClass('js-plp_no_autohide')) {
				$tmp.trigger('plp_hide', plp_params);
			}
		});
		$body.on('keydown', '.js-plp_confirm, .js-plp_ok, .js-plp_close', function(e) {
			if (yalwa.basics.is_space_bar_or_enter_pressed(e)) {
				jQuery(this).trigger('click');
			}
		});
	}

	function init_last_ads_session() {
		if (get_routing() === 'mc') {
			return;
		}
		var container = jQuery('.js-last_visited_session');
		if (container.length) {
			var max = 10;
			var last_visited_ads = yalwa.basics.ss_get('last_visited_ads', true) || [];
			var html = '';
			if (last_visited_ads) {
				for (var i in last_visited_ads) {
					if (last_visited_ads.hasOwnProperty(i)) {
						html = last_visited_ads[i].html_new + html;
					}
				}
			}
			if (html) {
				// Use parseHTMLUnsafe so declarative Shadow DOM in web components is parsed.
				// jQuery's append() uses innerHTML internally, which skips DSD parsing.
				if (typeof Document.parseHTMLUnsafe === 'function') {
					var parsed_doc = Document.parseHTMLUnsafe(html);
					var target = container.find('.js-last_visited_session_items')[0];
					if (target) {
						while (parsed_doc.body.firstChild) {
							target.appendChild(parsed_doc.body.firstChild);
						}
					}
				} else {
					container.find('.js-last_visited_session_items').append(html);
				}
				yalwa.basics.show(container);
				attach_goto_ad_handler();
			}
			if (yalwa.v.last_ad) {
				for (var j in last_visited_ads) {
					if (last_visited_ads.hasOwnProperty(j) && yalwa.v.last_ad.msgID === last_visited_ads[j].msgID) {
						last_visited_ads.splice(j, 1);
					}
				}
				last_visited_ads.push(yalwa.v.last_ad);
				if (last_visited_ads.length > max) {
					last_visited_ads.splice(0, last_visited_ads.length - max);
				}
				yalwa.basics.ss_set('last_visited_ads', last_visited_ads);
				const last_visited_msgIDs = last_visited_ads.map(item => item.msgID);
				yalwa.basics.set_cookie(yalwa.basics.get_cookie_name_final('lva'), btoa(JSON.stringify(last_visited_msgIDs)));
				const vap_call_button_handler = new MoleculeGroupPhonecall('molecule_phonecall');
				vap_call_button_handler.init();
			}
			jQuery('.js-ah_clear').on('click', reset_last_visited_ads);
		}
	}

	pub.show_announcement = function(text) {
		if (yalwa.basics.ss_get('hide_announcement')) {
			return;
		}
		var $announcement = jQuery('<div class="announcement js-announcement" />')
		$announcement.html(
			yalwa.basics.yicon('warning', {pixel: 24, classes: 'announcement__warning'})
			+ '<span>' + text + '</span>'
			+ yalwa.basics.yicon('close', {
				pixel: 10,
				classes: 'announcement__close js-announcement_close'
			})
		);
		$announcement.prependTo($main_col);
		jQuery('.js-announcement_close').on('click', function() {
			yalwa.basics.ss_set('hide_announcement', true);
			jQuery('.js-announcement').remove();
		});
	};

	pub.generic_shadow = (function(pub) {

		pub = pub || {};

		var defaults = {
			'background': 'var(--backdrop)',
			'zindex': '10',
			'onclick': function() {
				$document.trigger('generic_shadow_hide');
			},
			'callback': null
		};
		var $gs = null;
		var show_in_progress = false;
		var hide_in_progress = false;
		pub.show_in_progress = false;
		pub.hide_in_progress = false;

		pub.init = function() {
			$gs = jQuery('.js-generic_shadow');
			jQuery.Velocity.hook($gs, 'translateX', '-50%');
		};

		pub.showing = () => {
			return show_in_progress || $gs && $gs.is(':visible');
		};

		pub.queue = [];

		pub.queue_check = function() {
			if (plp_queue.length > 0) {
				let $queued_plp = plp_queue.shift();
				$queued_plp.trigger('plp_show', plp_params);
			}
		};

		pub.show_queued = function(overwrites) {
			pub.show_in_progress = true;
			show_in_progress = true;
			if (!$gs) {
				pub.init();
			}
			var options = jQuery.extend(defaults, overwrites);
			$gs.off('click').css({'z-index': options.zindex, 'background': options.background});
			$gs.off('touchmove');
			if (options.onclick) {
				$gs.on('click' + (options.namespace ? ('.' + options.namespace) : ''), options.onclick);
			}

			var velocity_options = {
				duration: typeof (options.duration) === 'undefined' ? 150 : options.duration
			};

			velocity_options.complete = function() {
				yalwa.mobile.generic_shadow.show_in_progress = false;
				show_in_progress = false;
				yalwa.mobile.generic_shadow.queue_check();
				if (options.callback) {
					options.callback();
				}
			};

			if ($gs.hasClass('hidden')) {
				yalwa.basics.show($gs).velocity('fadeIn', velocity_options);
				$document.trigger('generic_shadow_showing');
			} else {
				yalwa.basics.show($gs).velocity('finish', velocity_options);
				yalwa.mobile.generic_shadow.show_in_progress = false;
				show_in_progress = false;
				yalwa.mobile.generic_shadow.queue_check();
				if (options.callback) {
					options.callback();
				}
			}

			if (yalwa.v.is_ios) {
				document.querySelectorAll('.js-generic_shadow').forEach(function(el) {
					el.addEventListener('touchmove', ios_prevent_background_scrolling, { passive: false });
				});
			}
		};

		pub.hide_queued = function(no_animation) {
			pub.hide_in_progress = true;
			hide_in_progress = true;
			var deferred = jQuery.Deferred();
			$gs.velocity('fadeOut', {
				duration: no_animation === true ? 0 : 150,
				complete: function() {
					yalwa.basics.hide($gs);
					pub.hide_in_progress = false;
					hide_in_progress = false;
					pub.remove_events();
					yalwa.mobile.generic_shadow.queue_check();
					deferred.resolve();
				}
			});
			return deferred;
		};

		pub.show = function(overwrites) {
			// please do not use it anymore instead this please use queued version
			show_in_progress = true;

			if (!$gs) {
				pub.init();
			}
			var options = jQuery.extend(defaults, overwrites);
			$gs.off('click').css({'z-index': options.zindex, 'background': options.background});
			$gs.off('touchmove');
			if (options.onclick) {
				$gs.on('click' + (options.namespace ? ('.' + options.namespace) : ''), options.onclick);
			}

			var velocity_options = {
				duration: typeof (options.duration) === 'undefined' ? 150 : options.duration
			};

			velocity_options.complete = function() {
				show_in_progress = false;
				if (options.callback) {
					return velocity_options.complete = options.callback;
				}
			};

			if ($gs.hasClass('hidden')) {
				yalwa.basics.show($gs).velocity('fadeIn', velocity_options);
				$document.trigger('generic_shadow_showing');
			}
			if (yalwa.v.is_ios) {
				document.querySelectorAll('.js-generic_shadow').forEach(function(el) {
					el.addEventListener('touchmove', ios_prevent_background_scrolling, { passive: false });
				});
			}
			yalwa.basics.bem_modifier($body, 'gs_showing', 'add');
		};

		pub.hide = function(no_animation) {
			// please do not use it anymore instead this please use queued version
			hide_in_progress = true;
			var deferred = jQuery.Deferred();
			let on_complete = function() {
				yalwa.basics.hide($gs);
				hide_in_progress = false;
				pub.remove_events();
				deferred.resolve();
			};
			if (no_animation) {
				on_complete();
			}
			$gs.velocity('fadeOut', {
				duration: no_animation === true ? 0 : 150,
				complete: no_animation ? null : on_complete
			});
			yalwa.basics.bem_modifier($body, 'gs_showing', 'remove');
			return deferred;
		};

		pub.remove_events = function() {
			$gs.off();
		};

		return pub;

	}(pub.generic_shadow));

	pub.stop_invisible_start = function() {
		if (window.invisible_timeout) {
			clearTimeout(window.invisible_timeout);
		}
		if ($body && $body.length && $body.hasClass('mbody--invisible')) {
			setTimeout(() => {
				$body.removeClass('mbody--invisible');
			}, 200); // reduce FOUC
		}
	};

	pub.vibrate = function(intervals) {
		navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
		if (navigator.vibrate) {
			navigator.vibrate(intervals);
		}
	};

	pub.request_mc_counter_update = function() {
		if (!yalwa.mobile.is_mdot_domain()) {
			return;
		}
		jQuery.ajax({
			url: '/api/ajax/get_inbox',
			dataType: 'json'
		}).done(function(response) {
			pub.update_mc_counter(response.unread);
		});
	};

	pub.get_mc_count = function() {
		return jQuery('.js-ybtb_button_inbox').data('menu_count') || jQuery('.js-context').filter('[data-context="inbox"]').data('menu_count') || 0;
	};

	pub.update_mc_counter = function(new_value) {
		if (yalwa.v.is_phonegap) {
			yalwa.mobile.cordova.cordova_send({action: 'mc_count', params: {value: new_value}});
		}
		if (!yalwa.chat) {
			new_value = parseInt(new_value, 10) || 0;
			var button = jQuery('.js-ybtb_button_inbox');
			button.attr('data-menu_count', new_value).data('unread', new_value);
			if (new_value > 0) {
				button.removeClass('menu_counter').addClass('menu_counter menu_counter_update');
			} else {
				button.removeClass('menu_counter');
			}
			window.setTimeout(function() {
				jQuery('.menu_counter_update').removeClass('menu_counter_update');
			}, 350);
		}
	};

	pub.b64toBlob = function(b64Data, contentType, sliceSize) { // still used? app pre 2.4.0?
		return yalwa.basics.b64_to_blob(b64Data, contentType, sliceSize);
	};

	pub.app_progress = function($container) {
		const speed = random_int(80, 500);
		let $headroom = jQuery('.headroom');
		yalwa.basics.progress.start('', {
			container: $container || (!$headroom || !$headroom.length || $headroom.hasClass('headroom--unpinned') ? jQuery('body') : $headroom),
			trickleRate: random_int(15, 30) / 100,
			trickleSpeed: speed,
			speed: speed,
			minimum: random_int(10, 30) / 100
		});
	};

	pub.ocm_counter_toggle = function(ocm, new_value) {
		var current_value = parseInt(ocm.attr('data-ocm_counter'), 10);
		if (new_value === '--') {
			new_value = current_value - 1;
		} else if (new_value === '++') {
			new_value = current_value + 1;
		}
		ocm.attr('data-ocm_counter', new_value).data('ocm_counter', new_value);
		var ocm_class = 'ocm-counter';
		if (new_value > 0) {
			ocm.removeClass(ocm_class).addClass(ocm_class);
		} else {
			ocm.removeClass(ocm_class);
		}
	};

	// email alerts
	let abo_action_push;
	pub.email_alerts_init = function() {
		remove_dot_from_alert_button();
		show_tippy_once();
		let event = 'ontouchstart' in document.documentElement && yalwa.v.is_ios ? 'touchend' : 'click';
		jQuery('.js-email_alert_dialog').off(event).on(event, function(e) {
			if (!yalwa.basics.readonly_check()) {
				return false;
			}
			if (!yalwa.basics.is_logged_in()) {
				yalwa.mobile.auth
					.register_success_handler(abo_login_success_handler)
					.show_dialog(e);
				return;
			}
			load_alert_add({
				is_search: jQuery('.js-snh_search').val() ? 1 : 0,
				query: jQuery.trim(jQuery('.js-app_title').text())
			}).done(function() {
				jQuery('.js-abo_save').off(event).on(event, abo_save);
				email_alert_show();
				remove_dot_from_alert_button();
				yalwa.basics.state.register('email_alert_add', function() {
					if (!jQuery('.js-snh_abo_new').hasClass('hidden')) {
						email_alert_hide();
						return true;
					}
				});
				if (yalwa.v.is_ios) {
					document.querySelectorAll('.js-snh_abo_new').forEach(function(el) {
						el.addEventListener('touchmove', ios_prevent_background_scrolling, { passive: false });
					});
				}
				yalwa.mobile.init_pa_overlay_tp();
			});
		});
		if (yalwa.basics.ls_get('trigger_abo_after_login')) {
			trigger_abo_after_login();
		}
	};
	function remove_dot_from_alert_button() {
		// if alert window already showed, remove the dot and don't show tippy
		if (yalwa.basics.get_cookie('alert_window_showed')) {
			jQuery('.js-email_alert_dialog')
			.removeClass('result_meta__dot')
			.removeAttr('data-tippy')
			.each((_, el) => { if (el._tippy) el._tippy.destroy(); });
		} else {
			$('.js-email_alert_show_dot').addClass('result_meta__dot');
		}
	}
	function show_tippy_once() {
		// show tippy only once
		if (!yalwa.basics.get_cookie('alert_tippy_showed')) {
			// show automatically after 800ms
			const open_timeout = 800;
			// hide after 7s
			const close_timeout = 7000;
			setTimeout(() => {
				jQuery('.js-email_alert_dialog').each((_, el) => {
					if (el._tippy) {
						el._tippy.show();
						// hide after 7s
						setTimeout(() => {
							el._tippy.hide();
						}, close_timeout);
					}
				});
			}, open_timeout);
			yalwa.basics.set_cookie('alert_tippy_showed', 1);
		}
	}
	function abo_login_success_handler() {
		yalwa.basics.ls_set('trigger_abo_after_login', true);
		yalwa.basics.reload();
	}
	function trigger_abo_after_login() {
		if (yalwa.mobile.generic_shadow.showing()) {
			yalwa.basics.ls_remove('trigger_abo_after_login');
			return;
		}
		if(yalwa.basics.is_logged_in()) {
			jQuery('.js-email_alert_dialog').trigger('click');
		}
		yalwa.basics.ls_remove('trigger_abo_after_login');
	}

	function ios_prevent_background_scrolling(e) {
		if (window.matchMedia('(max-height: 600px)').matches && jQuery(e.target).hasClass('plp__text')) {
			return; // https://trac.yalwa.net/ticket/42534#comment:37
		}
		if (jQuery(e.target).closest('.js-infocard-content').length) {
			return; // allow native scrolling inside infocard content (e.g. priority lounge PLP)
		}
		e.preventDefault();
		e.stopPropagation();
	}

	function email_alert_toggle(close) {
		if (close) {
			close_modals('js-email_alert_dialog');
		}
		var a = jQuery('.js-snh_email_alert');
		var h = jQuery('.js-headroom'); //quick fix z-index bug
		yalwa.basics.toggle(a);
		if (!a.hasClass('hidden')) {
			h.css('z-index', 14);
			a.velocity('transition.expandIn', {duration: 300});
		} else {
			h.css('z-index', 8);
		}
	}

	function email_alert_hide() {
		yalwa.basics.hide(jQuery('.js-snh_abo_new'));
		yalwa.basics.hide(jQuery('.js-webpush_priming'));
		yalwa.mobile.generic_shadow.hide();
	}

	function email_alert_show() {
		yalwa.basics.state.push('email_alert_add');
		yalwa.basics.show(jQuery('.js-snh_abo_new'));
		yalwa.mobile.generic_shadow.show({onclick: email_alert_hide});
		alert_tracking();
		// Set coockie to not show alert again
		yalwa.basics.set_cookie('alert_window_showed', 1);
		// Make whole info div clickable

	}

	function alert_tracking() {
		yalwa.basics.ga.event({
			category: 'alert_plp_impression',
			action: yalwa.basics.is_logged_in() ? 'logged_in' : 'anond',
			label: 'mobile'
		});
	}

	function abo_save() {
		var $email = jQuery('.js-abo_email');
		if (!$email.val()) {
			$email.velocity('callout.shake');
			return;
		}
		var $input_push = jQuery('.js-email_alert_type[data-type="push"]');
		var abo_allow_push_changes = $input_push.prop('disabled') ? 0 : 1;
		abo_action_push = $input_push.prop('checked') ? 'add' : 'remove';

		var $input_email = jQuery('.js-email_alert_type[data-type="email"]');
		var abo_action_email = $input_email.prop('checked') ? 'add' : 'remove';

		if (!$input_push.prop('checked') && !$input_email.prop('checked')) {
			$input_push.parent().velocity('callout.shake');
			return;
		}
		var email_alert_time_val = jQuery('.js-email_alert_time').val();
		if (email_alert_time_val === 'i' && jQuery('.js-email_alert_pa').length) {
			yalwa.mobile.mfd({
				html: jQuery('.js-email_alert_pa').html(), close_after: function() {
					jQuery('.js-email_alert_time').val('d').velocity('callout.pulse');
				}
			});
			jQuery('.js-mfd').css({zIndex: 100000, backgroundColor: 'hsl(0deg 0% 0% / 90%)'});
			return;
		}

		jQuery.ajax({
			url: '/api/ajax/add_alert/',
			dataType: 'json',
			data: {
				// cookie value from loc_sp_params is also used
				promo_alert_email: $email.val(),
				time_repeat: email_alert_time_val,
				abo_allow_push_changes: abo_allow_push_changes,
				abo_action_push: abo_action_push,
				abo_action_email: abo_action_email
			},
			type: 'post'
		}).done(abo_save_response).fail(function(data) {
			abo_save_response(data.responseJSON);
		});

	}

	function abo_ask_push_permission() {
		if (yalwa.basics.webpush.is_granted()) {
			yalwa.basics.webpush.ask_or_update_existing('search_abo', true);
		} else {
			yalwa.basics.webpush.ask_or_update_existing('search_abo', false);
		}
	}

	function abo_save_response(response) {
		if (!response) {
			return;
		}
		if (response.info === 'email_alert_success') {
			yalwa.basics.show(jQuery('.js-snh_search_saved'));
			jQuery('.js-snh_search_saved').attr("href", response.account_section_url + '?show=my-subscriptions&search_id=' + response.search_id);
			yalwa.basics.hide(jQuery('.js-email_alert_dialog'));
			const data = {category: 'Added email alert', action: 'Browse'};
			yalwa.basics.ga.ping_metric('CM_ALERT_ADDED', 1, data);

			email_alert_hide();
			var $html_tmp = jQuery('<div>' + response.html + '</div>');
			var message_tmp = response.html;
			var type_tmp = 'success';
			if ($html_tmp.find('.confirm').length) {
				message_tmp = $html_tmp.text();
				type_tmp = 'warning';
			}
			yalwa.basics.toast({
				message: message_tmp,
				type: type_tmp,
				progressBar: true,
				timeOut: 4000
			});
			if (abo_action_push === 'add') {
				abo_ask_push_permission();
			}
		} else {
			var message;
			if (response.errors[0] !== undefined) {
				message = response.errors[0];
			} else {
				message = response.info;
			}
			if (message) {
				yalwa.basics.toast({
					message: message,
					type: 'warning',
					progressBar: true,
				});
			}
		}
	}

	const ltw = (function(pub) { // ltw = level tree widget
		let ltw_timer;
		let animation = false;
		let user_opened_dropdown = false;
		let ltw_caching; // sessionCache
		let ltw_cache = {};
		let ltw_cached_request_index = false;
		let $ltw_root;
		let selected_index;
		pub = pub || {};

		pub.leaf = null;
		pub.select_only = false;
		pub.init = function() {
			ltw_caching = true; // sessionCache
			$ltw_root = jQuery('.js-ltw');
			selected_index = 0;
			cache_age_handler();
			ltw_cache = JSON.parse(yalwa.basics.ss_get('ltw_cache')) || {};
			$ltw_root.addClass('invisible');
			pub.leaf = $ltw_root.data('ltw_start_id');
			jQuery('.js-snh_category').on('click.ltw_init', pub.init_request);
			$ltw_root.on ('keydown', keyboard_listener);
			$ltw_root.on('click', '.js-ltw_option', option_click).each(add_touchlistener);
			$ltw_root.removeClass('invisible');
		};

		function keyboard_listener(e) {
			const $items = $ltw_root.find('.js-ltw_option');
			if (e.key === 'Enter') {
				$ltw_root.focus();
				$items.eq(selected_index).trigger('click');
				selected_index = 0;
			}
			if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
				e.preventDefault();

				$items.eq(selected_index).attr('aria-selected', 'false').removeClass('selected');

				if (e.key === 'ArrowDown') {
					selected_index = (selected_index + 1) % $items.length;
				} else {
					selected_index = (selected_index - 1 + $items.length) % $items.length;
				}

				$items.eq(selected_index).attr('aria-selected', 'true').addClass('selected').focus();
				$ltw_root.attr('aria-activedescendant', $items.eq(selected_index).attr('id'));
			}
		}

		pub.init_request = function() {
			track_dropdown_open();
			var $root = jQuery('.js-snh').find('.js-ltw');
			if ($root.data('ltw_start_id')) {
				request($root, $root.data('ltw_start_id'), $root.data('ltw_start_type'), $root.data('ltw_parent_explicit'));
			} else {
				request($root, null, 'root');
			}
			jQuery(this).off('click.ltw_init');
		};

		pub.reset = function() {
			return request(jQuery('.js-snh').find('.js-ltw'), null, 'root');
		};

		pub.hide = function() {
			var $snh_ltw = jQuery('.js-snh_ltw');
			yalwa.basics.hide($snh_ltw);
			jQuery('.js-snh_category,.js-snh_category_clone').removeClass('toggled');
			jQuery('.js-snh_toggle').removeClass('open');
		}

		pub.toggle = function(position) {
			toggle_icon();
			jQuery('.js-snh_ltw').is(':visible') ? pub.hide() : show(position);
		}

		function toggle_icon() {
			jQuery('.js-snh_toggle').toggleClass('open');
		}

		function show(position) {
			var $snh_ltw = jQuery('.js-snh_ltw');
			yalwa.basics.show($snh_ltw);
			if (!$snh_ltw.is(':visible')) {
				$snh_ltw.velocity('transition.expandIn', {duration: 0});
			}
			if (position === 'narrow') {
				jQuery('.js-ciw_category').after($snh_ltw);
			} else {
				jQuery('.js-narrow_search').removeClass('toggled');
			}
		}

		function cache_age_handler() {
			if (!ltw_caching) {
				yalwa.basics.ss_remove('ltw_cache');
				yalwa.basics.ss_remove('ltw_cache_age');
				yalwa.basics.ss_remove('ltw_cache_id');
				return;
			}
			const cache_age = yalwa.basics.ss_get('ltw_cache_age');
			const cache_id = yalwa.basics.ss_get('ltw_cache_id');
			const now = parseInt(Date.now() / 1000);
			const expire_after = 86400; // one day
			if (!cache_id) {
				yalwa.basics.ss_set('ltw_cache_id', yalwa.basics.get_svn_revision());
			}
			if (!cache_age) {
				yalwa.basics.ss_set('ltw_cache_age', now);
			}
			if ((cache_age && (parseInt(cache_age) + expire_after) < now) || cache_id !== yalwa.basics.get_svn_revision()) {
				yalwa.basics.ss_set('ltw_cache_age', now);
				yalwa.basics.ss_set('ltw_cache_id', yalwa.basics.get_svn_revision());
				yalwa.basics.ss_remove('ltw_cache');
			}
		}

		function track_dropdown_open() {
			user_opened_dropdown = true;
			yalwa.basics.ga.event({
				category: 'mobile_category_select',
				action: 'mobile_category_select_open'
			});
		}

		function track_dropdown_click() {
			if (!user_opened_dropdown) {
				return;
			}
			yalwa.basics.ga.event({
				category: 'mobile_category_select',
				action: 'mobile_category_select_click'
			});
		}

		function track_dropdown_fire() {
			if (!user_opened_dropdown) {
				return;
			}
			yalwa.basics.ga.event({
				category: 'mobile_category_select',
				action: 'mobile_category_select_fire'
			});
		}

		function option_click() {
			let $this = jQuery(this);
			if (
				$this.hasClass('js-ltw_selected_item') &&
				!$this.hasClass('js-ltw_dating')
			) {
				return;
			}
			let position = $this.closest('.js-ltw').data('position') ? $this.closest('.js-ltw').data('position') : false;
			let select_only = position !== 'group_dialer';
			if ($this.hasClass('js-ltw_dating')) {
				if ($this.data('ab')) {
					yalwa.basics.ga.event({
						category: 'dating_promo',
						action: 'meta grid'
					});
				} else if ($this.data('d1')) {
					yalwa.basics.ga.event({category: $this.data('d1'), action: $this.data('d2')});
				}
				yalwa.basics.navigate($this.data('ltw_url'));
			} else if ($this.hasClass('js-ltw_leaf') && $this.data('ltw_url')) {
				track_dropdown_fire();
				yalwa.mobile.snh.fire($this.data('ltw_url'), select_only);
			} else {
				track_dropdown_click();
				request($this.closest('.js-ltw'), $this.data('ltw_id'), $this.data('ltw_type'), $this.data('ltw_parent'), $this.hasClass('js-ltw_back'));
			}
		}

		function request($root, ltw_id, type, parent_explicit, is_back, is_init) {
			var $request = jQuery.ajax({
				url: '/api/ajax/general',
				dataType: 'json',
				cache: true,
				data: {
					action: 'ltw_request_new',
					type: type,
					ltw_id: ltw_id,
					areaID: $root.data('areaid'),
					geoID: $root.data('geoid'),
					parent_explicit: parent_explicit && (type !== 'ebt_l2') ? parent_explicit : null,
					start_id: $root.data('ltw_start_id'),
					position: $root.data('position')
				},
				beforeSend: function(xhr, options) {
					let index = this.url;
					if (is_ltw_request_cached(index)) {
						ltw_cached_request_index = index;
						xhr.abort();
					}
				},
				success: function(data, status, xhr) {
					if (ltw_caching) {
						ltw_cache[this.url] = data;
						yalwa.basics.ss_set('ltw_cache', ltw_cache);
					} else {
						yalwa.basics.ss_remove('ltw_cache');
					}
				}
			});
			pub.leaf = ltw_id;
			var $children = $root.children();
			if (ltw_cached_request_index) {
				options_show_new($root, ltw_cached_request(ltw_cached_request_index), is_back, !$children.length, ltw_id, type, is_init);
				ltw_cached_request_index = false;
			} else if ($children.length) {
				jQuery.when($request, options_hide_old($root, is_back)).done(function(ajax_response) {
					options_show_new($root, ajax_response[0], is_back, false, ltw_id, type, is_init);
				});
			} else {
				$request.done(function(response) {
					options_show_new($root, response, is_back, true, ltw_id, type, is_init);
				});
			}

			return $request;
		}

		function is_ltw_request_cached(index) {
			return ltw_caching ? ltw_cache.hasOwnProperty(index) : false;
		}

		function ltw_cached_request(index) {
			return ltw_cache[index];
		}

		function touchstart(event) {
			var $target = jQuery(event.target);
			ltw_timer = window.setTimeout(function() {
				$target.closest('.js-ltw_option').addClass('ltw__option--touch');
			}, 40);
		}

		function touch_move_end(event) {
			window.clearTimeout(ltw_timer);
			var $target = jQuery(event.target);
			$target.closest('.js-ltw_option').removeClass('ltw__option--touch');
		}

		function add_touchlistener(i, root) {
			var sp = yalwa.mobile.supports_passive();
			root.addEventListener('touchstart', touchstart, sp);
			['touchmove', 'touchend'].forEach(function(listener) {
				root.addEventListener(listener, touch_move_end, sp);
			});
		}

		function stagger_value(a) {
			return Math.min(a * 18, 180);
		}

		function options_hide_old($root, is_back) {
			var deferred = jQuery.Deferred();
			if (animation) {
				$root.children().velocity('transition.' + (is_back ? 'slideRightOut' : 'slideLeftOut'), {
					duration: 180,
					stagger: stagger_value,
					drag: true,
					display: '',
					complete: function() {
						deferred.resolve();
					}
				});
			} else {
				deferred.resolve();
			}
			return deferred.promise();
		}

		function options_show_new($root, response, is_back, no_old, ltw_id, type, is_init) {
			let position = $root.closest('.js-ltw').data('position') ? $root.closest('.js-ltw').data('position') : false;
			let select_only = position !== 'group_dialer';
			if (response.url && !is_init) {
				track_dropdown_fire();
				jQuery('.js-snh_category').data('last_selected_category_url', response.url);
				yalwa.mobile.snh.fire(response.url, select_only);
				pub.hide();
			} else {
				$root.html(response.html);
				if (select_only) {
					if (jQuery('.js-ltw_option_all').length && !$root.find('[data-ltw_id="' + ltw_id + '"]').length) {
						jQuery('.js-snh_category').data('last_selected_category_url', jQuery('.js-ltw_option_all').data('ltw_url'));
					}
					yalwa.mobile.snh.fire(jQuery('.js-ltw_option_all').data('ltw_url'), select_only);
				}
				$root.closest('.js-snh_ltw').scrollTop(0);

				jQuery('.js-ltw').removeClass('invisible');
				if (!no_old && animation) {
					$root.children().velocity('transition.' + (is_back ? 'slideLeftIn' : 'slideRightIn'), {
						duration: 180,
						stagger: stagger_value,
						drag: true,
						display: ''
					});
				}

				// Important
				// These checks should be made here after downloaded html was parsed
				// see #41666
				yalwa.basics.state.register('ltw', function() {
					const $back = jQuery('.js-ltw_back').last();

					if ($back.length && $back.is(':visible') && $back[0]) {
						option_click.call($back[0], false);
						return true;
					}
					if (jQuery('.js-snh_ltw').not('.hidden').length) {
						pub.hide();
						return true;
					}
					return false;
				});
			}
			// The LTW box under the search box, not the "All Categories" one...
			const only_the_big_one = $root.parent().hasClass('js-ltw_new');
			const uae_personals_exception = yalwa.v.countryID === 29 && ltw_id === 'P';
			if (only_the_big_one && !uae_personals_exception) {
				if (is_back && !ltw_id.length) {
					$root.parent().addClass('ltw__new');
				} else {
					$root.parent().removeClass('ltw__new');
				}
			}
		}

		return pub;

	}(pub.ltw));

	// TODO used only mobile paf.js should be moved to paf.js
	var current_ltw_request = null;
	pub.ltw_request = function(root, level, subaction, list, sort_alphabetically, is_PAF) {
		// list = list || root; // not used anymore?
		var l1 = null;
		var l2 = null;
		var l3 = null;
		if (level) {
			switch (level.toString().length) {
				case 1:
					l1 = level;
					break;
				case 3:
					l2 = level;
					break;
				case 5:
					l3 = level;
					break;
			}
		}
		if (current_ltw_request) {
			current_ltw_request.abort();
		}
		current_ltw_request = jQuery.ajax({
			url: '/api/ajax/general',
			dataType: 'json',
			cache: true,
			data: {
				action: 'ltw_request',
				areaID: root.data('areaid'),
				geoID: root.data('geoid'),
				alphabetically: sort_alphabetically ? 1 : 0,
				PAF: is_PAF ? 1 : 0,
				l1: l1,
				l2: l2,
				l3: l3,
				subaction: subaction
			}
		});

		return current_ltw_request;
	};
	
	function init_bst_sliders() {
		const $sliders = jQuery('.js-posting_listing_slide');
		if (!$sliders.length) {
			return;
		}
		yalwa.v.current_page_type_for_bip_tracking = yalwa.basics.ga.dimension_get('CD_PAGETYPE');
		$sliders.each(function() {
			const $element = jQuery(this);
			const callback = !$element.hasClass('js-dating_promo') ? bip_tracker.bind({}) : null; // with .bind({}) use same instance for both directions and both events
			const options = {
				container: $element,
				css_prefix: 'posting_listing__',
				container_class: 'js-posting_listing_slide',
				element_class: 'js-posting_listing_slide_item',
				timeout: 0,
				arrows: {
					append_to: false,
					enabled: true,
					size: 36,
					directions: {
						left: {
							icon: 'arrow',
							folder: 'bst2',
							callback: callback,
							alt: $element.data('left_arrow_alt') || ''
						},
						right: {
							icon: 'arrow',
							folder: 'bst2',
							callback: callback,
							alt: $element.data('right_arrow_alt') || ''
						}
					}
				},
				clickable: true,
				use_visibility_change_handler: false
			};
			const slide_instance = new yalwa.basics.simple_auto_slide(options);
			slide_instance.start();
		})
	}
	function bip_tracker(event) {
		const event_type_mapping = {
			'click': 'click',
			'swipeleft': 'swipe',
			'swiperight': 'swipe'
		};
		yalwa.basics.ga.dimension_set('CD_PAGETYPE', 'BIP');
		yalwa.basics.ga.pageview({'page': '/BIP/', 'app_name': yalwa.basics.ga.get_updated_pagetype_in_appname('BIP')});
		yalwa.basics.ga.dimension_set('CD_PAGETYPE', yalwa.v.current_page_type_for_bip_tracking);
		const payload = {
			t: 'bip_pageview',
			initial: !this.initialized,
			msgid: jQuery(event.target).closest('.js-bst_list_item').data('msgid')
		};
		yalwa.basics.beacon('/api/ajax/track/', payload);
		yalwa.basics.ga.event({
			category: 'bip_switch_type',
			action: event_type_mapping[event.type]
		});
		this.initialized = true;
	}

// nudges
    pub.init_nudge = function() {
        jQuery('.js-nudge_related_ad_link').on_once('click.nudge_related_ad', function() {
			track_VAP_touchpoint(jQuery(this));
            yalwa.basics.navigate(jQuery(this).data('link'));
        });
        jQuery('.js-nudge_close').on_once('click.nudge_close', function() {
            jQuery(this).closest('.js-plp').trigger('plp_hide').remove();
        });
        jQuery('.js-nudge_chat_item').on_once('click.nudge_chat_item', function() {
			const $other_items = jQuery('.js-nudge_chat_item');
			$other_items.addClass('nudge_chat__item--blur');
			yalwa.basics.show($other_items.find('.js-nudge_chat_item_text'));
			yalwa.basics.hide($other_items.find('.js-nudge_chat_item_send'));
            const $this = jQuery(this);
            $this.addClass('nudge_chat__item--send').removeClass('nudge_chat__item--blur');
            yalwa.basics.hide($this.find('.js-nudge_chat_item_text'));
            yalwa.basics.show($this.find('.js-nudge_chat_item_send'));
        });
        jQuery('.js-nudge_chat_item_send').on_once('click.nudge_chat_item_send', function() {
			const $active_plp = jQuery('.js-plp').not('.hidden');
			if (yalwa.v.ua_phone_verification_needed) {
				$active_plp.trigger('plp_hide').remove();
				yalwa.mobile.show_ua_phone_verification_dialog();
				return;
			}
            let msgID = jQuery(this).data('msgid');
            let email_message = jQuery(this).data('email_message');
            yalwa.basics.chat_limit_reached().done((reached) => {
                if (reached) {
					let routing = yalwa.basics.get_routing();
                    if (routing === 'vap' || routing === 'search' || routing === 'search_nationwide') {
                        $active_plp.trigger('plp_hide');
                        yalwa.mobile.show_chat_limit_reached_plp();
                        $active_plp.remove();
                    }
                } else {
                    jQuery.ajax({
                        type: 'POST',
                        url: '/api/ajax/chat/',
                        data: {
                            action: 'new_conversation',
                            msgID: msgID,
                            email_message: email_message
                        },
                        dataType: 'json'
                    }).done(function(json) {
                        switch (json["class"]) {
                            case 'success':
                                $active_plp.trigger('plp_hide');
                                $active_plp.remove();
                                yalwa.basics.toast({
                                    message: json.label,
                                    'type': 'success',
                                    progressBar: true,
                                    positionClass: "toast-top-full-width",
                                    timeOut: 5000
                                });
                                break;
                            case 'error':
                                if (json.label) {
                                    yalwa.basics.toast({message: json.label, 'type': 'error'});
                                }
                                $active_plp.trigger('plp_hide');
                                $active_plp.remove();
                                break;
                            default:
                                return false;
                        }
                    });
                }
            });
        });
        jQuery('.js-nudge_show_more').on_once('click.nudge_show_more', function() {
           const $show_more = jQuery(this);
           yalwa.basics.hide($show_more);
           yalwa.basics.show(jQuery('.js-nudge_chat_item.hidden'));
        });
    };
// nudges

// geolocation
	function geolocation_init() {
		jQuery('.js-b_geolocate').on('click', geolocation_toggle);
		yalwa.basics.state.register('geolocation', function() {
			if (jQuery('.js-geolocation_card').length && !jQuery('.js-geolocation_card').hasClass('hidden')) {
				geolocation_hide();
				return true;
			}
		});
	}

	function parse_cat() {
		if (!yalwa.v.url_add) {
			return '';
		}
		var keep_cat = yalwa.v.url_add.match(/\/\d{3,5}\//);
		if (keep_cat !== null) {
			keep_cat = keep_cat[0].replace(/\//g, '');
		} else {
			keep_cat = yalwa.v.url_add.match(/\/\w\//);
			if (keep_cat !== null) {
				keep_cat = keep_cat[0].replace(/\//g, '');
			} else {
				keep_cat = false;
			}
		}
		return keep_cat;
	}

	function geolocate_autocomplete_request(lat, lon, acc, cat, mobile) {
		return jQuery.ajax({
			url: '/api/geo/geolocate_autocomplete/',
			data: {
				lat: lat,
				lon: lon,
				acc: acc,
				cat: cat,
				mobile: mobile
			},
			dataType: 'json'
		});
	}

	function geolocation_success(position, onsuccess, invisible) { // beware: used via cordova
		var keep_cat = parse_cat();

		geolocate_autocomplete_request(position.coords.latitude, position.coords.longitude, position.coords.accuracy, keep_cat, 1).done(function(data) {
			yalwa.basics.progress.stop();
			if (data && data.places[0] && data.places[0].url) {
				window.clearTimeout(yalwa.v.error_timeout);
				var html = '<div class="js-geolocation_card geolocation_card hidden">';
				html += '<a class="geolocation_card__head" href="' + data.places[0].url + '" data-countryid="' + data.places[0].countryID + '">' + data.places[0].label + '</a><hr />';
				html += '<span class="geolocation_card__head2">' + data.label.places_nearby + '</span><ul>';
				var i;
				for (i in data.places) {
					if (data.places.hasOwnProperty(i) && data.places[i].url) {
						if (i === '0') {
							continue;
						}
						html += '<li><a href="' + data.places[i].url + '">' + data.places[i].label + '</a></li>';
					}
				}
				html += '</ul>';
				if (Object.keys(data.top_cities).length) {
					html += '<hr /><span class="geolocation_card__head2">' + data.label.top_cities + '</span><ul>';
					for (i in data.top_cities) {
						if (data.top_cities.hasOwnProperty(i) && data.top_cities[i]) {
							html += '<li><a href="' + data.top_cities[i] + '">' + i + '</a></li>';
						}
					}
					html += '</ul>';
				}
				html += '</div>';
				$body.append(html);
				if (!invisible) {
					geolocation_show();
				}

				if (typeof (onsuccess) === 'function') {
					//geolocation_closest_success
					onsuccess(data);
				}
			} else {
				geolocation_error();
			}
		});
	}

	function geolocation_show() {
		yalwa.basics.show(jQuery('.js-geolocation_card'));
		yalwa.mobile.generic_shadow.show({'onclick': geolocation_hide});
		yalwa.basics.state.push('geolocation');
	}

	function geolocation_hide() {
		yalwa.basics.hide(jQuery('.js-geolocation_card'));
		yalwa.mobile.generic_shadow.hide();
		yalwa.basics.state.try_cancel('geolocation');
	}

	function geolocation_closest_choose(name, geoid) {
		$document.trigger('geoid_selected', [geoid, true]);
		jQuery('.js-places_suggest').attr('placeholder', name);
		jQuery('.js-location_area').val(name);
		snh_location_placeholder_color_toggle(true);
	}

	function snh_location_placeholder_color_toggle(has_location) {
		jQuery('.js-places_suggest').toggleClass('snh__input--has_value', !!has_location);
	}

	function location_change_icon_handler() {
		snh_location_placeholder_color_toggle(!!jQuery(this).val());
		const icon_name = jQuery(this).val() ? 'pin--blue' : 'pin--gray';
		const $gps_icon = jQuery('.js-snh_gps').find('.yimage').first();
		yalwa.basics.yimage_change(icon_name, $gps_icon);
	}
	
	function show_location_mandatory(show_toast) {
		yalwa.basics.show(jQuery('.js-pin_validity').eq(1));
		yalwa.basics.hide(jQuery('.js-pin_validity').eq(0));
		jQuery('.js-places_suggest').addClass('show_mandatory').focus();
		if (show_toast) {
			yalwa.basics.toast({message: yalwa.v.lang.search_bar_no_location_added, type: 'error'});
		}
	}

	function geolocation_closest_check(data) {
		const location = data?.places?.[0] || null;
		if (location) {
			geolocation_closest_choose(location.label, location.id);
			if (
				location.countryID &&
				yalwa.v.countryID &&
				location.countryID !== yalwa.v.countryID
			) {
				yalwa.v.change_hostname = location.hostname;
			}
			window.setTimeout(function() {
				yalwa.basics.toast({
					message: location.label,
					type: 'info',
					progressBar: true,
					timeOut: 2000
				});
			}, 500);
		}
	}

	function geolocation_closest() {
		$document.off('geolocation_success.closest').on('geolocation_success.closest', function(event, position) {
			geolocation_success(position, geolocation_closest_success, true);
		});
		$document.off('geolocation_error.closest').on('geolocation_error.closest', function(event, error) {
			geolocation_error(error, 'closest');
		});
		yalwa.mobile.get_current_position(10000, 'closest');
		yalwa.mobile.app_progress(jQuery('.js-places_suggest').closest('.js-snh_search_wrap'));
	}

	function geolocation_closest_success(data) {
		geolocation_closest_check(data);
	}

	function geolocation_toggle(e) {

		if (jQuery('.js-geolocation_card').length) {
			geolocation_show();
		} else {
			yalwa.mobile.app_progress();
			$document.off('geolocation_success.standard').on('geolocation_success.standard', function(event, position) {
				geolocation_success(position);
			});
			$document.off('geolocation_error.standard').on('geolocation_error.standard', function(event, error) {
				geolocation_error(error);
			});
			yalwa.mobile.get_current_position(10000, 'standard');
		}
		e.preventDefault();
	}

	function geolocation_error(err) {
		if (yalwa.v.locate_type === 'geo' && yalwa.v.locate_return) {
			yalwa.mobile.stop_invisible_start();
			window.setTimeout(function() {
				yalwa.basics.navigate(yalwa.v.locate_return + '&locate_fail=1');
			}, 1500);
		}
		yalwa.basics.progress.stop();
		window.clearTimeout(yalwa.v.error_timeout);
		if (err) {
			display_geolocation_error(err.code);
		}
	}

	function display_geolocation_error(code) {
		var label;
		yalwa.basics.progress.stop();
		switch (code) {
			case 1:
				label = 'mobile_notification_permission_denied';
				break;
			case 2:
				label = 'mobile_notification_position_unavailable';
				break;
			case 3:
				label = 'mobile_notification_timeout';
				break;
		}
		if (label) {
			yalwa.basics.label(label, 'main').done(function(value) {
				yalwa.basics.toast({message: value, type: 'warning'});
			});
		}
	}

// geolocation-end

// browse-history
	function history_init() {
		browse_history_init();
		browse_history_ads_init();
		if (!jQuery('.js-history_card').children().length) {
			jQuery('.js-history_card_container').remove();
			return;
		}
		jQuery('.js-ah_clear').on('click', reset_last_visited_ads);
	}

	function reset_last_visited_ads() {
		yalwa.basics.ss_set('last_visited_ads', []);
		yalwa.basics.set_cookie(yalwa.basics.get_cookie_name_final('lva'), JSON.stringify([]));
		jQuery('.js-history_ads_wrap').remove();
		jQuery('.js-last_visited_session').remove();
	}

	function browse_history_ads_init() {
		const last_visited_ads = yalwa.basics.ss_get('last_visited_ads', true) || [];
		const $history_ads_wrap = jQuery('.js-history_ads_wrap');
		if (!last_visited_ads.length) {
			$history_ads_wrap.remove();
			return;
		}
		let html = '';
		for (let i in last_visited_ads) {
			if (last_visited_ads.hasOwnProperty(i)) {
				const $html = jQuery(last_visited_ads[i].html);
				const href = $html.find('a').prop('href');
				const img_src = $html.find('[data-src]').data('src') || $html.find('[src]').attr('src');
				const header = $html.find('.js-result_title').first().text();
				if (href) {
					html += `
    <li>
        <a class="snh__history_item" href="${href}">
            <div class="snh__history_ad_image">
                ${img_src ? `<img loading="lazy" src="${img_src}" alt="" />` : ''}
            </div>
            <div class="snh__history_item_content">
                <div class="snh__history_item_title">${header}</div>
            </div>
        </a>
    </li>
`;
				}
			}
		}
		$history_ads_wrap.find('ul').html(html);
		yalwa.basics.show($history_ads_wrap);
	}

	function browse_history_init() {
		if (yalwa.v.lang.reset && !yalwa.basics.label_cache('reset', 'main')) {
			yalwa.basics.label_set('reset', 'main', yalwa.v.lang.reset);
		}
		if (yalwa.v.lang.browse_history_title && !yalwa.basics.label_cache('browse_history_title', 'main')) {
			yalwa.basics.label_set('browse_history_title', 'main', yalwa.v.lang.browse_history_title);
		}
		var bh_entries = yalwa.basics.ls_get(browse_history_key, true) || [];
		const $history_categories = jQuery('.js-browse_history')
		var value = bh_entries.length;
		jQuery('.js-ybtb_button_browse_history')
			.attr('data-menu_count', value)
			.data('unread', value)
		;
		if (!bh_entries.length) {
			$history_categories.remove();
			return;
		} else {
			yalwa.basics.show(jQuery('.js-bh_full'));
			browse_history_change_page(0);
		}
		jQuery('.js-bh_clear').on('click', function() {
			yalwa.basics.ls_remove(browse_history_key);
			$history_categories.remove();
			return;
		});

		$history_categories.on('click', 'li', function() {
			yalwa.basics.navigate(jQuery(this).data('url'));
		});
	}

	function browse_history_toggle() {
		close_modals();
		yalwa.basics.toggle(jQuery('.js-history_card'));
		yalwa.basics.toggle(jQuery('.js-browse_history'));
		yalwa.basics.toggle(jQuery('.js-history_card_container'));
	}

	function browse_history_change_page(page) {
		page = page || 0;
		var items_per_page = 20;
		var bh_entries = yalwa.basics.ls_get(browse_history_key, true) || [];
		var text = [];
		var count = 0;
		var start = bh_entries.length - 1 - (page * items_per_page);
		for (var i = start; i >= 0; i--) {
			let img = '';
			if (bh_entries[i].l1 || bh_entries[i].url.match(/\/([A-Z])\//)) {
				const img_tmp = bh_entries[i].l1 || bh_entries[i].url.match(/\/([A-Z])\//)[1] ;
				img = yalwa.basics.yicon(img_tmp, {pixel: 32});
			} else {
				img = yalwa.basics.yimage('categories_all', {folder: 'profile', pixel: 32});
			}
			const e = bh_entries[i];
			if (e.url) {
				text.push(`
<li class="snh__history_item" data-url="${e.url}">
	${img}
	<span class="snh__history_item_content">
		<span class="snh__history_item_title">
			${e.title}
			<span class="hidden snh__history_item_time">${e.ts}</span>
		</span>
		<span class="snh__history_item_details">
			<span>${e.details}</span>
			<span class="snh__history_item_results hidden">${e.results}</span>
		</span>
	</span>
</li>
				`);
			}
			count++;
			if (count >= items_per_page) {
				break;
			}
		}
		jQuery('.js-browse_history').find('ul').html(text.join(''));
		jQuery('.js-browse_history').data('page', page);
	}

	function filter_empty(x) {
		return x !== undefined && x !== null;
	}

	function browse_history_add() {
		if (!yalwa.v.browse_history_entry) {
			return;
		}
		var new_entry;
		var results = jQuery.trim(jQuery('.num_results strong:first-child').text() || jQuery('.js-result_count').text() || '0');
		new_entry = {
			url: location.href,
			title: yalwa.v.browse_history_entry[0],
			l1: yalwa.v.l1,
			details: yalwa.v.browse_history_entry.slice(1).join(', '),
			results: results + ' ' + (parseInt(results.replace(/[.,]/ig, ''), 10) > 1 ? yalwa.v.lang.Results : yalwa.v.lang.Result),
			ts: yalwa.basics.unix()
		};
		var bh_entries = yalwa.basics.ls_get(browse_history_key, true);
		bh_entries = bh_entries || [];
		for (var i = 0; i < bh_entries.length; i++) {
			if (bh_entries[i].title + bh_entries[i].details === new_entry.title + new_entry.details) {
				delete bh_entries[i];
				bh_entries.push(new_entry);
				bh_entries = bh_entries.filter(filter_empty);
				yalwa.basics.ls_set(browse_history_key, bh_entries);
				return;
			}
		}
		var max = 20;
		bh_entries.push(new_entry);
		if (bh_entries.length > max) {
			bh_entries = bh_entries.slice(bh_entries.length - max, bh_entries.length);
		}
		yalwa.basics.ls_set(browse_history_key, bh_entries);
	}

// browse-history-end

// promotions on browse/search pages
	function browse_promotions_init() {
		yalwa.basics.add_animation_on_scrollview(jQuery('.js-ce_image_animated'), 'ce_image_animated', 'tada');
		jQuery('.js-trigger_ce_onclick').on('click', function() {
			var $this = jQuery(this);
			var url = $this.data('url');

			yalwa.basics.ga.event({
				category: 'ce_campaign_tracking_click',
				action: $this.data('campaign'),
				label: $this.data('subcampaign')
			});
			yalwa.basics.navigate(url);
		});
	}

// promotions on browse/search pages end

	function init_ajax_reload_routine() { // ajax request e.g. in MC will fail, when logged out in the meantime
		var threshold = 3600;
		var timeoutID;
		var do_reload_on_return;

		$document.ajaxError(function(e, x) {
			if (x && x.responseText && x.responseText === 'ajax_autologin') {
				yalwa.basics.reload();
			}
		});

		$document.ajaxSuccess(function() {
			timeout_reset();
		});

		function timeout_reset() {
			yalwa.basics.ls_set('cordova_timer_started', yalwa.basics.unix());
			if (timeoutID) {
				window.clearTimeout(timeoutID);
			}
			timeoutID = window.setTimeout(function() {
				if (document.hidden) {
					do_reload_on_return = true;
				} else {
					yalwa.basics.ls_set('cordova_timer_started', 0);
					yalwa.basics.reload();
				}

			}, (threshold) * 1000);
		}

		timeout_reset();
		document.addEventListener("visibilitychange", function() {
			switch (document.visibilityState) {
				case 'visible':
					if (do_reload_on_return) {
						yalwa.basics.reload();
					} else if (yalwa.basics.ls_get('cordova_timer_started')) {
						if (yalwa.basics.unix() - yalwa.basics.ls_get('cordova_timer_started') > threshold) {
							yalwa.basics.reload();
						}
					}
					break;
			}
		});
	}

	pub.mark_new_postings = function() {
		if (yalwa.v.abo_hit_last_visited_ts && parseInt(yalwa.v.abo_hit_last_visited_ts) > 0) {
			yalwa.v.abo_hit_last_visited_ts = parseInt(yalwa.v.abo_hit_last_visited_ts);
			jQuery('.js-bst_list_item').each(function(i, e) {
				var $e = jQuery(e);
				if ($e.data('unix') && $e.data('unix') > yalwa.v.abo_hit_last_visited_ts) {
					yalwa.basics.show($e.find('.js-bsp_new.hidden'));
				}
			});
		}
	};

	function style_clicked($item) {
		var classname = $item.hasClass('js-bst_list_item') ? 'bst_list_item--clicked' : 'bsp_list_item--clicked';
		$item.addClass(classname);
		window.setTimeout(function() {
			$item.removeClass(classname);
		}, 200);
	}

	function attach_goto_ad_handler() {

		jQuery('a.js-ad_link').off('click').on('click', function(e) {
			track_VAP_touchpoint(jQuery(this));
			style_clicked(jQuery(this).closest('.js-bsp_list_item,.js-bst_list_item'));
		});

		jQuery('.js-bsp_goto_ad').off('click.goto').on('click.goto', function(e) {
			if (yalwa.v.is_phonegap && yalwa.v.is_ios) {
				yalwa.mobile.app_progress();
			}
			const $bsp_list_item = jQuery(this).closest('.js-bsp_list_item,.js-bst_list_item');
			style_clicked($bsp_list_item);
			const $adlink = $bsp_list_item.find('.js-ad_link');
			if ($adlink.length) {
				track_VAP_touchpoint(jQuery(this));
				if ($adlink.hasClass('js-simple_auth')) {
					$adlink.trigger('click');
				} else if ($adlink.prop('href')) {
					yalwa.basics.navigate($adlink.prop('href'));
				}
			}
		});
	}

	function init_maxlength_textareas() {
		const $textarea = jQuery('.js-countable_textarea');
		const maxLength = $textarea.attr('maxlength');

		if (!$textarea.parent().hasClass('textarea-container')) {
			$textarea.wrap('<div class="countable_textarea_container"></div>');
		}

		// Create and insert the counter badge after the textarea
		yalwa.basics.label('mpaf_chars', 'PAP').done(function(label) {
			$textarea.after(`<div class="countable_textarea_badge">${label}: 0 / ${maxLength}</div>`);
			// Update counter on input
			$textarea.on('input', function() {
				const currentLength = $(this).val().length;
				jQuery(this).next('.countable_textarea_badge').text(`${label}: ${currentLength} / ${maxLength}`);
			});

			$textarea.trigger('input');
		});
	}

	function track_VAP_touchpoint($element) {
		let tp = 'bst_default';
		if($element.closest('.last_visited_session').length) {
			tp = 'last_visited_ads';
		} else if($element.closest('.js-related_ads').length || $element.closest('.js-nudge_msg_related_ads').length) {
			tp = 'related_ads';
		} else if(yalwa.basics.get_routing() === 'public_profile') {
			tp = 'public_profile_ads';
		}
		yalwa.basics.set_VAP_touchpoint(tp);
	}

	function browse_init() {
		pub.mark_new_postings();
		jQuery('.js-bp_listing').on('click', function(e) {
			if (e.which === 1) {
				var $target = jQuery(e.target);
				if ($target.is('a')) {
					return;
				}
				if ($target.is('.js-fav') || $target.parent().is('.js-fav')) {
					e.preventDefault();
					e.stopPropagation();
					return;
				}
				if (yalwa.v.is_phonegap && yalwa.v.is_ios) {
					yalwa.mobile.app_progress();
				}
				var a = jQuery(this).find('.posting_content_title a[href]');
				if (a.length && a.prop('href')) {
					window.setTimeout(function() {
						yalwa.basics.navigate(a.prop('href'));
					}, 100);
				}
			}
		});
		premium_gallery_init();
		pub.email_alerts_init();

		if (yalwa.basics.get_get('highlight') && jQuery('.js-bst_list_item[data-msgid="'+yalwa.basics.get_get('highlight')+'"]').length > 0) {
			jQuery('.js-bst_list_item[data-msgid="'+yalwa.basics.get_get('highlight')+'"]').addClass('highlight_posting');
			setTimeout(() => {
				jQuery('.js-bst_list_item[data-msgid="'+yalwa.basics.get_get('highlight')+'"]')[0].scrollIntoView({
	          block: 'center',
	          inline: 'center'
	      });
				jQuery(document).scrollLeft(0);
			}, 500);
		}

		jQuery('.js-bst_lounge__member').on('click', function(event) {
			yalwa.basics.new_tab(jQuery(event.target).closest('a').prop('href'));
			return false;
		});

		jQuery('.js-bst_lounge__learn').on('click', function(event) {
			yalwa.basics.new_tab(jQuery(event.target).closest('a').prop('href'));
			return false;
		});

		jQuery('.js-bst_lounge__arrow').on('click', lounge_navigate);

		if (jQuery('.js-lounge_teaser').length) {
			window.setTimeout(lounge_teaser_text_rotate, 2400);
		}
		jQuery('.js-quickpost_send').on('touchstart click', quickpost_remember);
		jQuery('.js-quickpost_title').on('enterdown', function() {
			quickpost_remember();
			jQuery('.js-quickpost_send').trigger('click');
		});

		jQuery('.js-bst_more').on('click', function() {
			var $container = jQuery(this).closest('.js-bst_list_item');
			yalwa.mobile.generic_shadow.show({
				onclick: function() {
					yalwa.basics.hide($container.find('.js-bst_advanced'));
					yalwa.mobile.generic_shadow.hide();
				}
			});
			if (!$container.find('.js-bst_advanced_instance').length) {
				jQuery('.js-bst_advanced').not('.js-bst_advanced_instance').clone().addClass('js-bst_advanced_instance').appendTo($container);
			}
			yalwa.basics.show($container.find('.js-bst_advanced'));
		});

		jQuery('.js-show_ignored').on('click', function(e) {
			jQuery('.js-bsp_item_ignored').removeClass('bsp_item_ignored').addClass('bsp_item_not_ignored');
			jQuery(this).remove();
		});

	}

	pub.carousel = (function(pub) {

		pub = pub || {};
		var bounce_width = 35;
		var hammering = false;
		pub.init = function() {
			var $to_init = jQuery('.js-carousel').not('.js-initialized');
			$to_init.each(function(i, carousel) {
				var $carousel = jQuery(carousel);
				$carousel.addClass('js-initialized');
				if ($carousel.hasClass('js-use_shadow')) {
					$carousel.after('<div class="js-carousel_shadow carousel__shadow"></div>');
				}
				carousel.max = calc_max($carousel);
				new Hammer(carousel, {}).on('panend', function(event) {
					on_panend(carousel, event);
				}).on('panleft panright', function(event) {
					on_pan(carousel, event);
				});
				on_pan(carousel, {deltaX: 0}); // to check js-carousel_shadow
				hammering = false;
			});
			$to_init.find('a').on('click', function(e) {
				if (hammering) {
					e.preventDefault();
				}
			});
		};

		function calc_max($carousel) {
			var items_pixel = 0;
			$carousel.children().each(function(i, e) {
				items_pixel += parseInt(jQuery(e).outerWidth(true), 10);
			});
			var $parent = $carousel.parent();
			if ($parent.width() > items_pixel) {
				return 0;
			}
			return $parent.width() - items_pixel;
		}

		function on_pan(carousel, a) {
			hammering = true;
			var deltaX = a.deltaX * 1.3 + (carousel.start || 0);
			if (deltaX > bounce_width) {
				deltaX = bounce_width;
			}
			var close_to_end = Math.abs(deltaX - (carousel.max - bounce_width)) < 150;
			if (deltaX < bounce_width && deltaX > carousel.max - bounce_width) {
				var transform = 'translateX(' + (deltaX).toString() + 'px)';
				carousel.pan_delta = deltaX;
				window.requestAnimationFrame(function() {
					var $carousel = jQuery(carousel);
					$carousel.css({'transform': transform});
					yalwa.basics.toggle($carousel.siblings('.js-carousel_shadow'), !close_to_end)
				});
			}

		}

		function on_panend(carousel, e) {
			var pan_delta = carousel.pan_delta || 0;
			var going_left = e.additionalEvent === 'panleft';
			var smooth_factor = Math.abs(e.velocityX) * 400;
			var goal = going_left ? pan_delta - smooth_factor : pan_delta + smooth_factor;
			if (goal > 0) {
				goal = 0;
			}
			if (goal < carousel.max) {
				goal = carousel.max;
			}
			jQuery(carousel).velocity({translateX: [goal, pan_delta]}, {duration: 400, easing: 'easeOutQuart'});
			carousel.start = goal;
			setTimeout(function() {
				hammering = false;
			}, 300);
		}

		return pub;

	}(pub.carousel));

	function quickpost_remember() {
		yalwa.basics.ls_set('quickpost_title', jQuery('.js-quickpost_title').val());
	}

	function lounge_teaser_text_rotate() {
		jQuery('.js-lounge_teaser').each(lounge_teaser);
	}

	function lounge_teaser(i, e) {
		var $this = jQuery(e);
		var $span = $this.children('span');
		var current = $this.text();
		$span.velocity('fadeOut', {
			duration: 200, display: null, complete: function() {
				$span.text($this.data('toggle_text'));
				$span.velocity('fadeIn', {
					duration: 200, display: null, complete: function() {
						window.setTimeout(function() {
							lounge_teaser(null, e);
						}, 2400);
					}
				});
				$this.data('toggle_text', current);
			}
		});
	}

	var back_to_top = {
		timeout: null,
		last: null,
		hidden: true,
		init: function() {
			jQuery('.js-back_to_top').on('click', back_to_top.click_handler);
			if (yalwa.chat) {
				jQuery('.js-chat')
					.on('scroll', yalwa.basics.throttle(back_to_top.scroll_handler, 200));
			} else {
				$window
					.on('scroll.back_to_top', yalwa.basics.throttle(back_to_top.scroll_handler, 200));
			}
		},
		click_handler: function() {
			if (yalwa.chat) {
				// fixes iOS bug http://stackoverflow.com/a/10170170
				jQuery('.js-chat').scrollTop(0).css({'-webkit-transform': 'translate3d(0,0,0)'});
			} else {
				yalwa.mobile.mainscroll_set(0);
			}
			back_to_top.hide();
		},
		show: function() {
			if (back_to_top.hidden) {
				yalwa.basics.show(jQuery('.js-back_to_top'));
				back_to_top.hidden = false;
			}
		},
		hide: function() {
			if (!back_to_top.hidden) {
				yalwa.basics.hide(jQuery('.js-back_to_top'));
				back_to_top.hidden = true;
			}
		},
		scroll_handler: function() {
			if (!yalwa.chat || (yalwa.chat && yalwa.chat.current_view() === yalwa.chat.VIEW_LIST)) {
				var val = yalwa.chat ? jQuery('.js-chat').scrollTop() : yalwa.mobile.mainscroll_get();
				if (back_to_top.last && back_to_top.last > val && val > 250) {
					back_to_top.show();
					if (back_to_top.timeout) {
						window.clearTimeout(back_to_top.timeout);
					}
					back_to_top.timeout = window.setTimeout(back_to_top.hide, 2000);
				} else {
					if (back_to_top.last && back_to_top.last + 5 > val) {
						// goes only a bit down
					} else {
						if (back_to_top.timeout) {
							window.clearTimeout(back_to_top.timeout);
						}
						back_to_top.hide();
					}
				}
				back_to_top.last = val;
			}
		}
	};
	pub.back_to_top = back_to_top;

	function lounge_navigate() {
		var $this = jQuery(this);
		if ($this.hasClass('bst_lounge__arrow--disabled')) {
			return;
		}
		var direction = $this.hasClass('bst_lounge__arrow--back') ? 'back' : 'next';
		var members = $this.closest('.js-bst_lounge').find('.js-bst_lounge__member');
		if (direction === 'back') {
			yalwa.basics.hide(members.not('.hidden').last());
			yalwa.basics.show(members.not('.hidden').first().prev().velocity('transition.flipXIn', {display: ''}));
			if (!members.not('.hidden').first().prev().length) {
				$this.addClass('bst_lounge__arrow--disabled');
			} else {
				$this.removeClass('bst_lounge__arrow--disabled');
			}
			jQuery('.js-bst_lounge__arrow.bst_lounge__arrow--next').removeClass('bst_lounge__arrow--disabled');
		} else {
			yalwa.basics.hide(members.not('.hidden').first());
			yalwa.basics.show(members.not('.hidden').last().next().velocity('transition.flipXIn', {display: ''}));
			if (!members.not('.hidden').last().next().length) {
				$this.addClass('bst_lounge__arrow--disabled');
			} else {
				$this.removeClass('bst_lounge__arrow--disabled');
			}
			jQuery('.js-bst_lounge__arrow.bst_lounge__arrow--back').removeClass('bst_lounge__arrow--disabled');
		}
	}



	function premium_gallery_init() {
		if (jQuery('.js-pf_gallery').length) {
			yalwa.basics.import_js('mobile/modules/premium_gallery.js');
		}
	}

	function toggle_ofc(bool, suppress) {
		var was_hidden = jQuery('.ocm_left').hasClass('hidden');
		yalwa.basics.toggle(jQuery('.ocm_left'), bool);
		if (!suppress) {
			if (jQuery('.ocm_left').hasClass('hidden')) {
				if (!was_hidden) {
					yalwa.basics.state.try_cancel('ofc');
				}
			} else {
				yalwa.basics.state.push('ofc');
			}
		}
	}

	function navigation_init() {
		jQuery('.js-history_back').on('click', function() {
			if (jQuery(this).hasClass('ybtb__li--disabled')) {
				return;
			}
			if (yalwa.v.is_phonegap && ['mc', 'dol', 'dol_onboarding', 'chp', 'dol_faq'].indexOf(yalwa.basics.get_routing()) === -1) {
				yalwa.mobile.app_progress();
			}
			if (typeof (jQuery('.js-history_back').data('url')) === 'string') {
				yalwa.basics.navigate(jQuery('.js-history_back').data('url'));
			}
			if (yalwa.v.vap_from_external && jQuery('.vap_last_search a[href]').length) {
				yalwa.basics.navigate(jQuery('.vap_last_search a[href]').prop('href'));
			} else {
				window.history.back();
			}
		});
		if (jQuery('.js-ybtb_ofc').length) { // yalwa only
			$main_col.on('click', function() {
				toggle_ofc(false);
			});
			yalwa.basics.state.register('ofc', function() {
				if (!jQuery('.ocm_left').hasClass('hidden')) {
					toggle_ofc(false, true);
					return true;
				}
			});
			jQuery('.js-ybtb_ofc').on('click', function() {
				close_modals('ocm_left');
				toggle_ofc();
				if (yalwa.chat) {
					jQuery('.js-chat').on('scroll.ofc', function() {
						toggle_ofc(false);
						jQuery('.js-chat').off('scroll.ofc');
					});
				} else {
					$window.on('scroll.ofc', function() {
						toggle_ofc(false);
						$main_col.off('scroll.ofc');
					});
				}
			});
		}
		jQuery('.js-bsp_search').on('click', function() {
			$main_col.velocity('scroll', {
				offset: -5000,
				container: $main_col,
				mobileHA: false,
				complete: function() {
					jQuery('.js-snh_placeholder').trigger('click');
					if (yalwa.v.is_ios) {
						jQuery('.js-snh_search').velocity('callout.pulse');
					}
				}
			});
		});
		yalwa.basics.state.register('mdf', function() {
			var $close = jQuery('.js-mfd_close:visible');
			var $mfd = jQuery('.js-mfd');
			if ($close.length && $mfd.length && !$mfd.hasClass('hidden')) {
				$close.trigger('click');
				return true;
			}
			return false;
		});
		logo_init();

		pub.snh.init();

		if (jQuery('.js-burger_menu').length) {
			pub.burger.init();
		} else {
			jQuery('.js-burger_menu_open').one('click', function() {

				load_burger().done(function() {
					pub.burger.init(true);
					pwa_promo_tracking_init();
				});
			});
			jQuery('.js-burger_menu_open').on('keydown', yalwa.basics.keyhandler_for_space_and_enter);
		}

		pub.gestures.init();
		init_dol_promos();

		pub.auth.init();
	}

	pub.auth = (function(pub) {

		var loaded;
		let redirect_to;
		let success_handler;
		var init_register = true;
		const labels = {};
		let touchpoint;
		let login_button_selector = '.js-headroom_login_button, .js-default_login, .js-default_register';
		let $login_buttons;
		let $ignored_links;
		let $promo_auth;
		let promo_auth_class = '.js-simple_auth';
		let is_promo_view = false;
		let promo_view_tracking_data;
		let in_progress = false;

		pub = pub || {};

		pub.init = function() {
			$login_buttons = jQuery(login_button_selector);
			$ignored_links = jQuery('.js-ajax_ignore');
			yalwa.basics.auth.init();
		};

		pub.autoload = function() {
			return yalwa.basics.get_routing() === 'login' || yalwa.basics.get_routing() === 'registration';
		};

		pub.update_login_handlers = function() {
			$promo_auth = jQuery(promo_auth_class);
			$login_buttons = jQuery(login_button_selector);
			$login_buttons
				.not($ignored_links)
				.off('click.load_login')
				.on('click.load_login', pub.show_dialog);
			$login_buttons.on('keydown', function(event) {
				if (yalwa.basics.is_space_bar_or_enter_pressed(event)) {
					pub.show_dialog();
				}
			});
			if (!yalwa.basics.is_logged_in()) {
				var $links = jQuery('a[href*="\/my\/"]')
					.add($promo_auth)
					.not($ignored_links)
					.not($login_buttons)
					.not('[href*="\/activate"]');
				$links
					.off('click.load_login_links')
					.on('click.load_login_links', function(e) {
						if (jQuery(this).hasClass('js-login_dont_intercept')) {
							return;
						}
						yalwa.basics.auth.redirect_to = jQuery(this).attr('href');
						pub.show_dialog(e);
					});
			}
		};

		pub.update_logout_handlers = function() {
			jQuery('.js-logout').off('click.logout_main').on('click.logout_main', function(e) {
				yalwa.basics.before_logout();
				e.preventDefault();
				yalwa.basics.auth.logout().done(function(response) {
					if (response.success) {
						yalwa.basics.toast({message: response.message, type: 'success'});
						yalwa.mobile.burger.menu_hide(false);
						if (yalwa.v.is_phonegap) {
							cordova_logout(response);
						} else {
							mobile_logout(response);
						}
					} else {
						yalwa.basics.toast({message: response.message, type: 'error'});
					}
				});
				return false;
			});
		};

		function cordova_logout(response) {
			yalwa.mobile.cordova.cordova_send({action: 'logout', params: {}});
			if (yalwa.basics.yalwapp_version() > 2758) {
				$document.on('logout_success', function() {
					mobile_logout(response);
				});
			} else {
				// backward compatibility
				setTimeout(function() {
					mobile_logout(response);
				}, 2500)
			}
		}

		function mobile_logout(response) {

			//Turn off auto sign-in for future visits
			if (yalwa.basics.auth.credential_api_support() && !yalwa.v.is_phonegap) {
				navigator.credentials.preventSilentAccess();
			}

			setTimeout(function() {
				if (['login', 'logout'].indexOf(yalwa.basics.get_routing()) !== -1) {
					yalwa.basics.navigate(yalwa.basics.get_get('continue') ? yalwa.basics.get_get('continue') : yalwa.v.chp_url);
				} else {
					yalwa.basics.reload(true);
				}
			}, 200);
		}

		pub.show_dialog = function(e, forbid_cancel, default_register) {
			if (!yalwa.basics.readonly_check()) {
				e.preventDefault();
				return false;
			}
			let $clicked_element = false;
			if (e) {
				is_promo_view = jQuery(e.currentTarget).hasClass(promo_auth_class.substring(1));
			}
			if (is_promo_view) {
				promo_view_tracking_data = jQuery(e.currentTarget).data();
			}
			if (e) {
				if (jQuery(e.currentTarget).not($ignored_links).not($login_buttons).length) {
					yalwa.basics.auth.redirect_to = jQuery(e.currentTarget).attr('href');
				}
				$clicked_element = jQuery(e.currentTarget);
			}
			const deferred = jQuery.Deferred();
			const $login = jQuery('.js-login_modal');
			yalwa.mobile.burger.menu_hide(false, true);
			init_register = !!(default_register || ($clicked_element ? (!$clicked_element.hasClass('js-show_login_tab') && !$clicked_element.hasClass('js-default_login') && !$clicked_element.hasClass('js-headroom_login_button')) : false));
			touchpoint = e ? determine_touchpoint(jQuery(e.currentTarget)) : 1;
			if (e) {
				yalwa.basics.auth.o = jQuery(e.currentTarget).data('o');
				yalwa.basics.auth.os = jQuery(e.currentTarget).data('os');
			}
			if (!loaded) {
				const data = [];
				data[yalwa.basics.auth.touchpoint_parameter()] = touchpoint;
				if (pub.autoload()) {
					login_form_init(forbid_cancel);
					yalwa.mobile.magic_link.init(labels.magic_link);
					deferred.resolve();
				} else {
					yalwa.basics.load_template_json_once('template_login_json', jQuery('.js-login_modal'), false, data).done((data) => {
						if (data) {
							jQuery.extend(labels, data.labels);
						}
						prepare_dolteaser_labels();
						login_form_init(forbid_cancel);
						yalwa.mobile.magic_link.init(labels.magic_link);
						deferred.resolve();
					});
				}
				loaded = true;
			} else {
				set_touchpoint(touchpoint).done(function() {
					if ($login.hasClass('hidden')) {
						dialog_show(forbid_cancel);
						show_section(init_register ? 'register' : 'login');
					} else {
						dialog_hide();
					}
					deferred.resolve();
				});
			}
			if (e) {
				e.preventDefault();
			}
			return deferred.promise();
		};

		pub.register_success_handler = function(callback) {
			success_handler = callback;
			return pub;
		};

		function prepare_dolteaser_labels() {
			const profile_name = jQuery('.js-dolteaser_name').html();
			if (labels[31]) {
				Object.keys(labels[31]).forEach( key => {
					labels[31][key] = '<div class="dolteaser__ajax_title">' + labels[31][key] + '<div>';
				})
			}
			if (labels[32]) {
				Object.keys(labels[32]).forEach( key => {
					labels[32][key] = '<div class="dolteaser__ajax_title">' + labels[32][key].replace('%1$s', profile_name) + '<div>';
					labels[32][key] = labels[32][key].replace('yc-em2', 'dolteaser__ajax_name');
				})
			}
		}

		function set_touchpoint(tp) {
			return jQuery.ajax({
				url: '/api/ajax/general',
				type: 'post',
				dataType: 'json',
				data: {
					action: 'set_touchpoint',
					tp: tp
				}
			});
		}

		function determine_touchpoint($element) {
			touchpoint = $element.attr('href') && $element.attr('href') !== '#' ? new URL($element.attr('href')).searchParams.get(yalwa.basics.auth.touchpoint_parameter()) : null;
			touchpoint = $element.data(yalwa.basics.auth.touchpoint_parameter()) ? $element.data(yalwa.basics.auth.touchpoint_parameter()) : touchpoint;
			return touchpoint;
		}

		function prepare_labels() {
			if (!touchpoint) {
				touchpoint = 1;
			}
			const used_label_set = labels[touchpoint] ? labels[touchpoint] : labels['default'];
			jQuery('.js-ajax_login_heading').html(used_label_set.login_heading);
			jQuery('.js-register_link').html(used_label_set.login_subheading);
			jQuery('.js-ajax_register_heading').html(used_label_set.register_heading);
		}

		function show_section(section) {
			jQuery('.js-ltabs_item[data-value="' + section + '"]').trigger('click');
			show_section_event_tracking(section);
		}

		function show_section_event_tracking(section) {
			yalwa.basics.ga.event({
				category: 'ajax_login_show_section',
				action: section,
				label: 'mobile'
			});
		}

		function init_dialog_tabs() {
			if (ajax_login_no_register) {
				jQuery('.js-ltabs').addClass('hidden');
				show_section('login');
				jQuery('.ajax_login__content').addClass('ajax_login__no_register_corners');
				ajax_login_no_register = false;
			} else {
				jQuery('.js-ltabs').removeClass('hidden');
				jQuery('.ajax_login__content').removeClass('ajax_login__no_register_corners');
			}
		}

		function prepare_promo_view($modal) {
			promo_view_track('view');
			yalwa.basics.hide($modal.find('.js-ltabs'));
			yalwa.basics.hide($modal.find('.js-login_section[data-value="login"]'));
			yalwa.basics.hide($modal.find('.js-simple_auto_slide'));
			yalwa.basics.hide($modal.find('.js-ajax_login_down_arrow'));
			const $no_google_button = $modal.find('.js-ajax_register_show_form');
			$no_google_button.find('a').attr('href', yalwa.v.dolteaser_default_onboarding_url ? yalwa.v.dolteaser_default_onboarding_url : yalwa.basics.auth.redirect_to); // we want to use for this link the default onboarding url
			$no_google_button.off('click').on('click',promo_view_track.bind(event, 'click'));
			yalwa.basics.auth.gsi.button_on_click_handler = promo_view_track.bind(event, 'click');
		}

		function prepare_native_ads_event_category(category) {
			const native_ads_version = promo_view_tracking_data.d1.startsWith('native_ads_') ? 'v1' : 'v2';
			switch(native_ads_version) {
				case 'v1':
					category = 'native_ads_ajax_clicks';
					break;
				case 'v2':
					category = 'native_ads2_ajax_clicks';
					break;
			}
			return category;
		}

		function promo_view_track(type) {
			const data = {};
			const category = prepare_native_ads_event_category(promo_view_tracking_data.d1);
			switch(type) {
				case 'view':
					data.category = category.replace('click', 'view');
					data.action = 'all_views';
					break;
				case 'click':
					data.category = category;
					data.action = jQuery(event.currentTarget).hasClass('js-ajax_register_show_form') ? 'no_google' : 'google';
					break;
			}
			yalwa.basics.ga.event(data);
		}

		function reset_promo_view($modal) {
			yalwa.basics.show($modal.find('.js-ltabs'));
			yalwa.basics.show($modal.find('.js-login_section[data-value="login"]'));
			yalwa.basics.show($modal.find('.js-simple_auto_slide'));
			yalwa.basics.show($modal.find('.js-ajax_login_down_arrow'));
			$modal.find('.js-ajax_register_show_form a').attr('href', '#');
			yalwa.basics.auth.gsi.button_on_click_handler = function(){};
		}

		function dialog_show(forbid_cancel) {
			init_toggle_register_form_button();
			init_dialog_tabs();
			const $modal = jQuery('.js-login_modal');
			if (is_promo_view) {
				prepare_promo_view($modal);
			}
			if (pub.autoload()) {
				jQuery('.js-login_modal').detach().appendTo(jQuery('.js-page_unique'));
			} else {
				if (!yalwa.v.is_dol) {
					yalwa.mobile.generic_shadow.show(forbid_cancel ? {} : {onclick: dialog_hide});
				}
			}
			// do not allow chrome to autocomplete before ali initialized
			const $login_id_input = $modal.find('.js-login_id');
			const $login_input_click_area = $login_id_input.closest('label');

			$login_input_click_area.on('click', function() {
				$login_id_input.attr('disabled', false);
			});
			if (!pub.autoload()) {
				prepare_labels();
			}
			yalwa.basics.show($modal);
			$modal.trigger('click');
			$document.trigger('login_dialog_show', null);
		}

		function dialog_hide() {
			if (!pub.autoload()) {
				const $modal = jQuery('.js-login_modal');
				yalwa.mobile.generic_shadow.hide(true);
				yalwa.basics.hide($modal);
				show_register_form_button();
				success_handler = null; // reset success handler
				if (is_promo_view) {
					reset_promo_view($modal);
				}
			}
		}

		function dialog_remove() {
			if (!yalwa.v.is_dol) {
				return;
			}
			jQuery('.js-login_modal').remove();
		}

		/**
		 * public method used from dol.js to hide login/register modal for google login
		 */
		pub.dialog_hide = dialog_hide;
		pub.dialog_remove = dialog_remove;
		let ajax_login_benefits_slider;

		function init_toggle_register_form_button() {
			const $button = jQuery('.js-ajax_register_show_form');
			if (!$button.length) {
				return;
			}
			if (is_promo_view) {
				$button.off('click');
				return;
			}
			const $register_form = jQuery('.js-register_form');
			$button.off('click').on('click', function(event) {
				event.preventDefault();
				ajax_login_benefits_slider.hide();
				yalwa.basics.toggle($button);
				yalwa.basics.toggle($register_form);
			});
		}

		function show_register_form_button() {
			const $button = jQuery('.js-ajax_register_show_form');
			if (!$button.length) {
				return;
			}
			const $register_form = jQuery('.js-register_form');
			yalwa.basics.show($button);
			yalwa.basics.hide($register_form);
			ajax_login_benefits_slider.show();
		}

		function login_form_init(forbid_cancel) {
			if (jQuery('.js-ajax_login_read_only').length) {
				yalwa.basics.toast({
					message: jQuery('.js-ajax_login_read_only').html().replace(/<br>/g, ''),
					type: 'error'
				});
				return;
			}
			yalwa.mobile.ali.init();
			const ltabs_types = {
				login: 'login',
				register: 'register',
				chosen: 'login',
				other: 'register'
			};
			jQuery(document).on('ltabs_login', function() {
				if (jQuery('.ltabs__item--chosen').data('value') === ltabs_types.login) {
					ltabs_types.chosen = ltabs_types.login;
					ltabs_types.other = ltabs_types.register;
				} else {
					ltabs_types.chosen = ltabs_types.register;
					ltabs_types.other = ltabs_types.login;
				}
				jQuery('.js-login_section[data-value="' + ltabs_types.chosen + '"]').addClass('chosen');
				jQuery('.js-login_section[data-value="' + ltabs_types.other + '"]').removeClass('chosen');
			});
			yalwa.mobile.ltabs.init();
			if (pub.autoload() && yalwa.basics.get_routing() === 'registration' || init_register) {
				show_section('register');
			}
			init_register = false;
			jQuery('.js-ajax_register_email').on('enterdown', function() {
				jQuery('.js-ajax_register_submit').trigger('click');
			});
			jQuery('.js-login_pw').on('enterdown', function() {
				jQuery('.js-ajax_login_submit').trigger('click');
			});
			jQuery('.js-login_stay').on('click', function() {
				jQuery(this).toggleClass('checked');
			});
			const $login_submit_button = jQuery('.js-ajax_login_submit');
			const $register_submit_button = jQuery('.js-ajax_register_submit');
			const login_form = $login_submit_button.closest('form')[0];
			const register_form = $register_submit_button.closest('form')[0];
			const validity_support = typeof login_form.checkValidity === 'function';
			const validity_report_support = typeof login_form.reportValidity === 'function';

			// polyfill for html5 reportValidity()
			if (!validity_report_support) {
				login_form.addEventListener('invalid', function(event) {
					if (!jQuery('.locanto_toast').length) {
						yalwa.basics.toast({message: event.target.validationMessage, type: 'error'});
					}
				}, true);
				register_form.addEventListener('invalid', function(event) {
					if (!jQuery('.locanto_toast').length) {
						yalwa.basics.toast({message: event.target.validationMessage, type: 'error'});
					}
				}, true);
			}
			jQuery(login_form).find('.js-login_id').on('enterdown', () => {
				$login_submit_button.trigger('click');
			});
			$login_submit_button.on('click', async function(e) {
				e.preventDefault();
				const $login_id_input = jQuery(login_form).find('.js-login_id');
				// disabled inputs are always valid
				if ($login_id_input.attr('disabled')) {
					$login_id_input.attr('disabled', false);
					$login_id_input.focus();
				}
				if (validity_support && !login_form.checkValidity()) {
					if (validity_report_support) {
						login_form.reportValidity();
					}
					return;
				}
				if (in_progress) {
					return;
				}
				in_progress = true;
				const stay_logged_in = jQuery('.js-login_stay').hasClass('checked') ? 1 : 0;
				let hash = await yalwa.basics.fingerprint.get_hash();
				const login_params = {
					email: jQuery('.js-login_id').val(),
					pw: jQuery('.js-login_pw').val(),
					keep: stay_logged_in,
					csrf_key: jQuery('.js-login_csrf').data('key'),
					csrf_value: jQuery('.js-login_csrf').val(),
					otp_token: null,
					fp_hash: hash,
					remember_browser: false,
				};
				yalwa.basics.auth.login(login_params).done(async (response) => {
					if (response.twofactor_needed) {
						await yalwa.basics.import_js('shared/web_components/twofactor.js');
						jQuery('body').append('<yalwa-twofactordialog></yalwa-twofactordialog>');
						jQuery('yalwa-twofactordialog')[0].request_action('code', {email: jQuery('.js-login_id').val()});
						twofactor_listeners(login_params);
					} else {
						on_login_response(response);
					}
				});
			});
			$register_submit_button.on('click', function(e) {
				if (validity_support && !register_form.checkValidity()) {
					if (validity_report_support) {
						register_form.reportValidity();
					}
					return;
				}
				if (in_progress) {
					return;
				}
				in_progress = true;

				jQuery(this).prop('disabled', true);
				yalwa.basics.auth.register(jQuery('.js-ajax_register_email').val()).done(function(response) {
					in_progress = false;
					if (response.success) {
						if (response.is_dol) {
							$document.trigger('dol_registration_email_success', [jQuery('.js-ajax_register_email').val()]);
						} else {
							dialog_hide();
							$body.append(response.html);
							setTimeout(function() {
								yalwa.mobile.check_for_detach();
								jQuery('.js-ajax_register_plp').trigger('plp_show').on('plp_hide', function() {
									$document.trigger('dol_show_ajax_login', null);
								});
							}, 500);
						}
					} else {
						e.target.disabled = false;
						if (yalwa.v.is_dol && response.email_exists) {
							if ((yalwa.basics.ls_get('dol_login_helper_seen_times') < 3
								&& !yalwa.basics.ls_get('dol_login_helper_DNS')) || response.is_dating_only_user) {
								setTimeout(() => {
									yalwa.dol_onboarding.show_login_helper(response.is_dating_only_user);
								}, 300);
							}
							show_section('login');
							let $login_id = jQuery('.js-login_id');
							$login_id.val(jQuery('.js-ajax_register_email').val());
							$login_id.parent('.js-li').addClass('js-ali-infocus');
							// DEV-1039 BOF
							const $login_modal = jQuery('.js-login_modal');
							$login_modal.find('.js-login_id').focus();
							window.setTimeout(function() {
								$login_modal.find('.js-login_pw').focus();
							}, 200);
							// DEV-1039 EOF
							yalwa.basics.ga.event({
								category: 'dol_registration_error',
								action: 'email_exists',
							});
						} else {
							yalwa.basics.ga.event({
								category: 'dol_registration_error',
								action: response.text,
							});
							yalwa.basics.toast({title: response.title, message: response.text, type: 'error'});
						}
					}
				});
			});
			jQuery('.js-social_media_login_info').on('click', function(event) {
				jQuery('.js-social_media_login_info_details').toggle();
				event.preventDefault();
			});
			prepare_register_hint_label();
			prepare_login_hint_label();
			dialog_show(forbid_cancel);
			yalwa.basics.auth.gsi.render_button();
			ajax_login_benefits_slider = new yalwa.basics.simple_auto_slide({
				css_prefix:'ajax_login__'
			});
			ajax_login_benefits_slider.start();
			init_google_cordova_button();
			init_apple_cordova_button();
			$document.trigger('login_dialog_initialized');
		}

		function twofactor_listeners(login_params) {
			dialog_hide();
			jQuery(document).on_once('twofactor-code-submitted.login', 'yalwa-twofactordialog', async function(event) {
				const data = event.originalEvent.detail;
				login_params.otp_token = data.code || data.backup_code;
				login_params.remember_browser = data.remember_browser;
				yalwa.basics.auth.login(login_params).done((response) => {
					if (response.twofactor_needed) {
						jQuery('yalwa-twofactordialog')[0].show_invalid();
					} else {
						jQuery('yalwa-twofactordialog')[0].close();
						on_login_response(response);
					}
				});
			});
			jQuery(document).on_once('twofactor-dialog-closed.login', 'yalwa-twofactordialog', function() {
				in_progress = false;
				dialog_show();
			});
		}

		function on_login_response(response) {
			in_progress = false;
			if (response.success) {
				yalwa.v.is_logged_in = true;
				yalwa.basics.toast({message: response.message, type: 'success'});
				jQuery('.js-headroom_login_button').remove();
				yalwa.basics.webpush.unsubscribe();
				if (success_handler) {
					success_handler();
				} else {
					setTimeout(function() {
						if (yalwa.basics.auth.redirect_to) {
							yalwa.basics.navigate(yalwa.basics.auth.redirect_to)
						} else {
							yalwa.basics.reload();
						}
					}, 500);
				}
				dialog_hide();
				//make sure login success message visible enough
				window.setTimeout(function() {
					$document.trigger('login_successful', [response.has_dol, response.show_pledge]);
				}, 441);
			} else {
				yalwa.basics.toast({message: response.message, type: 'error'});
			}
		}

		function init_google_cordova_button() {
			jQuery('body').on('click', '.js-login_alternatives_google_app', function() {
				if (yalwa.v.is_ios_app) {
					yalwa.mobile.cordova.google_login_request('login_ios');
				} else {
					yalwa.mobile.cordova.google_login_request('sign_in');
				}
			});
		}

		function init_apple_cordova_button() {
			jQuery('body').on('click', '.js-login_alternatives_apple_app', function() {
				if (yalwa.v.is_ios_app) {
					pub.apple_login();
				}
			});
		}

		function prepare_register_hint_label() {
			const $register_link = jQuery('.js-register_hint a');
			$register_link.on('click', function(e) {
				e.preventDefault();
				show_section('register');
			});
		}

		function prepare_login_hint_label() {
			const $login_link = jQuery('.js-login_hint a');
			$login_link.on('click', function(e) {
				e.preventDefault();
				show_section('login');
			});
		}

		//Apple login
		pub.apple_login = function () {
			yalwa.mobile.cordova.cordova_send({
				action: 'apple_login',
				params: {
					type: 'login'
				}
			});
		}

		return pub;

	}(pub.auth));

	function init_dol_promos() {
		var $not_now_btn = jQuery('.js-dol_top_promo_not_now');
		var cookie_name = 'dol_top_promo_hide';
		if ($not_now_btn.length) {
			yalwa.basics.ga.event({
				category: 'dol_promo_view',
				action: 'top_promo_dialog'
			});
			var $dialog = jQuery('.js-dol_top_promo_dialog');
			$not_now_btn.on('click', function() {
				$dialog.velocity("transition.flipXOut", {delay: 50});
				if (yalwa.basics.get_cookie(cookie_name)) {
					yalwa.basics.set_cookie(cookie_name, 2, 2592000);
				} else {
					yalwa.basics.set_cookie(cookie_name, 1, 2592000);
				}

			});
		}
	}

	function load_alert_add(data) {
		return yalwa.basics.load_template_once('template_alert_add', jQuery('.js-snh_abo_new'), $body, data);
	}

	function load_burger() {
		return yalwa.basics.load_template_once(
			'template_burger',
			jQuery('.js-burger_menu'),
			yalwa.mobile.matches_breakpoint('desktop') ? jQuery('.js-ovw_desktop_header_right') : $main_col, {
				routing: yalwa.basics.get_routing(),
				tab: yalwa.mobile.htabs.get(),
				home_link: jQuery('.js-ytbt_home').attr('href') || '',
				this_url: location.href,
				loggedin_expected: yalwa.basics.is_logged_in() ? 1 : 0
			});
	}

	function load_history() {
		return yalwa.basics.load_template_once('template_history', jQuery('.js-history_card'), jQuery('.js-history_card_container'));
	}

	function logo_init() {
		if (window.performance) {
			var touchstart;
			var $l = jQuery('.js-logo_link');
			$l.on('touchstart', function() {
				touchstart = window.performance.now();
			}).on('touchend', function() {
				if (window.performance.now() - touchstart < 200) {
					var url = $l.attr('href');
					if (url) {
						yalwa.basics.navigate(url);
					}
				}
			});
		}
	}

	pub.burger = (function(pub) {

		pub = pub || {};

		let $bm;
		let in_progress = false;
		let init = false;

		pub.init = function(lazyloaded) {
			if (init) {
				return;
			}
			yalwa.mobile.check_for_detach();
			$bm = jQuery('.js-burger_menu');
			if (!$bm.length) {
				return;
			}
			init = true;
			$bm.find('.js-post_ad').on('click', yalwa.basics.js_post_ad_click);
			yalwa.basics.state.register('burger_menu', function() {
				if (pub.is_currently_opened()) {
					yalwa.mobile.burger.menu_hide(true);
					return true;
				}
			});
			jQuery('.js-burger_menu_open').on('click', menu_toggle);
			jQuery('.js-burger_counter').each(function() {
				const $this = jQuery(this);
				if ($this.text() === '0') {
					yalwa.basics.hide($this);
				}
			});
			if (lazyloaded) {
				menu_toggle();
			}
			share_init();
			if (yalwa.v.is_phonegap) {
				// delegated: the burger menu is lazyloaded and re-rendered, so a direct
				// binding can miss the element or land twice
				jQuery(document).off('click.force_app_rating').on('click.force_app_rating', '.js-force_app_rating_dialog', function() {
					yalwa.basics.ls_set('feedback_sent', null);
					yalwa.mobile.app_rating.show();
				});
			} else if (
				yalwa.basics.webpush.prerequisites_met()
				&& yalwa.basics.webpush.is_default()
				&& !yalwa.v.webpush_ask_on_init
			) {
				pub.show_push_options();
			}
			yalwa.mobile.auth.update_login_handlers();
			yalwa.mobile.auth.update_logout_handlers();
			yalwa.mobile.init_followers_popup();
			jQuery('.js-dol_burger_menu_link').on('click', handle_dol_click);

			if (pwa_prompt || yalwa.v.can_show_burger_app_download_prompt) {
				jQuery('.js-pwa_promotion_burger').removeClass('hidden');
			}
			$document.trigger('burger_menu_loaded');
		};

		pub.show_push_options = function() {
			yalwa.basics.show(jQuery('.js-webpush_ask'));
			jQuery('.js-webpush_ask').on('click', yalwa.basics.webpush.ask_or_update_existing);
		};

		pub.menu_hide = function(animation, keep_shadow) {
			if (yalwa.v.is_ios) {
				yalwa.basics.bem_modifier($main_col, 'overflow_hidden', 'remove');
			}
			if (!init) {
				return;
			}
			jQuery('.js-mbody').off('click.burger_menu');
			if (animation) {
				$bm.velocity("transition.slideLeftOut", {duration: 250, display: '', complete: after_slide});
			} else {
				after_slide();
			}
			if (!keep_shadow) {
				yalwa.mobile.generic_shadow.hide(true);
			}
			jQuery('html').css({
				minHeight: null,
				overflow: null
			})
			yalwa.basics.show(jQuery('.js-ybtb_mc'));
			yalwa.basics.state.try_cancel('burger_menu');
		};

		pub.is_currently_opened = function() {
			return jQuery('.js-burger_menu').length && !jQuery('.js-burger_menu').hasClass('hidden');
		};

		function menu_toggle() {
			const $btn = jQuery('.js-burger_menu_open');
			if (pub.is_currently_opened()) {
				yalwa.mobile.burger.menu_hide(true);
				$btn.removeClass('ovw_desktop_header__avatar--opened');
			} else {
				menu_show();
				$btn.addClass('ovw_desktop_header__avatar--opened');
			}
		}

		function after_slide() {
			yalwa.basics.hide($bm);
		}

		function show_complete() {
			jQuery('.js-mbody').on('click.burger_menu', body_click);
			setTimeout(function() {
				in_progress = false; // ios strangeness #36300
			}, 400);
		}

		function menu_show() {
			$bm.css({'--additional_top_padding': $main_col.css('--additional_top_padding')});
			if (yalwa.v.is_ios) {
				yalwa.basics.bem_modifier($main_col, 'overflow_hidden', 'add');
			}
			in_progress = true;
			$bm.velocity("transition.slideLeftIn", {duration: 250, display: '', complete: show_complete});
			yalwa.basics.show($bm);
			if (jQuery('.js-ovw_desktop_header').is(':visible')) {
				calc_height();
				if (yalwa.basics.current_device_classification() === 'desktop') {
					calc_width();
					check_h1_position();
				}
				setTimeout(calc_height, 200);
				setTimeout(function() {
					if (yalwa.basics.current_device_classification() !== 'desktop') {
						yalwa.mobile.generic_shadow.show({duration: 0, zindex:7});
					}
				}, 40); // avoids flickering on iOS
			} else {
				setTimeout(function() {
					yalwa.mobile.generic_shadow.show({duration: 0});
				}, 40); // avoids flickering on iOS
			}
			yalwa.basics.state.push('burger_menu');
			yalwa.basics.hide(jQuery('.js-ybtb_mc'));
		}

		function body_click(e) {
			const $btn = jQuery('.js-burger_menu_open');
			if (in_progress || jQuery(e.target).closest('.js-burger_menu,.js-ybtb,.js-headroom').length) {
				return;
			}
			yalwa.mobile.burger.menu_hide(true);
			$btn.removeClass('ovw_desktop_header__avatar--opened');
		}
		function calc_width() {
			// jQuery('.js-burger_menu').css({width: jQuery('.js-burger_menu_open').outerWidth()});
		}
		function calc_height() {
			const excluded_routes = ['mc', 'mc_gallery'];
			if (excluded_routes.indexOf(yalwa.basics.get_routing()) !== -1) {
				return;
			}
			jQuery('.js-burger_menu').css({height: jQuery('.js-burger_primary').height() + jQuery('.burger_menu__header').height()});
		}

		return pub;

	}(pub.burger));

	pub.premium_tracking = (function(pub) {
		pub = pub || {};
		let has_ads_posted = 'unknown';
		pub.init = function() {
			if (yalwa.basics.is_logged_in()) {
				if (yalwa.v.count_active_ads > 0) {
					has_ads_posted = 'yes';
				} else {
					has_ads_posted = 'no';
				}
			}
			jQuery('.js-premium_tracking').on('click', function() {
				let touchpoint_name = jQuery(this).data('touchpoint-name');
				let overwrite = false;
				if (touchpoint_name == 'my_ads_pf'
					&&
					(  yalwa.basics.ls_get('last_premium_touchpoint_name') == 'bp_gallery'
					|| yalwa.basics.ls_get('last_premium_touchpoint_name') == 'vap_pf_promo_banner'
					|| yalwa.basics.ls_get('last_premium_touchpoint_name') == 'mandatory_paf_pf_interstitial'
					|| yalwa.basics.ls_get('last_premium_touchpoint_name') == 'paf_pf_interstitial'
					)
				) {
					// overwrite my_ads_pf touchpoint with initial touchpoint
					// https://yalwa.atlassian.net/browse/DEV-11742?focusedCommentId=100160
					overwrite = true;
					touchpoint_name = yalwa.basics.ls_get('last_premium_touchpoint_name');
				}
				yalwa.basics.ls_set('last_premium_touchpoint_name', touchpoint_name);
				if (overwrite) {
					// in this case, we do not want to have an additional click tracking
					return true;
				}
				yalwa.basics.ga.datalayer({
					'event': 'pf_touchpoint_click',
					'pf_touchpoint_name': touchpoint_name,
					'ovw_enabled': true,
					'pf_device': yalwa.basics.current_device_classification(),
					'has_ads_posted': has_ads_posted
				});

			});

		}


		pub.init_page = function(page) {
			const event = 'pf_' + page; // e.g. pf_shopping_cart
			let touchpoint_name = yalwa.basics.ls_get('last_premium_touchpoint_name');
			let last_premium_tracked_event = yalwa.basics.ls_get('last_premium_tracked_event');
			// on my_ads page, check if the user comes from a valid touchpoint leading to my_ads:
			if (event == 'pf_my_ads' && touchpoint_name != 'bp_gallery' && touchpoint_name != 'vap_pf_promo_banner') {
				reset_pf_tracking();
				return;
			}
			// check if the user comes from a touchpoint, if so do the datalayer tracking and delete the last touchpoint name:
			if (touchpoint_name) {
				// do not track an event twice on the same page
				if (last_premium_tracked_event == event) {
					return;
				}
				yalwa.basics.ga.datalayer({
					'event': event,
					'pf_touchpoint_name': touchpoint_name,
					'ovw_enabled': true,
					'pf_device': yalwa.basics.current_device_classification(),
					'has_ads_posted': has_ads_posted
                });
				if (event == 'pf_successful_purchase') {
					reset_pf_tracking();
				} else {
					yalwa.basics.ls_set('last_premium_tracked_event', event);
				}

			}
		}

		function reset_pf_tracking() {
			yalwa.basics.ls_remove('last_premium_touchpoint_name');
			yalwa.basics.ls_remove('last_premium_tracked_event');
		}

		return pub;

	}(pub.premium_tracking));

	pub.snh = (function(pub) {
		pub = pub || {};
		let $placeholder;
		let $snh_container;
		let snh_selected_item = false;
		let $search_input;
		let $search_input_clear;
		let $location_input;
		let $category_input;
		let $category_placeholder;
		let $category_icon_placeholder;
		let $category_root;
		let $distance_helper;
		let $distance_select;
		let distance_start_value;
		let category_start_id;
		let geo_start_id;
		let query_on_start;
		let $area;
		let is_state = false;
		let is_nationwide_city = false;
		let areaID = false;
		let snh_inputs;
		let selected_geoid;
		let snh_select_silently_in_progress = false;
		let snh_location_select_in_progress = false;
		let current_geoID;
		let snh_default_search_url;
		let snh_default_distance;
		let snh_search_params;
		let snh_search_options;
		let $history_button;
		let enter_click;
		let last_selected_suggestion;
		const android_keyboard_close_detector = new AndroidKeyboardCloseDetector(on_keyboard_close);

		pub.values_object = {};

		pub.init = function() {
			if (get_routing() === 'mc') {
				country_select_init();
				return;
			}
			if (typeof yalwa.v.filter_data === 'object') {
				Object.freeze(yalwa.v.filter_data)
			} else {
				yalwa.v.filter_data = Object.freeze({});
			}
			jQuery('.js-show_remaining_cities').on('click', () => {
				jQuery('.js-city.hidden').removeClass('hidden').velocity('fadeIn', {display: '', duration: 1200});
				yalwa.basics.hide(jQuery('.js-show_remaining_cities'));
			});

			pub.new_search_filter_data = jQuery.extend({}, yalwa.v.filter_data) || {};
			$snh_container = jQuery('.js-snh');
			is_state = yalwa.v.is_state || false;
			is_nationwide_city = yalwa.v.is_nationwide_city || false;
			$search_input = jQuery('.js-snh_search');
			$search_input_clear = jQuery('.js-snh_close');
			$location_input = jQuery('.js-places_suggest');
			$category_input = jQuery('.js-snh_category');
			$category_placeholder = jQuery('.js-snh_ltw_input');
			$category_icon_placeholder = jQuery('.js-snh_categories_icon');
			$category_root = jQuery('.js-snh_ltw .js-ltw');
			$distance_helper = jQuery('.js-snh_select_helper');
			$distance_select = $distance_helper.find('select');
			distance_start_value = $distance_select.val();
			category_start_id = $category_root.data('ltw_start_id');
			geo_start_id = $category_root.data('geoid');
			query_on_start = $search_input.val();
			$area = jQuery('.js-location_area');
			$history_button = jQuery('.js-ybtb_button_browse_history');
			snh_inputs = [$search_input, $location_input, $category_input, $history_button];
			selected_geoid = yalwa.v.current_geoID ? parseInt(yalwa.v.current_geoID) : false;
			current_geoID = yalwa.v.vap_nationwide_context ? 0 : yalwa.v.current_geoID;
			snh_default_search_url = $snh_container.data('url');
			snh_default_distance = parseInt(yalwa.v.default_distance) || 0;
			snh_search_params = {
				mobile: 1,
				L1: yalwa.v.search_suggested_L1 || 0,
				L2: yalwa.v.search_suggested_L2 || 0,
				L3: yalwa.v.search_suggested_L3 || 0,
				current_geoID: current_geoID || 0
			};
			snh_search_options = {
				triggerSelectOnValidInput: false,
				serviceUrl: '/api/ajax/search_autocomplete',
				sessionCache: true,
				minChars: 3,
				params: snh_search_params,
				width: 'flex',
				paramName: 'keyword',
				deferRequestBy: 0,
				preventBadQueries: false,
				appendTo: '.js-snh_suggestions',
				position: 'relative',
				containerClass: 'snh__suggestions_autocomplete',
				classes: {
					selected: 'snh__suggestions_autocomplete_item_selected',
					suggestion: 'snh__suggestions_autocomplete_item'
				},
				transformResult: function(response) {
					let result = typeof response === 'string' ? $.parseJSON(response) : response;
					last_selected_suggestion = {contains_cityname: result.contains_cityname, is_vacational: result.is_vacational};
					return result;
				},
				onSearchStart: function(params) {
				},
				onSearchComplete: function(term, suggestions) {
					if (!jQuery(this).is(':focus')) {
						jQuery(this).autocomplete('hide');
					}
				},
				onSelect: function(suggestion) {
					snh_selected_item = suggestion;
					if (snh_select_silently_in_progress) {
						snh_select_silently_in_progress = false;
					} else {
						snh_select_suggested_category(suggestion);
					}
				},
				onChange: function() {
				},
				onBlur: function() {
					// for testing purposes
					//return true; // override default onBlur behaviour
				},
				onHide: function() {
				},
				beforeRender: function($container, suggestions) {
					// for testing purposes
				},
				formatResult: function(suggestion, currentValue) {
					// Do not replace anything if the current value is empty
					if (!currentValue) {
						return suggestion.value;
					}
					let n = (suggestion.type === 'category' ? suggestion.suggested_l3 : suggestion.suggested_keyword);
					return suggestion.l1_icon + '<span class="snh__suggestions_autocomplete_name">' + n + '</span>';
				},
				onHint: function(param) { //debugging functions do not remove
				}
			};
			$snh_container.on('click', snh_placeholder_open);
			$search_input
				.on('input', search_input_input_handler)
				.on('keydown', search_input_keydown_handler);
			$category_input
				.on('click', function() {
					close_modals('js-ltw_root');
					yalwa.basics.show($category_root.trigger('ltw_opened'));
					ltw.toggle('default');
				});
			$search_input_clear.on('click', clean_search_input);
			$category_root.on('click', '.js-ltw_option', snh_ltw_click_handler);

			snh_dropdown_handler_init_once();
			snh_browse_history_init_once();
			snh_go_init();
			snh_search_init_once();
			snh_location_search_init_once();
			jQuery('.js-refine_search').one('click', snh_placeholder_open);
			jQuery('.js-search_filter_button').on('click', load_search_filter);
			snh_set_selected_category();
			pub.can_be_searched();
			if (jQuery('.js-ticker_list').length) {
				yalwa.basics.import_js('mobile/modules/ticker.js').then((Module) => {
					jQuery('.js-ticker_list').each(function(i, e) {
						const $list = jQuery(e);
						if ($list.find('.js-ticker_item').length >= 3) {
							new Module.Ticker($list);
						}
					});
				});
			}
			country_select_init();
		};

		function clean_search_input(event) {
			$search_input.val('').trigger('change');
			yalwa.basics.hide(jQuery(this));
		}

		function country_select_init() {
			if (jQuery('.js-country_select').length) {
				jQuery('.js-country_select').each(function(index) {
					const country_select = new CountrySelect(jQuery(this));
					country_select.init();
				})
			}
		}

		function load_search_filter() {
			yalwa.basics.load_css(yalwa.basics.static_url('css') + 'mobile/sites/bsp/search_filter.css');
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'mobile/search_filter.js');
		}

		pub.can_be_searched = function() {
			const can_be_searched = is_query_changed() || is_geoid_changed() || is_category_changed() || is_distance_changed() || any_special_filter_in_use();
			if (can_be_searched) {
				jQuery('.js-snh_go').prop('disabled', false);
				return true;
			} else {
				jQuery('.js-snh_go').prop('disabled', true);
				return false;
			}

		};

		function is_location_mandatory() {
			return false;
			return !jQuery('.js-search_filter').is(':visible') && yalwa.basics.get_routing() === 'search_nationwide' && !Object.entries(pub.new_search_filter_data).length;
		}

		function get_search_start_url() {
			if (yalwa.v.is_distribution_page) {
				return location.protocol + '//' + location.host + location.pathname;
			}
			return yalwa.v.chp_url + yalwa.v.path_segment + '/q/';
		}

		pub.fire = function(url, select_only = false) {
			if (yalwa.basics.snh_navigation_started) {
				return false;
			}
			if (url && url !== 'undefined' && !select_only) {
				jQuery('.js-snh_go').prop('disabled', true);
				yalwa.basics.snh_navigation_started = true
				yalwa.basics.navigate(url);
				return false;
			}
			jQuery('.js-snh').find('[name]').each(function(i, e) {
				const $e = jQuery(e);
				if ($e.val() && !$e.attr('disabled')) {
					pub.values_object[$e.attr('name')] = $e.val();
				} else {
					delete pub.values_object[$e.attr('name')];
				}
			});
			if (
				jQuery.isEmptyObject(pub.values_object) &&
				!yalwa.mobile.snh.new_search_filter_data['uuna'] // allow user updates new ads search
			) {
				jQuery('.js-snh_go').prop('disabled', true);
				return;
			}
			geoid_chosen = yalwa.v.selected_geoid || (yalwa.v.vap_nationwide_context ? 0 : yalwa.v.current_geoID);
			geoid_chosen = parseInt(geoid_chosen);
			if (!select_only) {
				yalwa.mobile.app_progress();
			}
			if (!select_only) {
				query_handling_before_send();
			}

			const start_url = get_search_start_url();

			if (pub.values_object.query && !jQuery('.js-search_filter').is(':visible')) {
				prepare_default_search();
			}

			if (pub.values_object['c[type]']) {
				pub.values_object.c_type = pub.values_object['c[type]'];
				delete pub.values_object['c[type]'];
			}

			if (start_url.search('query=') !== -1 && pub.values_object.query) {
				delete pub.values_object.query;
			}

			if (pub.values_object.dist === 'max') {
				delete pub.values_object.dist;
				pub.values_object.geoid = -1;
			}
			if (parseInt(pub.values_object.dist) === parseInt(snh_default_distance)) {
				delete pub.values_object.dist;
			}
			if (
				[0,-1].indexOf(geoid_chosen) > -1 &&
				is_location_mandatory() &&
				!select_only
			) {
				yalwa.basics.progress.stop();
				yalwa.basics.toast({message: yalwa.v.lang.search_location_error, type: 'error'});
				$location_input
					.focus()
					.velocity('callout.shake');
				return;
			}
			if (
				geoid_chosen === -1 ||
				(
					geoid_chosen === 0 &&
					(
						yalwa.v.vap_nationwide_context ||
						parseInt(yalwa.v.current_geoID) === 0
					)
				)
			) {
				if (pub.values_object.area) {
					if (!pub.values_object.query) {
						pub.values_object.query = pub.values_object.area;
					} else {
						pub.values_object.query += ' ' + pub.values_object.area;
					}
					delete pub.values_object.area;
				}
				delete pub.values_object.geoid;
			} else {
				pub.values_object.geoid = geoid_chosen;
			}

			let new_url;

			const recursive_encoded_params = [];
			if (pub.values_object && pub.values_object?.query === '') {
				delete pub.values_object.query; // an empty query parameter changes serverside-redirection logic
			}
			// please do not merge objects
			// if you need any merging make it in yalwa.search_filter.handle_values_object()
			if (jQuery.param(pub.values_object).length) {
				if (yalwa.search_filter) {
					yalwa.search_filter.handle_values_object();
				}
				recursive_encoded_params.push(jQuery.param(pub.values_object));
			}
			if (!yalwa.search_filter && yalwa.mobile.snh.is_l1_changed()) {
				pub.new_search_filter_data = {};
			}
			if (jQuery.param(pub.new_search_filter_data).length) {
				recursive_encoded_params.push(jQuery.param(pub.new_search_filter_data));
			}
			if (recursive_encoded_params.length) {
				new_url = start_url + (start_url.indexOf('?') === -1 ? '?' : '&') + recursive_encoded_params.join('&');
			}

			if (yalwa.v.change_hostname) {
				new_url = new_url.replace(location.hostname, yalwa.v.change_hostname);
			}

			if (select_only) {
				if (pub.can_be_searched()) {
					jQuery('.js-snh_go').prop('disabled', false);
				} else {
					jQuery('.js-snh_go').prop('disabled', true);
				}
			}

			if (new_url && !select_only) {
				if (!pub.can_be_searched()) {
					yalwa.basics.progress.stop();
				} else {
					yalwa.basics.navigate(new_url);
				}
			}
		};

		pub.is_l1_changed = function() {
			return yalwa.mobile.snh.values_object.hasOwnProperty('l1') && yalwa.mobile.snh.values_object.l1 !== yalwa.v.l1;
		};

		const query_handling_before_send = _ => {
			const value = pub.values_object.query ? pub.values_object.query : '';
			pub.values_object.query = value.toLowerCase();
		}

		function search_input_input_handler() {
			pub.can_be_searched();
			yalwa.basics.toggle($search_input_clear, jQuery(this).val());
		}

		function search_input_keydown_handler(e) {
			enter_click = e.which === 13;
			if (
				enter_click &&
				$search_input.autocomplete().isExactMatch($search_input.autocomplete().currentValue)
			) {
				snh_select_silently_in_progress = false;
				$search_input.autocomplete('select', 0);
				return;
			}

			if (
				enter_click &&
				$search_input.autocomplete().selectedIndex === -1
			) {
				pub.fire(null, false);
			}
		}

		function any_special_filter_in_use() {
			return Object.keys(yalwa.mobile.snh.new_search_filter_data).length ||
				(yalwa.v.filter_data && Object.keys(yalwa.mobile.snh.new_search_filter_data).length !== Object.keys(yalwa.v.filter_data).length)
				;
		}

		function disable_distance_selector() {
			$distance_select.prop('disabled', true);
			$distance_helper.addClass('disabled');
		}

		function enable_distance_selector() {
			$distance_select.prop('disabled', false);
			$distance_helper.removeClass('disabled');
		}

		function is_query_changed() {
			let query = $search_input.val();
			if (query_on_start === query) {
				return false;
			} else {
				return true;
			}
		}

		function is_distance_changed() {
			if (distance_start_value === $distance_select.val()) {
				return false;
			} else {
				return true;
			}
		}

		function is_geoid_changed() {
			if (geo_start_id === $category_root.data('geoid') || $category_root.data('geoid') === 0) {
				return false;
			} else {
				return true;
			}
		}

		function is_category_changed() {
			if (category_start_id === $category_root.data('ltw_start_id')) {
				return false;
			} else {
				return true;
			}
		}

		function snh_browse_history_init_once() {
			$history_button.one('click', function() {
				load_history().done(function() {
					history_init();
					$history_button.on('click', browse_history_click_handler).trigger('click');
				});
			});
		}

		function browse_history_click_handler() {
			browse_history_icon_toggle();
			browse_history_toggle();
			$search_input.autocomplete('hide');
		}

		function browse_history_close() {
			close_modals();
			yalwa.basics.toggle(jQuery('.js-history_card'), false);
			yalwa.basics.toggle(jQuery('.js-browse_history'), false);
			yalwa.basics.toggle(jQuery('.js-history_card_container'), false);
		}


		function browse_history_icon_toggle() {
			if (!jQuery('.js-history_card').children().length) {
				return;
			}
			const $icon = $history_button.find('.yimage');
			yalwa.basics.yimage_toggle($icon, 'history--gray', 'history--blue');
		}
		function browse_history_button_hide() {
			history_icon_color_change_to('gray');
			yalwa.basics.hide($history_button);
		}
		
		function history_icon_color_change_to(color) {
			const $icon = $history_button.find('.yimage');
			yalwa.basics.yimage_change('history--' + color, $icon);
		}

		function snh_go_init() {
			jQuery('.js-snh_go').on('click', function() {
				pub.fire();
			});
		}

		function browse_history_button_show() {
			yalwa.basics.show($history_button);
		}

		function snh_placeholder_open() {
			ltw.select_only = true;
			jQuery('.js-bsp_search').addClass('invisible');
			yalwa.basics.hide(jQuery('.js-narrow_search'));
			yalwa.basics.show(jQuery('.js-snh_modal'));
			browse_history_button_show();
			if (yalwa.v.is_distribution_page) {
				$document.off('click.snh_body', snh_body_click_handler).on('click.snh_body', snh_body_click_handler);
			} else if (window.matchMedia('(max-width: 1079px)').matches) {
					yalwa.mobile.generic_shadow.show_queued({
						zindex:2,
						namespace: 'snh',
						onclick: snh_modal_close
					});
					jQuery('.js-mbody').css('overflow', 'hidden');
			} else {
				$document.off('click.snh_body', snh_body_click_handler).on('click.snh_body', snh_body_click_handler);
			}
			yalwa.basics.hide(jQuery('.js-ybtb'));
		}

		function snh_body_click_handler(event) {
			if (event.originalEvent && !event.originalEvent.composedPath().includes(jQuery('.js-snh')[0])) {
				snh_modal_close();
				$document.off('click.snh_body', snh_body_click_handler);
			}
		}

		function snh_modal_close() {
			jQuery('.js-mbody').css('overflow', '');
			yalwa.basics.hide(jQuery('.js-snh_modal'));
			yalwa.mobile.generic_shadow.hide_queued();
			close_modals();
			yalwa.basics.hide(jQuery('.js-history_card'));
			yalwa.basics.hide(jQuery('.js-browse_history'));
			yalwa.basics.hide(jQuery('.js-history_card_container'));
			yalwa.basics.show(jQuery('.js-ybtb'));
			$search_input.autocomplete('hide');
			browse_history_button_hide();
			ltw.hide();
		}

		function snh_search_init_once() {
			if ($search_input.length) {
				$search_input.autocomplete(snh_search_options);
			}
		}

		function snh_dropdown_handler_init_once() {
			snh_inputs.map($input => {
				$input.on('click', function(event) {
					snh_hide_other_dropdowns(jQuery(this));
				});
				$input.on('focus', android_keyboard_close_detector.start);
			});
		}

		function close_all_dropdowns() {
			snh_hide_other_dropdowns(jQuery());
		}

		function on_keyboard_close() {
			snh_hide_other_dropdowns($history_button);
		}

		function snh_hide_other_dropdowns($input) {
			snh_inputs.map(function($other_input, index) {
				if ($other_input[0] !== $input[0]) {
					if (typeof $other_input.autocomplete === 'function') {
						if (snh_location_select_in_progress) {
							snh_location_select_in_progress = false;
							if (yalwa.v.selected_geoid > 0) {
								$location_input.autocomplete('select', 0);
							}
						}
						$other_input.autocomplete('hide');
					}
					if ($other_input.hasClass('js-snh_category')) {
						ltw.hide();
					}
					if ($other_input.hasClass('js-ybtb_button_browse_history')) {
						browse_history_close();
						if ($input.hasClass('js-snh_search')) {
							history_icon_color_change_to('gray');
						}
					}
				}
			})
		}

		function snh_distance_handler(suggestion) {
			const default_distance = suggestion.default_distance || 0;
			is_state = suggestion.is_state || false;
			is_nationwide_city = suggestion.is_nationwide_city || false;
			$distance_select.val(default_distance);
			if (!suggestion.areaID) {
				snh_distance_disable_first_option();
			} else {
				snh_distance_enable_first_option();
			}
			snh_distance_prepare_options();
		}

		function snh_distance_prepare_options() {
			$distance_select.find('option').each(function() {
				jQuery(this).html(jQuery(this).data('html')); // reset
				if (jQuery(this).filter(':selected').length) {
					jQuery(this).html(yalwa.v.lang.default_distance);
					snh_default_distance = jQuery(this).val();
				}
			});
		}

		function snh_distance_prepare_options_initial() {
			$distance_select.find('option').each(function() {
				jQuery(this).data('html', jQuery(this).html());
				if (jQuery(this).val() === yalwa.v.default_distance) {
					jQuery(this).html(yalwa.v.lang.default_distance);
				}
			});
		}

		function snh_distance_init_once() {
			$distance_select.on('input', function() {
				pub.can_be_searched();
			});
			if (!yalwa.v.areaID) {
				snh_distance_disable_first_option();
			} else {
				snh_distance_enable_first_option();
			}
			snh_distance_prepare_options_initial();
		}

		function snh_distance_disable_first_option() {
			$distance_select.find('option').first().attr('disabled', true);
			$distance_select.find('option').first().wrap('<span></span>');
		}

		function snh_distance_enable_first_option() {
			$distance_select.find('option').first().attr('disabled', false);
			if ($distance_select.find('option').first().parent().is('span')) {
				$distance_select.find('option').first().unwrap();
			}
		}

		function snh_location_search_init_once() {
			if (!$area.length) {
				return;
			}
			snh_distance_init_once();
			$location_input.on('input', location_change_icon_handler);
			$location_input.on('enterdown', () => {pub.fire();});
			const observer = new MutationObserver(() => {
				location_change_icon_handler.call($area);
			});
			observer.observe($area[0], { attributes: true, attributeFilter: ['value'] });

			$document.on('geoid_selected', function(event, geoid, hostname_may_have_changed) {
				geoid_chosen_handler(event, geoid, hostname_may_have_changed);
			});
			const options = {
				serviceUrl: '/api/geo/geo_search_autocomplete',
				minChars: 2,
				sessionCache: true,
				params: {
					routing: yalwa.basics.get_routing(),
					skip_states: yalwa.v.is_distribution_page ? 1 : 0
				},
				width: 'flex',
				paramName: 'term',
				deferRequestBy: 0,
				preventBadQueries: true,
				appendTo: '.js-places_autocomplete',
				position: 'relative',
				containerClass: 'snh__suggestions_autocomplete snh__suggestions_autocomplete--location',
				classes: {
					selected: 'snh__suggestions_autocomplete_item_selected',
					suggestion: 'snh__suggestions_autocomplete_item_location'
				},
				onSearchComplete: function(term, suggestions) {
					// if API returns empty array for requested geo search term set geoid to zero.
					// if we don't have any geoid for requested area this triggers area search on snh_fire
					snh_location_select_in_progress = true;
					if (term.length && !suggestions.length) {
						$document.trigger('geoid_selected', [-1]);
						$area.val(term);
					} else {
						// select first suggestion's geoID
						$document.trigger('geoid_selected', [suggestions[0].data]);

						let n = suggestions[0].value,
							pos = n.indexOf(',');
						if (pos !== -1) {
							n = n.slice(0, pos)
						}

						$area.val(n);
						areaID = suggestions[0].areaID;
					}
				},
				onSelect: function(suggestion) {
					snh_distance_handler(suggestion);
					$location_input.attr('data-placeholder', $location_input.attr('placeholder'));
					$location_input.attr('placeholder', $location_input.val());
					$location_input.addClass('dropdown_value_selected');
					$area.val(suggestion.value);
					areaID = suggestion.areaID;
					$location_input.val('');
					$document.trigger('geoid_selected', [suggestion.data]);
					if (suggestion.data > 0) {
						yalwa.v.current_geoID = suggestion.data;
					}
					snh_location_select_in_progress = false;
					jQuery('.js-places_suggest').removeClass('show_mandatory');

				},
				onChange: function() {
				},
				onSearchStart: function() {
				},
				onBlur: function() {
				},
				onHide: function($suggestions) {
				},
				onSearchError: function(e) {
				},
				onHint: function(signal) {
					if (signal === '') {
						// it triggers if user clears the input but since we use the selected city as placeholder clearing is done automatically
						// sends wrong signal disabled
						//$document.trigger('geoid_selected', [0]);
					}
				}
			};

			if ($location_input.length) {
				$location_input.autocomplete(options);
				jQuery('.js-snh_gps').on('click', geolocation_closest);
			}
		}

		function keep_default_filters_and_reset() {
			const keep = {};

			if ('pic' in pub.new_search_filter_data) {
				keep.pic = pub.new_search_filter_data.pic;
			}

			if ('query_description' in pub.new_search_filter_data) {
				keep.query_description = pub.new_search_filter_data.query_description;
			}

			pub.new_search_filter_data = keep;
		}

		function prepare_default_search() {
			if (is_location_mandatory()) {
				return false;
			}
			$category_root.data('ltw_start_id', '');
			$category_root.data('ltw_start_type', 'root');
			reset_ebt_filter();
			snh_set_selected_category();
			keep_default_filters_and_reset();
		}

		function snh_select_suggested_category(suggestion) {
			if (suggestion.type === 'default_search') {
				prepare_default_search();
			}
			let start_id, start_type;
			if (suggestion.l3) {
				start_id = suggestion.l3;
				start_type = 'l3';
			} else if (suggestion.l2) {
				start_id = suggestion.l2;
				start_type = 'l2';
			} else if (suggestion.l1) {
				start_id = suggestion.l1;
				start_type = 'l1';
			} else {
				start_id = '';
				start_type = '';
			}
			$category_root.data('ltw_start_id', start_id);
			$category_root.data('ltw_start_type', start_type);
			snh_set_selected_category();
			$category_placeholder.html(suggestion.suggested_category ? suggestion.suggested_category : yalwa.v.lang.All_categories);
			$category_icon_placeholder.html(suggestion.l1_icon);
			ltw.init_request();
			let suggested_url = (suggestion.url ? suggestion.url : suggestion.popsearch_url);
			last_selected_suggestion = suggestion;
			pub.fire(suggested_url, !suggested_url); // open suggested url
		}

		function snh_clothing_categories_handler($element) {
			const clothing_categories = yalwa.v.clothing_categories;
			let ltw_parent = $element.data('ltw_parent');
			if (!clothing_categories) {
				return;
			}
			if (ltw_parent && clothing_categories.indexOf(ltw_parent) > -1) {
				$category_root.data('ltw_parent_explicit', ltw_parent);
			} else {
				$category_root.data('ltw_parent_explicit', '');
			}
		}

		function snh_set_selected_category($element) {
			let type, id, ltw_parent;
			if ($element) {
				snh_clothing_categories_handler($element);
			}
			if ($element) {
				type = $element.data('ltw_type');
				id = $element.data('ltw_id');
				ltw_parent = $element.data('ltw_parent');
			} else {
				type = $category_root.data('ltw_start_type');
				id = $category_root.data('ltw_start_id');
				ltw_parent = $category_root.data('ltw_parent_explicit');
			}
			if (!type) {
				return;
			}
			switch (type) {
				case 'root':
					delete pub.values_object.l1;
					delete pub.values_object.categoryID;
					delete pub.values_object.sub_categoryID;
					delete pub.values_object.ebt_kwID;
					delete pub.values_object.type;
					delete pub.values_object.ebt_kw_label;
					delete pub.values_object.ebt_kw_parent;
					break;
				case 'l2':
					delete pub.values_object.l1;
					pub.values_object.categoryID = id;
					delete pub.values_object.sub_categoryID;
					delete pub.values_object.ebt_kwID;
					delete pub.values_object.type;
					delete pub.values_object.ebt_kw_label;
					delete pub.values_object.ebt_kw_parent;
					break;
				case 'ebt_l1':
				case 'ebt_l2':
				case 'ebt_l3':
					delete pub.values_object.l1;
					delete pub.values_object.categoryID;
					delete pub.values_object.sub_categoryID;
					pub.values_object.ebt_kwID = id;
					delete pub.values_object.type;
					delete pub.values_object.ebt_kw_label;
					delete pub.values_object.ebt_kw_parent;
					break;
				case 'l3':
					delete pub.values_object.l1;
					delete pub.values_object.categoryID;
					pub.values_object.sub_categoryID = id;
					delete pub.values_object.ebt_kwID;
					delete pub.values_object.type;
					delete pub.values_object.ebt_kw_label;
					delete pub.values_object.ebt_kw_parent;
					break;
				case 'l1':
					pub.values_object[type] = id;
					delete pub.values_object.categoryID;
					delete pub.values_object.sub_categoryID;
					delete pub.values_object.ebt_kwID;
					delete pub.values_object.type;
					delete pub.values_object.ebt_kw_label;
					delete pub.values_object.ebt_kw_parent;
					break;
				case 'l1_immo':
					switch (id) {
						case 'immo_for_sale':
							id = 'sale';
							break;
						case 'immo_for_rent':
							id = 'rent';
							break;
						case 'immo_holiday_rentals':
							id = 'rentals';
							break;
					}
					pub.values_object.type = id;
					pub.values_object.l1 = 'R';
					delete pub.values_object.categoryID;
					delete pub.values_object.sub_categoryID;
					delete pub.values_object.ebt_kwID;
					delete pub.values_object.ebt_kw_label;
					delete pub.values_object.ebt_kw_parent;
					break;
			}
		}

		function snh_ltw_click_handler() {
			if (jQuery(this).hasClass('js-ltw_selected_item')) {
				return;
			}
			yalwa.basics.bem_modifier(jQuery('.js-ltw_option'), 'selected', 'remove');
			jQuery('.js-ltw_option').removeClass('js-ltw_selected_item');
			jQuery(this).addClass('js-ltw_selected_item');
			yalwa.basics.bem_modifier(jQuery(this), 'selected', 'add');
			snh_set_selected_category(jQuery(this));
			$category_root.data(
				{
					'ltw_start_id': jQuery(this).data('ltw_id'),
					'ltw_start_type': jQuery(this).data('ltw_type'),
				});

			const $icon = jQuery(this).hasClass('js-ltw_back') ? yalwa.basics.yimage('categories_all', {folder: 'profile', pixel: 24}) : jQuery(this).find('.yimage');

			if ($icon.length) {
				$category_icon_placeholder.html($icon);
			}
			switch (jQuery(this).data('ltw_type')) {
				case 'root':
					$category_placeholder.html(yalwa.v.lang.all_categories);

					snh_search_params.L1 = 0;
					snh_search_params.L2 = 0;
					snh_search_params.L3 = 0;
					reset_ebt_filter();
					break;
				case 'l1':
					snh_search_params.L1 = jQuery(this).data('ltw_id');
					snh_search_params.L2 = 0;
					snh_search_params.L3 = 0;
					$category_placeholder.html(jQuery(this).text());
					break;
				case 'l2':
					snh_search_params.L2 = jQuery(this).data('ltw_id');
					snh_search_params.L1 = 0;
					snh_search_params.L3 = 0;
					$category_placeholder.html(jQuery(this).text());
					break;
				case 'l3':
				case 'ebt_l1':
				case 'ebt_l2':
				case 'ebt_l3':
					snh_search_params.L3 = jQuery(this).data('ltw_id');
					snh_search_params.L1 = 0;
					snh_search_params.L2 = 0;
					$category_placeholder.html(jQuery(this).text());
					reset_ebt_filter();
					break;
			}
			snh_search_options.params = snh_search_params;
			snh_select_silently_in_progress = true;
			$search_input
				.autocomplete('setOptions', snh_search_options)
				.autocomplete('onValueChange');
			pub.fire(false, true);
		}

		/**
		 * if user selects an ebt as a category over snh category selector, ebt search filters should be reset
		 */
		function reset_ebt_filter() {
			if (yalwa.search_filter) {
				yalwa.search_filter.reset_specific_filter_data('ebt_kwID');
			} else {
				delete pub.new_search_filter_data.ebt_kwID;
				delete pub.new_search_filter_data.ef;
			}
		}

		function geoid_chosen_handler(event, geoid, hostname_may_have_changed) {
			hostname_may_have_changed = hostname_may_have_changed || false;
			if (!hostname_may_have_changed && yalwa.v.change_hostname) {
				yalwa.v.change_hostname = null;
			}
			selected_geoid = (typeof geoid === 'undefined' || geoid === '' || geoid === null) ? 0 : parseInt(geoid);
			let current_geoID = yalwa.v.selected_geoid || (yalwa.v.vap_nationwide_context ? false : yalwa.v.current_geoID) || false;
			current_geoID = current_geoID ? parseInt(current_geoID) : false;
			// update snh suggestions
			yalwa.v.selected_geoid = selected_geoid;

			if (typeof selected_geoid === 'number' && typeof current_geoID === 'number' && selected_geoid !== current_geoID) {
				snh_search_params.current_geoID = selected_geoid;
				snh_search_options.params = snh_search_params;
				snh_select_silently_in_progress = true;
				$search_input
					.autocomplete('setOptions', snh_search_options)
					.autocomplete('onValueChange');
				$category_root.data('geoid', selected_geoid);
				$category_root.data('areaid', areaID);
				ltw.init_request();
			}
			if (selected_geoid > 0 && !is_state && !is_nationwide_city) {
				enable_distance_selector();
			} else {
				disable_distance_selector();
			}
			snh_location_placeholder_color_toggle(selected_geoid > 0);
			pub.fire(false, true);
		}

		return pub;

	}(pub.snh));

	function popsearch_paning_init() {
		if (typeof (Hammer) === 'undefined' || !jQuery('.js-popsearch').length) {
			return;
		}
		const $popsearch_container = jQuery('.js-popsearch');
		let items_pixel = 0;
		$popsearch_container.find('a,span').each(function(i, e) {
			items_pixel += parseInt(jQuery(e).css('display', 'inline-block').outerWidth(), 10) + 10;
		});
		const max = $popsearch_container.outerWidth() - items_pixel;
		const hammertime = new Hammer($popsearch_container[0], {});
		hammertime.get('pan').set({direction: Hammer.DIRECTION_HORIZONTAL, threshold: 0});
		let start = 0;
		hammertime.on('panend', function() {
			start = $popsearch_container.data('tmp') || 0;
		});
		hammertime.on('panleft panright', function(a) {
			window.requestAnimationFrame(function() {
				const deltaX = a.deltaX + start;
				if (deltaX < 5 && deltaX > max) {
					const transform = 'translateX(' + (deltaX).toString() + 'px)';
					$popsearch_container[0].style.transform = transform;
					$popsearch_container[0].style.webkitTransform = transform;
					$popsearch_container.data('tmp', deltaX);
				}
			});
		});
	}

	function debounce(method, delay) {
		clearTimeout(method._tId);
		method._tId= setTimeout(function(){
			method();
		}, delay);
	}

	pub.mfd = function(config) { // mfd = mobile fullscreen dialog
		config = config || {};
		jQuery('.js-mfd').remove();

		var html = config.html;
		if (!html) {
			return;
		}

		if (config.disable_close === undefined || config.disable_close === false) {
			html += yalwa.basics.yicon('close--white', {pixel: 32, classes: 'js-mfd_close mfd_close'});
			yalwa.basics.state.push('mdf');
		}

		var $mfd = jQuery('<div class="mfd js-mfd hidden ' + (config.classes ? config.classes : '') + '">' + html + '</div>');

		jQuery('body').append($mfd);
		jQuery('.js-mfd_close').on('click', function() {
			if (config.close_before) {
				config.close_before();
			}
			jQuery('.js-mfd').velocity('transition.shrinkOut', {
				complete: function() {
					if (config.close_after) {
						config.close_after();
					}
				}
			});
		});
		$mfd.velocity('transition.expandIn', {display: null});
		yalwa.basics.show($mfd);
	};

	// ptr = pull to refresh
	function ptr_init() {
		var slidebox = jQuery('.js-pullrefresh');
		if (!slidebox.length || typeof (Hammer) === 'undefined') {
			return;
		}
		const dol_htabs = yalwa.v.is_dol && jQuery('.js-ptr_dol').length;
		var container = dol_htabs ? jQuery('.js-ptr_dol') : $headroom;
		if (!container.length) {
			return;
		}
		container.on('touchcancel', ptr_hide);
		var slidebox_icon = slidebox.children('.js-pullrefresh_icon');
		var text = slidebox.children('.js-pullrefresh_text');
		var threshold = 50;
		var slowdown_factor = 0.4;
		var current_down = 0;
		var last_height = 0;
		var animation = null;
		var overflow_set = false;
		new Hammer.Manager(container[0], {
			cssProps: {
				userSelect: ''
			},
			recognizers: [[Hammer.Pan, {direction: Hammer.DIRECTION_VERTICAL}]]
		}).on('panend pandown panup', function(e) {
			window.getSelection().removeAllRanges();
			var $target = jQuery(e.target);
			if (jQuery('.js-all_categories').hasClass('active')) {
				return;
			}
			if ($target.hasClass('pullrefresh')) { // prevents unintended scrolls esspecially on ios
				return;
			}
			if ($headroom.hasClass('ptr_disabled')) {
				return;
			}
			if (!dol_htabs && $target.closest('.js-htabs_item').length) {
				if (e.type === 'panend') {
					ptr_hide();
				}
				return;
			}
			if (htabs_active) {
				return;
			}
			ptr_active = true;
			e.preventDefault();
			ptr_pan(e);
		});

		function animate_dots() {
			jQuery('.js-dot').velocity('transition.fadeIn', {
				duration: 500,
				stagger: 200,
				loop: 3,
				complete: animate_dots
			});
		}

		function ptr_pan(ev) {
			if (!overflow_set) {
				jQuery('.js-headroom').css({overflow: 'visible'});
				overflow_set = true;
			}
			switch (ev.type) {
				case 'pandown':
				case 'panup':
					requestAnimationFrame(ptr_update_height);
					current_down = ev.deltaY * slowdown_factor;
					break;

				case 'panend':
					if (ev.deltaY * slowdown_factor >= threshold) {
						// jQuery('.js-headroom').css({overflow: ''});
						requestAnimationFrame(() => {
							ptr_set_height(50);
							slidebox_icon.addClass('loading');
							text.text(yalwa.v.lang.ptr_load);
							jQuery('.js-pullrefresh_text').append(' <span class="js-dot">.</span><span class="js-dot">.</span><span class="js-dot">.</span>');
							animate_dots();
						});
						yalwa.mobile.page_will_unload(location.href);
						window.setTimeout(function() { // avoid freezing on iOS
							yalwa.basics.reload();
						}, 100);
					} else {
						ptr_hide();
					}
					break;
			}
		}

		function ptr_set_height(height) {
			if (height !== last_height && height >= 0) {
				ptr_cancel_animation();
				container.css({
					'transform': 'translate(0,' + Math.round(height) + 'px)'
				});
				last_height = height;
			}
		}

		function ptr_cancel_animation() {
			cancelAnimationFrame(animation);
		}

		function ptr_hide() {
			jQuery('.js-headroom').css({overflow: ''});
			overflow_set = false;
			current_down = 0;
			ptr_set_height(0);
			animation = null;
			ptr_active = false;
		}

		function ptr_update_height() {

			ptr_set_height(current_down);
			if (current_down >= threshold) {
				slidebox_icon.addClass('arrow-up').removeClass('arrow-down');
				text.html(yalwa.v.lang.ptr_release);
			} else {
				slidebox_icon.removeClass('arrow-up').addClass('arrow-down');
				text.html(yalwa.v.lang.ptr_pull);
			}
		}
	}

// helper

	function expand_click(event) {
		if (event.which === 1 || event.which === 0) {
			var $this = jQuery(this);
			var link_element = false;
			if ($this.prop('href')) {
				link_element = $this;
			} else if ($this.find('a[href]')) {
				link_element = $this.find('a[href]');
			}
			if (link_element) {
				var href = link_element.prop('href');
				if (yalwa.v.is_phonegap && link_element.attr('target') === '_blank' || (yalwa.v.is_ios && href.search('mailto:') === 0)) { // #30875
					// if (yalwa.v.is_phonegap && link_element.attr('target') === '_blank') { // #30875
					event.preventDefault();
					if (link_element.hasClass('js-app_intent')) {
						yalwa.mobile.cordova.openintent(href);
					} else {
						yalwa.mobile.cordova.openexternal(href);
					}

					return;
				}
				if (href
					&& (href.search('#') === -1 || link_element[0].pathname !== location.pathname)
					&& href.search('javascript:') !== 0
				) {
					yalwa.mobile.page_will_unload(href);
					if (link_element.hasClass('js-post_ad')) {
						link_element.trigger('click');
					} else {
						yalwa.basics.navigate(href);
						event.preventDefault();
					}
				}
			}
		}
	}

	function random_int(min, max) {
		return Math.floor(Math.random() * (max - min + 1) + min);
	}

	function scroll_watch() {
		if ((yalwa.basics.is_safari() || yalwa.v.is_ios) && !yalwa.v.is_phonegap) {
			return; // safari does this automatically and this also breaks the back-button functionality
		}
		if (history.replaceState) {
			$window.on('scroll.save_position', function() {
				yalwa.basics.debounce(scroll_store, 200);
			});
		}
	}

	pub.mainscroll_set = function(value) {
		return $window.scrollTop(value || 0);
	};

	pub.mainscroll_get = function() {
		return $window.scrollTop();
	};

	function scroll_restore() {
		yalwa.mobile.mainscroll_set(history.state.scroll_position);
	}

	pub.scroll_check = function() {
		if (history && history.state && history.state.scroll_position) {
			scroll_restore();
		}
	};

	function scroll_store() {
		yalwa.basics.state.extend({scroll_position: yalwa.mobile.mainscroll_get()}, true);
	}

	function close_modals(self) {
		jQuery('.js-snh_tip_helper').remove();
		jQuery('.js-snh_tip_html').removeClass('snh_tip_html');
		if (self !== 'ocm_left' && !jQuery('.ocm_left').is('.hidden')) {
			toggle_ofc(false);
		}
		if (self !== 'js-ltw_root' && !jQuery('.js-snh_ltw .js-ltw_root').is('.hidden')) {
			yalwa.basics.toggle(jQuery('.js-snh_ltw .js-ltw_root'));
			jQuery('.js-ltw_root').removeClass('toggled');
		}
		if (self !== 'js-narrow_search') {
			yalwa.basics.hide(jQuery('.js-narrow_search'));
		}
	}

	pub.yli = (function(pub) {

		pub = pub || {};

		pub.start = function($element, modifier) {
			$element.addClass('yli');
			if (modifier) {
				$element.addClass('yli--' + modifier);
			}
			setTimeout(() => {
				$element.addClass('yli--active');
			}, 200);
		};

		pub.stop = function($element) {
			$element.removeClass('yli yli--active');
		};

		pub.toggle = function($element, modifier) {
			if ($element.hasClass('yli--active')) {
				pub.stop($element);
			} else {
				pub.start($element, modifier);
			}
		};

		pub.progress = function($element, milliseconds, callback) {
			let $yli_progress = jQuery('<div class="js-yli_progress yli_progress"></div>');
			let color_darkened = $element.css('backgroundColor');
			color_darkened = '#000000';
			$yli_progress.css({backgroundColor: color_darkened});
			$element.addClass('yli_progress_parent').append($yli_progress);
			$yli_progress.velocity({width: '100%'}, {
				duration: milliseconds, complete: function() {
					if (typeof (callback) === 'function') {
						callback();
					}
					$yli_progress.remove();
					$element.removeClass('yli_progress_parent');
				}
			});
		};

		return pub;

	}(pub.yli));

	pub.barspinner = function(modifier) {
		return jQuery('<div class="barspinner' + (modifier ? ' barspinner--' + modifier : '') + ' js-barspinner"><div class="barspinner__bar"></div><div class="barspinner__bar"></div><div class="barspinner__bar"></div></div>');
	};

// helper-end

	function origin() {
		if (window.location.origin) {
			return window.location.origin;
		} else {
			return window.location.protocol + '//' + window.location.host;
		}
	}

	function add_dol_promo_link_tracking() {
		if (jQuery('.js-dating_landing_area_tracker').length) {
			var $add_tracking = jQuery('.js-dating_landing_area_tracker');
			var track_country = $add_tracking.data('country');
			var track_area = $add_tracking.data('area');
			$add_tracking.find('a').on('click', function(e) {
				yalwa.basics.ga.event({
					category: 'chp_ahp_dol_promo_click',
					action: String(track_country),
					label: track_area && track_area > 0 ? String(track_area) : ''
				});
			});
		}
	}

	function check_routing() {
		yalwa.basics.check_routing();
		var routing = get_routing();
		switch (routing) {
			case 'book_upgrade':
				pub.premium_tracking.init_page('checkout');
				if (
					!yalwa.v.pa_plans_type &&
					performance.navigation.type === 2
				) {
					yalwa.basics.reload();
				}
				new StickyHelper().init();
				break;
			case 'chp':
				add_dol_promo_link_tracking();
				jQuery('.js-logo_link,.js-ytbt_home').on('click', function(e) {
					jQuery('.js-snh_category, .js-ybtb_button_browse_history').filter('.ybtb_active').trigger('click');
					var $back = jQuery('.js-ltw_back').last();
					if ($back.length && $back.is(':visible') && $back[0]) {
						// reset ltw
						ltw.reset().always(function() {
							jQuery('.js-ltw_back[data-ltw_type="root"]').trigger('click');
						});
					}
				});
				if (yalwa.v.is_phonegap && location.hash === "#areas") {
					jQuery('.js-places_suggest').focus().trigger("click");
				}
				premium.init_cart();
				break;
			case 'ahp':
				seo_read_more_button_init();
				add_dol_promo_link_tracking();
				premium.init_cart();
				break;
			case 'favorites':
				jQuery('.js-remove_favs').on('click', function() {
					jQuery('.js-remove_favs_plp').trigger('plp_show').on('plp_confirm', fav_manager.reset.bind(fav_manager));
				});
				lazyload_pagination_init('.favs__listings');
				break;
			case 'notification-center':
				lazyload_pagination_init('.js-profile_settings_form');
				break;
			case 'search':
			case 'search_nationwide':
			case 'browse':
				browse_init();
				lso_read_more_init();
				browse_history_add();
				browse_promotions_init();
				break;
			case 'distribution':
				pub.email_alerts_init();
				break;
			case 'login':
				if (yalwa.basics.get_get(yalwa.basics.auth.touchpoint_parameter())) { // reset touchpoint
					const o = {};
					o[yalwa.basics.auth.touchpoint_parameter()] = null;
					yalwa.basics.set_get(o);
				}
				break;
			case 'logout':
			case 'registration':
				yalwa.basics.after_logout_handler();
				break;
			case 'pis':
				if (window.location.hash && jQuery(location.hash).length) {
					setTimeout(function() {
						$window
							.scrollTop(0)
							.scrollTop(jQuery(location.hash).offset().top - 60);
					}, 400); // doesnt work for ios without timeout
				}
				break;
			case 'cart':
				premium.init();
				premium.init_cart();
				pub.premium_tracking.init_page('shopping_cart');
				break;
			case 'change_nickname':
				jQuery('.js-change_nickname_input').on('enterdown', function() {
					jQuery(this).trigger('blur');
				}).on('blur', nickname_check);
				jQuery('.js-change_nickname_submit').on('click', function() {
					setTimeout(() => {
						if ($('.js-change_nickname_input').attr('data-input-valid') === 'true') {
							if (yalwa.v.is_hybrid) {
								jQuery('.js-hybrid_warning_change_email')
									.on('click', '.js-plp_confirm', () => {
										jQuery('.js-hybrid_warning').trigger('plp_hide');
										jQuery('.js-change_nickname_submit').closest('form').submit();
									})
									.on('click', '.js-plp_ok', () => {
										jQuery('.js-hybrid_warning').trigger('plp_hide');
									})
									.trigger('plp_show')
							} else {
								jQuery(this).closest('form').submit();
							}
						}
					}, 200);
				});
				break;
			case 'account_activation':
				init_terms_plp();
				yalwa.mobile.ali.init();
				yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/quickselect.js', function() {
					jQuery('.js-activate_sex').quickselect({
						breakOut: 'all',
						activeIsDeletable: false
					});
					yalwa.mobile.stop_invisible_start();
				});
				jQuery('.js-activate_pa_more').on('click', function() {
					jQuery('.js-activate_table').addClass('pa_activate_table--open');
					jQuery(this).remove();
				});
				jQuery('.js-change_nickname_input').on('enterdown', function() {
					jQuery(this).trigger('blur');
				}).on('blur', nickname_check);

				jQuery('.js-activate_phone').on('input', function() {
					jQuery('.js-phone_verification_submit').attr('disabled', !jQuery(this).val());
				});
				jQuery('.js-activate_submit').on('click', function(e) {
					if (jQuery('.js-activate_phone').length && jQuery('.js-activate_phone').is(':visible')) {
						var $input = jQuery('.js-activate_phone');
						if (!$input.data('valid')) {
							e.preventDefault();
							yalwa.mobile.mainscroll_set($input.offset().top);
							jQuery('.js-phone_verification_submit').velocity('callout.shake', {delay: 200});
							$input.velocity('callout.shake', {delay: 200});
							yalwa.basics.toast({message: $input.data('invalid_phone_number'), type: 'error'});
						}
					}

					if(!document.getElementsByClassName('js-username_tips')[0].checkValidity()) {
						e.preventDefault();
						jQuery('.js-username_tips').focus().blur().focus();
						return;
					}
					if(!document.getElementsByClassName('js-password_input')[0].checkValidity()) {
						e.preventDefault();
						setTimeout(function () {
							jQuery('.js-password_input').focus();
						}, 100);

					}
					if(document.getElementsByClassName('js-page_activate__form')[0].checkValidity()) {
						jQuery('.js-activate_submit').off('click').click();
					}
				});
				pv_activation_init();
				init_optional_info();
				break;
			case 'mail_unsubscribe':
				jQuery('.js-delete_account_warning').on('plp_confirm', function() {
					if (yalwa.v.tfa_needed) {
						jQuery('yalwa-twofactordialog')[0].request_action('code');
						jQuery(document).on_once('twofactor-code-submitted.login', 'yalwa-twofactordialog', async function(event) {
							const code = event.originalEvent.detail.code || event.originalEvent.detail.backup_code;
							jQuery('.js-delete_account_form').append('<input type="hidden" name="otp_token" value="' + code + '" >');
							jQuery('.js-delete_account_submit').trigger('click');
							jQuery(this).trigger('plp_hide');
							jQuery('yalwa-twofactordialog')[0].close();
						});
					} else {
						jQuery('.js-delete_account_submit').trigger('click');
						jQuery(this).trigger('plp_hide');
					}

				});
				jQuery('.js-delete_account_go').on('click', function() {
					jQuery('.js-delete_account_warning').trigger('plp_show');
				});
				break;
			case 'terms':
			case 'privacy':
				embedded_page_link_handler();
				break;
			case 'pa_info':
				if (yalwa.v.selected_pa_feature) {
					var $selected = jQuery('.js-cyp_feature').filter('[data-featureid="' + yalwa.v.selected_pa_feature + '"]');
					if ($selected.length) {
						$selected.velocity("scroll", {
							container: $main_col, delay: 500, duration: 400, offset: -60, complete: function() {
								$selected.velocity('callout.pulse');
							}
						});

					}
				}
				break;
			case 'youth_protection':
				jQuery('.js-underage_accept').on('click', function(event) {
					event.preventDefault();
					yalwa.basics.set_cookie('loc_underage_accept', 1, 2592000);
					yalwa.basics.navigate(event.target.href);
					return false;
				});
				break;
			case 'myratings':
			case 'public_profile':
				init_public_profile();
				break;
			case 'vap':
				init_ignore_buttons();
				if (yalwa.v.is_ios) {
					$window.on('pageshow', event => {
						if (event.originalEvent.persisted) {
							// yalwa.basics.reload();
						}
					});
				}
				break;
			case 'premium_confirm':
				pub.premium_tracking.init_page('successful_purchase');
				break;
			case 'info_premium':
				pub.premium_tracking.init_page('info_premium');
				break;
			case 'myads':
				pub.premium_tracking.init_page('my_ads');
				premium.open_pa_dialog_click_listener();
				break;
			case 'start':
			case 'post_confirm':
			case 'confirm':
				premium.open_pa_dialog_click_listener();
				let $dol_promo_plp = jQuery('.js-dol_promo_plp');
				if ($dol_promo_plp.length) {
					yalwa.basics.load_css(yalwa.basics.static_url('fonts') + 'open_sans/style.css');
					yalwa.basics.ga.event({
						category: 'dol_promo_plp',
						action: 'impression: ' + (routing === 'start' ? 'after registration' : 'after PAF')
					});
					let $button = $dol_promo_plp.find('.js-dol_promo_cta');
					$button.on('click', (e) => {
						e.preventDefault();
						yalwa.basics.ga.event({
							category: 'dol_promo_plp',
							action: 'click: ' + (routing === 'start' ? 'after registration' : 'after PAF')
						}).done(() => {
							yalwa.basics.navigate($button.attr('href'));
						});
						return false;
					});
				}
			case 'paplans':
				new StickyHelper().init();
				break;
		}
		yalwa.basics.ls_set('prev_was_bsp', routing === 'search' || routing === 'search_nationwide' || routing === 'browse');
		if (routing === 'chp' || routing === 'ahp' || routing === 'search' || routing === 'search_nationwide' || routing === 'vap') {
			window.setTimeout(yalwa.mobile.app_rating.check_opportunity, 4100);
		}
	}

	function lso_read_more_init() {
		jQuery('.js-lso_read_more').each(function() {
			const $button = jQuery(this);
			const $text = $button.prev('.js-lso_text');
			if ($text.length && $text[0].scrollHeight <= $text.innerHeight() + 2) {
				yalwa.basics.hide($button);
			}
		});

		jQuery('.js-lso_read_more').on('click', function() {
			const $button = jQuery(this);
			const $text = $button.prev('.js-lso_text');
			const $label = $button.find('.js-lso_read_more_label');
			const collapsed = $text.hasClass('lso--collapsed');

			if (collapsed) {
				$text.removeClass('lso--collapsed');
				$label.text($button.data('label-showless'));
			} else {
				$text.addClass('lso--collapsed');
				$label.text($button.data('label-showmore'));
			}
		});
	}

	function seo_read_more_button_init() {
		const $button = jQuery('.js-seo_read_more');
		$button.on('click', seo_read_more_button_click_handler);

		// Initial set
		set_grid_max_height();

		$window.on('resize', () => {
			yalwa.basics.debounce(() => {
				set_grid_max_height();
			}, 250);
		});
	}

	function lazyload_pagination_init(element) {
		const paginator = jQuery('.paginator');
		const favs_listings = jQuery(element);

		if ('IntersectionObserver' in window) {
			const observer = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
				if (entry.isIntersecting) {
					const next_link = paginator.find('a[data-direction="next"]').attr('href');
					if (next_link) {
						loadContent(next_link);
					} else {
						paginator.remove();
					}
				}
				});
			}, {
				root: null,
				rootMargin: '200px',
				threshold: 0
			});

			if (paginator.length) {
				observer.observe(paginator[0]);
			}
		}

		function loadContent(url) {
			jQuery.ajax({
				url: url,
				method: 'GET',
				success: function(data) {
					const new_favs_listings = jQuery(data).find(element).children().not('.notification_settings__abos');
					favs_listings.append(new_favs_listings);
					const new_paginator = jQuery(data).find('.paginator');
					paginator.html(new_paginator.html());
					fav_manager.render();
					init_bst_sliders();
				}
			});
		}

	}

	// Function to calculate and set the max height
	function set_grid_max_height() {
		const $grid = jQuery('.js-seo_text_footer');
		const grid_children = $grid.children();

		const is_mobile = yalwa.basics.current_device_classification() === 'mobile';
		const is_tablet = yalwa.basics.current_device_classification() === 'tablet';

		if (grid_children.length > 0) {
			let middle_height;
			const first_height = grid_children.eq(0).outerHeight();
			if (is_tablet) {
				middle_height = first_height / 2;
			} else {
				const grid_gap = 30;
				const second_height = grid_children.eq(is_mobile ? 1 : 2).outerHeight();
				middle_height = first_height + (second_height / 2) + (is_tablet ? 0 : grid_gap);
			}
			$grid.css('maxHeight', `${middle_height}px`);
		}
	}

	function seo_read_more_button_click_handler(event) {
		jQuery('.js-seo_text_footer').css('maxHeight', '');
		const $seo_text = jQuery(this).prev('.js-seo_text');
		jQuery(this).remove();
		yalwa.basics.bem_modifier($seo_text, 'collapsed', 'toggle');
	}
	function init_optional_info() {
		jQuery('.js-account_activation_optional_button').on('click', toogle_optional_info);
	}

	function toogle_optional_info(event) {
		event.preventDefault();
		jQuery('.js-account_activation_optional_section').toggleClass('collapsed');
		jQuery('.js-account_activation_optional_icon').toggleClass('up');
	}

	function pv_activation_init() {
		yalwa.basics.show(jQuery('.js-phone_verification__inputs'));
		jQuery('.js-activate_phone').prop("required", true);
	}
	function handle_left_side_navigation() {
		const $left_side_navigation = jQuery('.js-profile_left');
		const $move_to_left_side = jQuery('.js-desktop_left_side');
		if (yalwa.mobile.matches_breakpoint('desktop')) {
			$move_to_left_side.each(function(index) {
				if(jQuery(this).closest('.js-profile_left').length) {
					return;
				}
				jQuery(this).data('position', index);
				const $mobile_postion = jQuery('<div class="js-mobile_position" data-position="' + index + '"></div>');
				$mobile_postion.insertAfter(jQuery(this));
				jQuery(this).appendTo($left_side_navigation);
			})
		} else {
			$move_to_left_side.each(function(index) {
				const position = jQuery(this).data('position');

				const $mobile_postion = jQuery('.js-mobile_position').filter('[data-position="' + position + '"]');
				jQuery(this).insertAfter($mobile_postion);
				$mobile_postion.remove();
			})
		}
	}

	function init_public_profile() {
		const sticky_helper = new StickyHelper();
		sticky_helper.init();
		jQuery('.js-bsp_item_ignored').removeClass('js-bsp_item_ignored').removeClass('bsp_item_ignored');
		yalwa.mobile.mark_new_postings();
		if (yalwa.mobile.htabs.get() === 'start' || !yalwa.mobile.htabs.get()) {
			highlight_avatar();
		}
		handle_left_side_navigation();
		$window.on('resize', handle_left_side_navigation);
		$document.on('htabs_profile', function(e, id) {
			if (id === 'start') {
				setTimeout(highlight_avatar, 200);
			}
			handle_left_side_navigation();
		});
		const $rating_list_elements = jQuery('.js-rating_list');
		$rating_list_elements.on('click', '.js-ur_comment_btn', function() {
			var $this = jQuery(this);
			var reviewID = $this.data('review_id');
			var $textarea = jQuery('.js-comment_' + reviewID);
			if ($textarea.val()) {
				jQuery.post('/api/ajax/user_rating', {
					action: 'comment',
					reviewID: reviewID,
					ctrl_str: $this.data('ctrl_str'),
					text: $textarea.val(),
					username: $this.data('nickname'),
					countryID: yalwa.v.countryID
				}, function(html) {
					const $comment = jQuery('.js-rating_list_item').filter('[data-reviewid="' + reviewID + '"]').find('.js-lpp_rating_comment');
					$comment.parent().velocity({opacity: 0}, {
						complete: function() {
							$comment.html(html);
							$comment.parent().velocity({opacity: 1});
						}
					});
					ovw_add_comment_handler(reviewID);
				});
			} else {
				yalwa.basics.toast({message: $textarea.data('error_message'), type: 'error'});
			}
		});

		$rating_list_elements.on('click', '.js-add_comment, .js-cancel_comment', ovw_toggle_comment);

		$rating_list_elements.on('click', '.js-delete_comment', function() {
			var $this = jQuery(this);
			var reviewID = $this.data('review_id');
			jQuery.post('/api/ajax/user_rating', {
				action: 'delete-comment',
				reviewID: reviewID,
				ctrl_str: $this.data('ctrl_str'),
				username: $this.data('nickname'),
				countryID: yalwa.v.countryID
			}, function(html) {
				ovw_delete_comment_handler(reviewID);
			});
		});
		jQuery('.js-show_review_comment,.js-show_review_delete').on('click', function(event) {
			if (yalwa.v.is_pa_rework_testing_active) {
				pub.load_pa_plan_overlay('delete_review');
			} else {
				yalwa.mobile.mfd({html: jQuery(jQuery(this).hasClass('js-show_review_comment') ? '.js-show_review_respond_content' : '.js-show_review_delete_content').first().html()});
			}

			event.preventDefault();
			event.stopPropagation();
			return false;
		});
		jQuery('.js-ur_delete_btn_mobile').on('click', function() {
			var $button = jQuery(this);
			var $item = $button.closest('.js-rating_list_item');
			var $dialog = jQuery('.js-plp').filter('[data-id="reviewid_' + $item.data('reviewid') + '"]');
			yalwa.basics.show($dialog);
			$dialog.find('.js-delete_user_yes')
				.off('click')
				.on('click', function() {
					jQuery.post('/api/ajax/user_rating', {
						action: 'delete-rating',
						reviewID: $button.data('review_id'),
						ctrl_str: $button.data('ctrl_str'),
						countryID: yalwa.v.countryID
					}, function(html) {
						if (html === 'success') {
							$button.closest('.js-rating_list_item').remove();
							yalwa.basics.reload();
						} else {
							$dialog.trigger('plp_hide');
							yalwa.basics.toast({message: html, type: 'info'});
						}

					});
				});
			$dialog.trigger('plp_show');
		});
		init_ignore_buttons();
		init_public_profile_ajax_service();
		setTimeout(yalwa.mobile.htabs.move_track, 200);
	}

	function init_public_profile_ajax_service() {
		const $categories = jQuery('.js-public_profile_category');
		const $form = jQuery('.js-public_profile_search_form');
		$categories.on('click', public_profile_ajax_handler);
		$form.on('submit', public_profile_ajax_handler)
	}

	function public_profile_ajax_handler(event) {
		event.preventDefault();
		const $form = jQuery('.js-public_profile_search_form');
		const $this = jQuery(this);
		if (event.type === 'submit') {
			$this.data('grp', $form.find('input').filter('[name="grp"]').val());
			$this.data('cat', $form.find('input').filter('[name="cat"]').val());
			$this.data('search', $form.find('input').filter('[name="search"]').val());
		} else {
			$form.find('input').filter('[name="grp"]').val($this.data('grp'));
			$form.find('input').filter('[name="cat"]').val($this.data('cat'));
			$form.find('input').filter('[name="search"]').val('');
			public_profile_menu_visual_change($this);
		}
		const data =  {};
		if (yalwa.v.public_profile_emailIDs) {
			data.emailIDs = yalwa.v.public_profile_emailIDs;
		}
		if (yalwa.v.userID_viewed) {
			data.userID_viewed = yalwa.v.userID_viewed;
		}
		if (yalwa.v.nickname) {
			data.nickname = yalwa.v.nickname;
		}
		if ($this.data('grp')) {
			data.grp = $this.data('grp');
		}
		if ($this.data('cat')) {
			data.cat = $this.data('cat');
		}
		if ($this.data('search')) {
			data.search = $this.data('search');
		}
		yalwa.basics.ajaxservice({
			type: 'POST',
			resource: 'publicprofile',
			action: 'category',
			data: data,
			csrf: $form.data('csrf')
		}).then(response => {
			if (response.success) {
				jQuery('.js-public_profile_postings').html(response.html);
				if(yalwa.mobile.matches_breakpoint('desktop')) {
					jQuery('html')
						.animate({
							scrollTop: 0
						}, 400);
				}
			}
		});
	}

	function public_profile_menu_visual_change($element) {
		$element.closest('.js-public_profile_groups').find('.js-public_profile_cat_visual').removeClass('active');
		$element.closest('.js-public_profile_cat_visual').addClass('active');
	}

	function ovw_toggle_comment(event, action, reviewID) {
		if (event) {
			const $this = jQuery(this);
			reviewID = $this.data('review_id');
		}
		const $list_item = jQuery('.js-rating_list_item').filter(`[data-reviewid="${reviewID}"]`);
		const $form = $list_item.find('.js-comment_form');
		const $cancel_button = $list_item.find('.js-cancel_comment');
		const $add_button = $list_item.find('.js-add_comment');
		const $delete_button = $list_item.find('.js-ur_delete_btn_mobile');
		const $comment = $list_item.find('.js-lpp_rating_comment');
		const $delete_comment_button = $list_item.find('.js-delete_comment');
		yalwa.basics.toggle($cancel_button);
		if (action !== 'add') {
			yalwa.basics.toggle($add_button);
			yalwa.basics.toggle($delete_button);
		}
		if (action !== 'delete') {
			yalwa.basics.toggle($form);
		}
		if (action) {
			yalwa.basics.toggle($delete_comment_button);
			yalwa.basics.toggle($comment);
		}
	}

	function ovw_delete_comment_handler(reviewID) {
		ovw_toggle_comment(null, 'delete', reviewID);
	}

	function ovw_add_comment_handler(reviewID) {
		ovw_toggle_comment(null, 'add', reviewID);
	}

	function highlight_avatar() {
		jQuery('.js-lpp_avatar').removeClass('lpp__avatar--regular');
		window.setTimeout(function() {
			jQuery('.js-lpp_avatar').addClass('lpp__avatar--regular');
		}, 50);
	}

	function init_ignore_buttons() {
		var $buttons = jQuery('.js-ignore_user');
		if (!$buttons.length) {
			return;
		}
		$buttons.on('click', function() {
			if (!yalwa.basics.readonly_check()) {
				return false;
			}
			var $this = jQuery(this);
			jQuery.ajax({
				url: '/api/ajax/ignore_user',
				type: 'post',
				dataType: 'json',
				data: {
					ignore: $this.data('ignored') === 0 ? 1 : 0,
					emailID: $this.data('emailid')
				}
			}).done(function(response) {
				if (response.success) {
					if (response.ignored) {
						yalwa.basics.toast({message: $this.data('text_block'), type: 'success'});
						$this.data('ignored', 1).find('.js-list_label').text($this.data('text_unignore'));
					} else {
						yalwa.basics.toast({message: $this.data('text_unblock'), type: 'success'});
						$this.data('ignored', 0).find('.js-list_label').text($this.data('text_ignore'));
					}
				} else {
					yalwa.basics.toast({message: yalwa.v.lang.an_error_occurred, type: 'error'});
				}
			});
		});
	}

	function select_followers_tab() {
		if (yalwa.basics.ss_get('see_followers_tab')) {
			yalwa.basics.ss_remove('see_followers_tab');
			jQuery('.js-ltabs_item[data-value="followers"]').trigger('click');
		}
	}

	function nickname_check() {
		var $input = jQuery(this);
		jQuery.ajax({
			url: '/api/ajax/nickname_check/',
			type: 'post',
			data: {
				nickname: $input.val()
			},
			dataType: 'json'
		}).done(nickname_check_done);
	}

	function nickname_check_done(response) {
		yalwa.basics.hide(jQuery('.js-nickname_validation'));
		if (response[0] === false) {
			var $input = jQuery('.js-change_nickname_input');
			var info = response[1];
			if (!info) {
				return;
			}

			yalwa.basics.username_tips.popup.reset();
			yalwa.basics.username_tips.popup.show();
			yalwa.basics.username_tips.popup.set_heading(info);

			if (response[2] === 'suggestions') {
				var suggestions = response[4];
				var suggestions_html = '';
				for (var i in suggestions) {
					if (suggestions.hasOwnProperty(i)) {
						suggestions_html += '<div style="padding: 5px;" class="js-nickname_suggestion fake_link">' + suggestions[i] + '</div>';
					}
				}
				jQuery('.js-utpopup-content').append(jQuery('<span class="js-utpop_used_label">' + response[3] + '</span>'));
				jQuery('.js-utpopup-content').append(suggestions_html);
			}

			jQuery('.js-nickname_suggestion').on('click', function() {
				jQuery('.js-change_nickname_input').val(jQuery(this).text());
				yalwa.basics.username_tips.popup.hide();
				$input.trigger('blur');
			});
		} else {
			yalwa.basics.username_tips.show_tick();
			yalwa.basics.username_tips.popup.hide();
		}
	}

	function get_routing() {
		if (yalwa.basics.get_routing) {
			return yalwa.basics.get_routing();
		}
		yalwa.v.routing = yalwa.v.routing || jQuery('html').data('routing');
		return yalwa.v.routing;
	}

	function share_button_click() {
		var $this = jQuery(this);
		$this = $this.is('a') ? $this : $this.find('a');
		var position = $this.closest('[data-share_position]').data('share_position');
		var provider = $this.data('provider');
		var is_profile = $this.data('is_profile') ? $this.data('is_profile') : false;
		var url = jQuery(this).attr('href');
		if (url.search('/whatsapp:/') !== -1) {
			url = url.replace('whatsapp://send?text=', '');
		}
		var decoded_url = decodeURIComponent(url);
		if (provider === 'WhatsApp' && !yalwa.v.is_phonegap) {
			return;
		}

		const data = {
			category: 'Share box',
			action: position,
			label: provider
		};
		yalwa.basics.ga.ping_metric('CM_SHARE', 1, data);
		if (!yalwa.v.is_phonegap && navigator.share !== undefined) {
			var $sb = jQuery('.js-share_buttons');
			navigator.share({
				title: $sb.data('title'),
				url: decodeURIComponent($sb.data('url'))
			}).catch((e) => {

			});
		} else if (yalwa.v.is_phonegap) {
			if (yalwa.v.is_phonegap) {
				var share_labels = yalwa.v.share_labels || {};
				var is_plain = provider === 'generic_plain' ? true : false;
				if (is_plain) {
					share_labels.subject = yalwa.v.cookie_domain;
				} else if (is_profile) {
					share_labels = yalwa.v.phonegap_share_profile_labels;
				}
				yalwa.mobile.cordova.cordova_send({
					action: 'share',
					params: {
						provider: provider,
						url: decoded_url,
						labels: share_labels,
						is_plain: is_plain,
						is_profile: !!$this.data('is_profile')
					}
				});
			} else {
				yalwa.v.cordova_share = {
					provider: provider,
					url: decoded_url,
					is_profile: !!$this.data('is_profile')
				};
			}
		} else {
			yalwa.basics.new_tab(decoded_url);
		}
	}

	function share_init() {
		const $buttons = jQuery('.js-share_buttons');
		const position = $buttons.data('share_position');
		// cordova IOS SocialSharing plugin do not working in Ipad (getTopMostViewController bug)
		if (
			(navigator.share || (yalwa.v.is_phonegap && navigator.userAgent.match(/iPad/i) === null)) &&
			position !== 'confirmation_mobile'
		) {
			jQuery('.js-share_buttons').each(function() {
				prepare_share_button(jQuery(this));
			});
			return false;
		} else {
			yalwa.basics.show(jQuery('.js-share_container'));
			$buttons.find('a').on('click', function(event) {
				const provider = jQuery(this).data('provider');
				if (
					yalwa.v.is_phonegap ||
					provider !== 'WhatsApp'
				) {
					event.preventDefault();
					event.stopPropagation();
					share_button_click.apply(this);
					return false;
				}
			});
		}
	}

	function prepare_share_button(element) {
		const position = element.data('share_position');
		const alt_text = element.data('alt')
		const sprite_type = yalwa.v.is_ios ? 'ios_share--white' : 'share--white';
		let share_button = jQuery('<div class="js-share_button share_buttons share_buttons--fixed hitbox"></div>');
		share_button.html(yalwa.basics.yicon(sprite_type, {'pixel': 20, 'alt': alt_text}));
		switch (position) {
			case 'VAP':
				share_button = element;
				break;
			case 'VAP_mobile':
				element.closest('.card').remove();
				share_button.appendTo('body');
				break;
			case 'VIP_mobile':
				element.remove();
				share_button.appendTo('.js-vip_container');
				break;
			case 'profile':
				element.closest('.js-share_container').remove();
				share_button.appendTo('body');
				break;
			case 'burger_menu':
				share_button = element;
				if (location.href.search('/my') !== -1) {
					share_button.remove();
					return;
				}
				break;
		}

		share_button.on('click', function() {
			var urls = prepare_share_urls(jQuery(this), position);
			var share_title = prepare_share_title(position);
			var share_text = prepare_share_text(position);
			if (jQuery('.js-vap_manage').length > 0) {
				//own ad
				share_title = '';
				share_text = '';
			}
			if (yalwa.v.is_phonegap) {
				yalwa.mobile.cordova.cordova_send({
					action: 'share',
					params: {
						provider: 'None',
						url: urls.url.length + share_text.length <= 280 ? urls.url : urls.short_url,
						labels: {
							subject: share_title,
							text: share_text,
						}
					}
				});
			} else {
				navigator.share({
					title: share_title,
					text: share_text,
					url: urls.url.length + share_text.length <= 280 ? urls.url : urls.short_url
				}).catch((e) => {

				});
			}

			yalwa.basics.ga.ping_metric('CM_VAP_CALL', 1);
			const data = {
				category: 'Share box',
				action: position,
				label: 'native'
			};
			yalwa.basics.ga.ping_metric('CM_SHARE', 1, data);

		});
	}

	function prepare_share_text(position) {
		switch (position) {
			case 'VIP_mobile':
				return yalwa.v.lang.share_text_image;
			case 'profile':
				return yalwa.v.lang.share_text_profile;
			case 'burger_menu':
				return yalwa.v.lang.share_text_page;
			default:
				return yalwa.v.lang.share_text_ad;
		}
	}

	function prepare_share_title(position) {
		switch (position) {
			case 'VIP_mobile':
				return yalwa.v.lang.share_subject_image;
			case 'profile':
				return yalwa.v.lang.share_subject_profile;
			case 'burger_menu':
				return yalwa.v.lang.share_subject_page;
			default:
				return yalwa.v.lang.share_subject_ad;
		}
	}

	function prepare_share_urls(element, position) {
		var urls = {};
		var base_url = window.location.href;
		var base_short_url = document.location.protocol + '//locan.to' + (document.location.port ? ':' + document.location.port : '') + '/' + yalwa.basics.get_msgID(null, true);
		switch (position) {
			case 'VIP_mobile':
				urls.url = base_url + '%26image_featured%3D' + yalwa.vap.current_index;
				urls.short_url = base_short_url + '&i=' + yalwa.vap.current_index;
				break;
			case 'profile':
			case 'burger_menu':
				urls.url = base_url;
				urls.short_url = base_url;
				break;
			default:
				urls.url = base_url;
				urls.short_url = base_short_url;
		}

		return urls;
	}

	pub.handle_push = function(data) { // beware: used via cordova
		if (yalwa.push) {
			yalwa.push.process(data);
		}
	};

	pub.is_mdot_domain = function() {
		return location.hostname.search(/^m\./) === 0;
	};
	
	pub.cordova = (function(pub) {
		
		pub = pub || {};
		
		let $default_upload_input;
		let fileupload_timeout;
		let fileupload_timeout_first;
		let twofactor_first_time = true;
		
		pub.init = function() {
			pub.set_default_upload_input();
			// IOS App history_back button fix
			if (yalwa.v.is_ios) {
				if ((window.location.href === yalwa.v.chp_url && (document.referrer === '' || document.referrer === yalwa.v.chp_url)) || document.referrer === '' || window.history.length === 1) {
					yalwa.mobile.cordova.remove_backbutton();
				}
				if (window.history.state && window.history.state.ltw_type === 'root') {
					yalwa.mobile.cordova.remove_backbutton();
				}
			}
			
			if (!yalwa.v.is_ios) {
				yalwa.mobile.cordova.apply_cordova_image_upload_listener();
			}
			
			if (['login', 'logout'].indexOf(yalwa.basics.get_routing()) === -1) {
				if (!yalwa.v.is_read_only_mode) {
					if (yalwa.v.phonegap_logged_in && yalwa.v.phonegap_logged_in.userID) {
						yalwa.mobile.cordova.cordova_send({
							action: 'login_store',
							params: {data: yalwa.v.phonegap_logged_in, url: location.href}
						});
					} else if (window.location.hostname !== 'secure.locanto.info' && window.location.hostname !== 'm.uae.locanto.asia') {
						// no auto-login on checkout page, we don't have the session info there
						// no auto-login on aue personals page, causes infinite autologin attempts
					}
				}
				yalwa.mobile.cordova.cordova_send({
					action: 'country_info',
					params: {ID: yalwa.v.countryID, name: yalwa.v.phonegap_countryname}
				});
				yalwa.mobile.cordova.cordova_send({action: 'check_pending_pushes', params: {}});
			}
			//jQuery('.js-openexternal').on('click', openexternal_click);
			
			init_ajax_reload_routine();
			
			$document.on('click', 'a[href][target="_blank"]', new_tab_links);
			if (yalwa.v.is_ios) {
				// hack to resolve bug during input focus and status bar
				$main_col.on('focus', 'input,textarea', function() {
					if (jQuery(this).is('.js-snh_search')) {
						return false;
					}
				})
				yalwa.basics.progress.load();
			} else {
				$window.on('beforeunload', function() {
					yalwa.mobile.page_will_unload();
				}); // safari doesnt support beforeunload and pagehide doesnt seem to work in inappbrowser
			}
			if (yalwa.mobile.is_mdot_domain()) {
				window.setTimeout(function() {
					yalwa.mobile.cordova.cordova_send({
						action: 'mc_count',
						params: {value: yalwa.mobile.get_mc_count()}
					});
				}, 2000);
			}
			if (
				!yalwa.basics.is_logged_in() &&
				yalwa.basics.auth.gsi.black_listed_routes_for_one_tap.indexOf(yalwa.basics.get_routing()) === -1
				&& !yalwa.v.is_ios
			) {
				pub.google_login_request('one_tap');
			}
		};
		
		pub.set_default_upload_input = function($default_input) {
			$default_upload_input = jQuery('.js-upload');
		}
		
		// The InAppBrowser message bridge replaces cordova_collect polling.
		// Only the app versions whose expander registers a 'message' listener
		// understand these payloads, older apps must keep using the queue.
		function is_iab_message_bridge_active() {
			const app_type = yalwa.basics.yalwapp_type();
			const app_version = yalwa.basics.yalwapp_version();
			return (app_type === 'g' && app_version >= 3016) || (app_type === 'h' && app_version >= 3022);
		}
		
		//moved from basic.js
		pub.cordova_send = function(object) {
			if (!yalwa.v.is_phonegap) {
				return;
			}
			
			if (is_iab_message_bridge_active()) {
				try {
					if (yalwa.v.is_ios &&
						typeof window.webkit === 'object' &&
						window.webkit.messageHandlers &&
						window.webkit.messageHandlers.cordova_iab) {
						window.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(object));
						return;
					}
					if (!yalwa.v.is_ios && typeof cordova_iab === 'object' && cordova_iab.postMessage) {
						cordova_iab.postMessage(JSON.stringify(object));
						return;
					}
				} catch (e) {
					// Keep the old queue as a compatibility fallback for older IAB builds.
				}
			}
			
			yalwa.v.send_pending = yalwa.v.send_pending || [];
			yalwa.v.send_pending.push(object);
		};
		
		var last_file_input_clicked;
		
		pub.apply_cordova_image_upload_listener = function() {
			$body
				.off('click.image_request', 'input[type="file"]')
				.on('click.image_request', 'input[type="file"]', on_cordova_fileinput_click);
		};
		
		pub.show_native_rating_dialog = function() {
			yalwa.mobile.cordova.cordova_send({action: 'show_native_rating_dialog'});
		};
		
		function on_cordova_fileinput_click(e) { // android only
			const use_always_default_input = ['paf', 'PAF_create_new'];
			if (use_always_default_input.indexOf(yalwa.v.routing) === -1) {
				last_file_input_clicked = this;
			}
			e.preventDefault(); //stop native click event!!!
			yalwa.mobile.cordova.cordova_send({
				action: 'image_request',
				params: {source: (jQuery(this).prop('cordova_camera') || jQuery(this).attr('cordova_camera')) ? 'camera' : 'folder'}
			});
			if (yalwa.mobile) {
				yalwa.mobile.app_progress();
			}
		}
		
		//**dataURL to blob**
		// see https://gist.github.com/wuchengwei/b7e1820d39445f431aeaa9c786753d8e
		pub.dataURLtoBlob = function(dataurl) { // beware: used via cordova
			var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
				bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], {type: mime});
		};
		
		pub.b64_to_blob = function(b64Data, contentType, sliceSize) { // http://stackoverflow.com/a/16245768 needed for android app file upload
			try {
				contentType = contentType || '';
				sliceSize = sliceSize || 512;
				
				var byteCharacters = atob(b64Data);
				var byteArrays = [];
				
				for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
					var slice = byteCharacters.slice(offset, offset + sliceSize);
					
					var byteNumbers = new Array(slice.length);
					for (var i = 0; i < slice.length; i++) {
						byteNumbers[i] = slice.charCodeAt(i);
					}
					
					var byteArray = new Uint8Array(byteNumbers);
					
					byteArrays.push(byteArray);
				}
				
				return new Blob(byteArrays, {type: contentType});
			} catch (e) {
				//return false;
				return e;
			}
		};
		
		pub.cordova_upload_blob_new = function(b64Data) { // beware: used via cordova
			cordova_upload_blob_internal(b64Data, 'new');
		};
		
		pub.cordova_upload_blob = function(b64Data) { // beware: used via cordova
			cordova_upload_blob_internal(b64Data, 'old');
		};
		
		function wait_for_fileupload_initialization(b64Data, method) {
			if (fileupload_timeout_first && fileupload_timeout > fileupload_timeout_first + 15) { // try only 15 time
				yalwa.basics.sentry.submit_error(new Error('cordova file upload problem: after waiting for initialization 15 seconds breaking'));
				fileupload_timeout_first = false;
				return;
			} else if (last_file_input_clicked && jQuery(last_file_input_clicked).length) {
				if (typeof jQuery(last_file_input_clicked).fileupload_me === 'function') {
					jQuery(last_file_input_clicked).fileupload_me();
				} else if (typeof jQuery(last_file_input_clicked).fileupload === 'function') {
					jQuery(last_file_input_clicked).fileupload();
				}
			} else {
				if (typeof $default_upload_input.fileupload_me === 'function') {
					$default_upload_input.fileupload_me();
				} else if (typeof $default_upload_input.fileupload === 'function') {
					$default_upload_input.fileupload();
				}
			}
			fileupload_timeout = setTimeout(function() {
				cordova_upload_blob_internal(b64Data, method);
			}, 1000);
			if (!fileupload_timeout_first) {
				fileupload_timeout_first = fileupload_timeout;
			}
		}
		
		function is_fileupload_initialized(b64Data, method) {
			if (!jQuery(last_file_input_clicked).length && !$default_upload_input.length) {
				yalwa.basics.sentry.submit_error(new Error('cordova file upload problem: could not determine either clicked or default input file'));
				return false;
			} else if (last_file_input_clicked && jQuery(last_file_input_clicked).length) {
				if (typeof jQuery.data(last_file_input_clicked, 'blueimp-fileupload') !== 'object') {
					wait_for_fileupload_initialization(b64Data, method);
					return false;
				} else {
					return fileupload_initialisation_success();
				}
			} else if ($default_upload_input.length) {
				if (typeof jQuery.data($default_upload_input[0], 'blueimp-fileupload') !== 'object') {
					wait_for_fileupload_initialization(b64Data, method);
					return false;
				} else {
					return fileupload_initialisation_success();
				}
			} else {
				return fileupload_initialisation_success();
			}
		}
		
		function fileupload_initialisation_success() {
			if (fileupload_timeout) {
				clearTimeout(fileupload_timeout);
			}
			return true;
		}
		
		function cordova_upload_blob_internal(b64Data, method) { // beware: used via cordova
			if (!is_fileupload_initialized(b64Data, method)) {
				return;
			}
			const blob = (method === 'old' ? yalwa.mobile.cordova.b64_to_blob(b64Data, 'data:image/jpeg;base64,') : yalwa.mobile.cordova.dataURLtoBlob(b64Data));
			if (blob) {
				if (last_file_input_clicked && jQuery(last_file_input_clicked).length) {
					try {
						jQuery(last_file_input_clicked).fileupload('add', {files: [blob]});
					} catch (e) {
						//only on MC
						if ($default_upload_input.length) {
							$default_upload_input.fileupload('add', {files: [blob]});
						} else {
							yalwa.basics.sentry.submit_error(new Error('cordova file upload problem: no valid input file')); //?
						}
					}
				} else if ($default_upload_input.length) {
					$default_upload_input.fileupload('add', {files: [blob]});
				} else {
					yalwa.basics.sentry.submit_error(new Error('cordova file upload problem: couldnt determine input file')); //?
				}
			} else {
				yalwa.basics.sentry.submit_error(new Error('cordova file upload problem: blob not supported'));
			}
		}
		
		pub.logout_success_promise = function() {
			$document.trigger('logout_success');
		};
		
		pub.cordova_collect = function() { // beware: used via cordova
			var pending = yalwa.v.send_pending;
			if (pending) {
				yalwa.v.send_pending = null;
			}
			if (is_real_cordova() && !yalwa.basics.ss_get('ircs') && !is_real_cordova_check_in_progress) {
				send_is_real_cordova_check_result();
			}
			return {items: pending, timeout: 500};
		};
		
		let is_real_cordova_check_in_progress = false;
		
		function is_real_cordova() {
			if (
				yalwa.v.irc &&
				yalwa.v.is_phonegap &&
				(
					(
						yalwa.v.is_ios &&
						typeof window.webkit === 'object' &&
						typeof window.webkit.messageHandlers === 'object' &&
						typeof window.webkit.messageHandlers.cordova_iab === 'object'
					) ||
					!yalwa.v.is_ios &&
					typeof cordova_iab === 'object'
				)
			) {
				return true;
			} else {
				return false;
			}
		}
		
		function send_is_real_cordova_check_result() {
			is_real_cordova_check_in_progress = true;
			jQuery.ajax({
				url: '/api/ajax/general',
				data: {
					action: 'irc',
					irc: yalwa.v.irc
				},
				dataType: 'json',
				type: 'post',
				cache: false,
			}).done((response) => {
				is_real_cordova_check_in_progress = false;
				if (!response.success) {
					yalwa.basics.ss_set('ircs', true);
				} else {
					yalwa.basics.ss_set('ircs', true);
				}
			});
		}
		
		pub.ios_workaround_focus = function() {
			$headroom.addClass('headroom--absolute');
			yalwa.basics.hide(jQuery('.js-pullrefresh'));
			yalwa.basics.hide(jQuery('.js-mpaf_controls'));
		};
		
		pub.ios_workaround_blur = function() {
			$headroom.removeClass('headroom--absolute');
			yalwa.basics.show(jQuery('.js-pullrefresh'));
			yalwa.basics.show(jQuery('.js-mpaf_controls'));
		};
		
		pub.openexternal = function(url) {
			if (yalwa.v.is_phonegap) {
				yalwa.mobile.cordova.cordova_send({action: 'openexternal', params: {url: url}});
			}
		};
		pub.openintent = function(url) {
			if (yalwa.v.is_phonegap) {
				// openpartner action uses default webintent in old apps
				yalwa.mobile.cordova.cordova_send({action: 'openpartner', params: {url: url}});
			}
		};
		
		pub.receive_geolocation_success = function(position) {  // beware: used via cordova
			$document.trigger('geolocation_success.' + position.type, position);
		};
		
		pub.receive_geolocation_error = function(error_code) {  // beware: used via cordova
			display_geolocation_error(error_code);
		};
		
		pub.receive_stats = function(cordova_stats) {  // beware: used via cordova
			if (!cordova_stats) {
				return false;
			}
			
			if (yalwa.mobile.generic_shadow.showing()) {
				return false;
			}
			
			let show_later_check_ts = yalwa.basics.ls_get('app_rating_later')
				? yalwa.basics.ls_get('app_rating_later')
				: cordova_stats.first_launch;
			
			if (show_later_check_ts < yalwa.basics.unix() - yalwa.basics.ONE_WEEK
				&& cordova_stats.page_count
				&& cordova_stats.page_count > 100
			) {
				yalwa.mobile.app_rating.show();
			}
		};
		
		pub.share_finished = function() {
		
		};
		
		pub.remove_backbutton = function() { // beware: used via cordova
			jQuery('.js-history_back').addClass('ybtb__li--disabled');
		};
		
		pub.activate_backbutton = function() { // beware: used via cordova
			jQuery('.js-history_back').removeClass('ybtb__li--disabled');
		};
		
		pub.on_resume = function(last_remote_url) {  // beware: used via cordova (iOS only currently)
			// not used yet
		};
		
		pub.get_country_list = function(list) {
			// no longer needed?
		};
		
		function openexternal_click(e) {
			yalwa.mobile.cordova.openexternal(jQuery(this).prop('href'));
			e.preventDefault();
			e.stopPropagation();
			return false;
		};
		
		function new_tab_links(event) {
			event.preventDefault();
			if (jQuery(event.target).is('.js-external_link_image, .js-external_links')) {
				return;
			}
			const href = jQuery(this).prop('href');
			if (yalwa.basics.yalwapp_version() >= 250) {
				if (jQuery(this).data('latitude') && jQuery(this).data('longitude')) {
					yalwa.basics.openwebintent(href);
				} else if (url_is_external(href)) {
					if (jQuery(this).hasClass('js-app_intent')) {
						yalwa.mobile.cordova.openintent(href);
					} else {
						yalwa.mobile.cordova.openexternal(href);
					}
				} else if (jQuery(this).hasClass('js-force_second_webview')) {
					yalwa.basics.opensecondwebview(href);
				} else if (jQuery(this).hasClass('js-open_webintent')) {
					yalwa.basics.openwebintent(href);
				} else {
					yalwa.basics.navigate(href);
				}
			} else {
				yalwa.mobile.cordova.openexternal(href);
			}
		}
		
		function url_is_external(url) {
			var url_parsed = parse_url(url);
			if (url_parsed.hostname.search(/\blocanto\./) !== -1) {
				// handle internal PDFs in cordova
				if (url.search(/pdf\?s=/) !== -1 || url.search(/invoice\/\?id=/) !== -1) {
					return true;
				}
				return false;
			}
			return true;
		}
		
		function parse_url(url) {
			var a = document.createElement('a');
			a.href = url;
			return a;
		}
		
		pub.google_login_success_receiver = async function(response) {
			let idToken =  (!yalwa.v.is_ios_app) ? response.credential : response.credential.idToken;
			let data = {
				action: 'login_social',
				type: 'google',
				credential: idToken,
				select_by: response.select_by,
				fp_hash: await yalwa.basics.fingerprint.get_hash(),
			};
			backend_request_google(data);
		}
		
		function backend_request_google(data) {
			jQuery.ajax({
				url: '/api/ajax/general',
				type: 'post',
				dataType: 'json',
				cache: false,
				data: data
			}).done(async (response) => {
				if (response.result === 'twofactor_needed') {
					await yalwa.basics.import_js('shared/web_components/twofactor.js');
					jQuery('body').append('<yalwa-twofactordialog></yalwa-twofactordialog>');
					jQuery('yalwa-twofactordialog')[0].request_action('code', {email: response.email}).then(() => {
						if (!twofactor_first_time) {
							jQuery('yalwa-twofactordialog')[0].show_invalid();
						}
						twofactor_first_time = false;
					});
					jQuery(document).on_once('twofactor-code-submitted.login', 'yalwa-twofactordialog', async function(event) {
						data.otp_token = event.originalEvent.detail.code || event.originalEvent.detail.backup_code;
						data.remember_browser = event.originalEvent.detail.remember_browser;
						backend_request_google(data);
					});
					return;
				}
				if (response.success) {
					yalwa.basics.auth.gsi.on_success_callback();
					if (yalwa.basics.auth.redirect_to) {
						yalwa.basics.navigate(yalwa.basics.auth.redirect_to)
					} else {
						yalwa.basics.reload();
					}
				}
			});
		}
		
		pub.google_login_error_receiver = function(data) {
			//('gsi_error', data);
			// error:: 16: Caller has been temporarily blocked due to too many canceled sign-in prompts.
		}
		
		pub.google_login_request = function(type) {
			const data = {
				web_client_id: '373637357546.apps.googleusercontent.com',
				login_type: type
			};
			if (yalwa.basics.yalwapp_type() === 'g') {
				data.web_client_id = '630539875517-sop6rmv3iekfu85uhv7od9iunm8r6lbd.apps.googleusercontent.com';
			}
			if (yalwa.basics.yalwapp_type() === 'h') {
				data.web_client_id = '630539875517-sqblj0cadrrm3iacmhm5kcs6p76egcis.apps.googleusercontent.com';
			}
			yalwa.mobile.cordova.cordova_send({action: 'google_login', params: data});
		}
		
		pub.receiver_apple_login_success = function(data) {
			apple_login.handle_success(data);
		};
		
		pub.receiver_apple_login_failure = function(msg) {
			apple_login.handle_failure(msg);
		};
		
		let apple_login = {
			handle_failure: function(msg) {
				if (msg) {
					//this.track('error', msg);
					// yalwa.basics.sentry.submit_error(new Error('#Dating App apple_login error: ' + msg));
				}
			},
			handle_success: async function(obj) {
				backend_request_apple({
					action: 'login_social',
					type: 'apple',
					credential: obj.identityToken,
					client_user: obj.user,
					full_name: obj.fullName,
					fp_hash: await yalwa.basics.fingerprint.get_hash(),
				});
			}
		};
		
		function backend_request_apple(data) {
			jQuery.ajax({
				url: '/api/ajax/general',
				type: 'post',
				dataType: 'json',
				cache: false,
				data: data
			}).done(async (response) => {
				if (response.result === 'twofactor_needed') {
					await yalwa.basics.import_js('shared/web_components/twofactor.js');
					jQuery('body').append('<yalwa-twofactordialog></yalwa-twofactordialog>');
					jQuery('yalwa-twofactordialog')[0].request_action('code', {email: response.email}).then(() => {
						if (!twofactor_first_time) {
							jQuery('yalwa-twofactordialog')[0].show_invalid();
						}
						twofactor_first_time = false;
					});
					jQuery(document).on_once('twofactor-code-submitted.login', 'yalwa-twofactordialog', async function(event) {
						data.otp_token = event.originalEvent.detail.code || event.originalEvent.detail.backup_code;
						data.remember_browser = event.originalEvent.detail.remember_browser;
						backend_request_apple(data);
					});
					return;
				}
				if (response.success) {
					if (response.redirect_url) {
						yalwa.basics.navigate(response.redirect_url);
						return;
					}
					yalwa.basics.auth.gsi.on_success_callback();
					if (yalwa.basics.auth.redirect_to) {
						yalwa.basics.navigate(yalwa.basics.auth.redirect_to)
					} else {
						yalwa.basics.reload();
					}
				}
			});
		}
		
		return pub;
		
	}(pub.cordova));

	pub.modal_show = function() {
		if (!jQuery('.js-cart').hasClass('hidden')) {
			yalwa.basics.hide(jQuery('.js-cart').data('modal_toggled', true));
		}
	};

	pub.modal_hide = function() {
		if (jQuery('.js-cart').data('modal_toggled')) {
			yalwa.basics.show(jQuery('.js-cart').data('modal_toggled', false));
		}
	};

	function check_supports_passive() {
		supports_passive_event_handler = false;
		try {
			var opts = Object.defineProperty({}, 'passive', {
				get: function() {
					supports_passive_event_handler = true;
				}
			});
			window.addEventListener("test", null, opts);
		} catch (e) {
		}
	}

	// safari doesnt support beforeunload and pagehide doesnt seem to work in inappbrowser
	pub.page_will_unload = function(url) {
		if (yalwa.basics.is_app()) {
			jQuery('#logo').addClass('indicate_loading');
		}
		if (yalwa.v.is_phonegap) {
			var disable_progress = false;
			if (url) {
				if (yalwa.v.is_ios && url.search(/maps\.(apple|google)/) !== -1) {
					disable_progress = true;
				}
				if (url.search('tel:') !== -1) {
					disable_progress = true;
				}
				if (url.search('locanto') === -1) {
					disable_progress = true;
				}
			}
			if (!disable_progress) {
				yalwa.mobile.app_progress();
			}
		}
	};

	pub.supports_passive = function() {
		return supports_passive_event_handler ? {passive: true} : false;
	};

	pub.get_current_position = function(timeout, type) {
		if (yalwa.v.is_phonegap) {
			if (navigator && navigator.geolocation && yalwa.basics.yalwapp_version() <= 271) {
				return navigator.geolocation.getCurrentPosition(
					function(position) {
						$document.trigger('geolocation_success.' + type, position);
					},
					function(error) {
						$document.trigger('geolocation_error.' + type, error);
					}, {
						timeout: timeout
					}
				);
			} else {
				// since on old inappbrowser do not fired loadstop event this can not be working but try once
				yalwa.mobile.cordova.cordova_send({action: 'geolocation', params: {type: type}});
			}
		} else {
			if (navigator && navigator.geolocation) {
				return navigator.geolocation.getCurrentPosition(
					function(position) {
						$document.trigger('geolocation_success.' + type, position);
					},
					function(error) {
						$document.trigger('geolocation_error.' + type, error);
					}, {
						timeout: timeout
					}
				);
			} else {
				$document.trigger('geolocation_error.' + type, null);
			}
		}
	};

	pub.track_cart_upselling_datalayer_event = function(name) {
		yalwa.basics.ga.datalayer({
			event: 'shopping_cart_upsell',
			shopping_cart_upsell: name
		});
	}

	var premium_first_load = true;
	var premium = (function(pub) {

		pub = pub || {};

		pub.init = function() {

			jQuery('.js-book_premium_checkbox_feature').on('change', checkbox_feature_toggle);
			jQuery('.js-book_premium_checkbox_extension').on('change', checkbox_extension_toggle);
			jQuery('.js-pf_clear_shopping_cart').on('click', cart_reset);
			jQuery('.js-pf_duration').on('change', select_change);
			jQuery('.js-book_premium_proceed').on('click', proceed);
			jQuery('.js-pf_feature_remove,.js-pf_feature_remove_all').on('click', feature_remove);
			jQuery('.js-pf_extension_remove').on('click', extension_remove);
			jQuery('.js-pf_go_checkout').on('click', go_checkout);
			jQuery('.js-pf_extension_category_parent').on('click', category_extension_toggle_all);

			jQuery('.js-book_premium_checkbox_feature:checked').each(checkbox_feature_toggle);
			jQuery('.js-book_premium_checkbox_extension:checked').each(checkbox_extension_toggle);
			premium_first_load = false;

			if (is_cart()) {
				check_cart_upselling_offer();
			} else {
				update_amount_total();
			}
		};

		function update_shopping_cart_offer_timer(timer_element, end_time_ms, remove_selector) {
			const original_format = timer_element.html().trim();

			const update_timer = () => {
				const now = Date.now();
				const remaining_ms = end_time_ms - now;

				if (remaining_ms <= 0) {
					jQuery(remove_selector).remove();
					return;
				}

				const total_seconds = Math.floor(remaining_ms / 1000);
				const hours = Math.floor(total_seconds / 3600);
				const minutes = Math.floor((total_seconds % 3600) / 60);
				const seconds = total_seconds % 60;

				const formatted_time = original_format
					.replace('%1$sh', "<strong>" + hours + "h</strong>")
					.replace('%1$su', "<strong>" + hours + "u</strong>")
					.replace('%2$sm', "<strong>" + minutes + "m</strong>")
					.replace('%3$ss', "<strong>" + seconds + "s</strong>");

				timer_element.html(formatted_time);
				yalwa.basics.show(timer_element);
				setTimeout(update_timer, 1000);
			};

			update_timer();
		}

		function check_cart_upselling_offer() {
			if (yalwa.v.shopping_cart_offer_end_ts) {
				const timer_element = jQuery('.js-sc_upselling_timer');
				if (!timer_element.length) return;

				const end_time = yalwa.v.shopping_cart_offer_end_ts * 1000;
				update_shopping_cart_offer_timer(
					timer_element,
					end_time,
					'.js-sc_upselling_info'
				);
			}
		}

		function category_extension_toggle_all() {
			//var value = !!jQuery('.js-pf_extension_category input:not(:checked)').length;
			var value = jQuery(this).prop('checked');
			jQuery('.js-pf_extension_category input[type="checkbox"]').each(function() {
				jQuery(this).prop('checked', value);
			});
			update_amount(get_feature(jQuery(this)));
			update_amount_total();
		}

		function go_checkout(e) {
			var $form = jQuery('.js-pf_cart_form');
			$form.find('.js-pf_hidden_appended').remove();
			var features = get_selected_features();
			var inputs = [];
			for (var i = 0; i < features.length; i++) {
				var f = features[i];
				if (typeof (f.featureID) === 'string' && f.featureID.search('_') !== -1) { // category extension
					var tmp = f.featureID.split('_');
					var featureID = tmp[0];
					var featureID_sub = tmp[1];
					inputs.push('<input type="hidden" class="js-pf_hidden_appended" name="orders[' + f.msgID + '][' + featureID + '][' + featureID_sub + ']" value="' + f.amount + '" />');
					if (f.touchpointID) {
						inputs.push('<input type="hidden" class="js-pf_hidden_appended" name="touchpoints[' + f.msgID + '][' + featureID + '][' + featureID_sub + ']" value="' + f.touchpointID + '" />');
					}
				} else {
					inputs.push('<input type="hidden" class="js-pf_hidden_appended" name="orders[' + f.msgID + '][' + f.featureID + ']" value="' + f.amount + '" />');
					if (f.touchpointID) {
						inputs.push('<input type="hidden" class="js-pf_hidden_appended" name="touchpoints[' + f.msgID + '][' + f.featureID + ']" value="' + f.touchpointID + '" />');
					}
				}
			}
			$form.append(inputs.join(''));
			$form.submit();
		}

		function feature_remove() {
			if (!yalwa.basics.readonly_check()) {
				return;
			}
			var $this = jQuery(this);

			if ($this.hasClass('js-has_freebie_in_bundle')) {
				freebie_bundle_remove($this);
				return;
			}

			var $feature;
			if ($this.hasClass('js-pf_feature_remove_all')) {
				$feature = get_feature($this.closest('.js-pf_posting_title').next('.js-pf_feature'));
			} else {
				$feature = get_feature($this);
			}
			$feature.addClass('js-marked_for_delete');
			if (is_cart()) {
				cart_set_request();
			}

			let $posting_title = $this.closest('.js-cart_item').find('.js-pf_posting_title');

			if ($posting_title.length && !$feature.next().is('.js-pf_feature') && !$feature.prev().is('.js-pf_feature')) {
				$posting_title.remove();
				const $container = get_item($feature);
				$container.remove();
			}
			const $item = get_item($feature);
			$feature.remove();
			update_amount_subtotal($item);
			update_amount_total();
		}

		function freebie_bundle_remove($button) {
			const $bundle = $button.closest('.js-cart_item');
			const $features = $bundle.find('.js-pf_feature');

			// Set cart and make an API request
			$features.addClass('js-marked_for_delete');
			if (is_cart()) {
				cart_set_request();
			}
			// Remove elements
			$bundle.remove();
			update_amount_total();
		}

		function extension_remove() {
			var $extension = get_extension(jQuery(this));
			var $feature = get_feature($extension);
			$extension.addClass('js-marked_for_delete');
			if (is_cart()) {
				cart_set_request();
			}
			$extension.remove();
			update_amount($feature);
			update_amount_total();
		}



		pub.load_cart_headroom_promo = function() {
			if (yalwa.v.cart_upselling_offer_ts) {
				jQuery.get(
					'/api/ajax/general',
					{
						action: 'load_cart_upselling_html',
						template: 'headroom'
					},
					function(response) {
						jQuery('.js-headroom_infobanners').html(response.html);
						yalwa.mobile.track_cart_upselling_datalayer_event('banner_views');
						jQuery('.js-upselling_info').on('click', () => {
							yalwa.mobile.track_cart_upselling_datalayer_event('banner_click');
						});
						const timer_element = jQuery('.js-cart_upselling_timer');
						if (!timer_element.length) return;

						if (yalwa.v.cart_upselling_offer_ts) {
							const end_time = yalwa.v.cart_upselling_offer_ts * 1000;
							update_shopping_cart_offer_timer(
								timer_element,
								end_time,
								'.js-upselling_info'
							);
						}
					},
					'json'
				);
			}
		};

		pub.init_cart = function() {
			// avoid caching issues on mobile devices
			pub.init_shopping_cart_badge_update();
			jQuery('.js-pf_feature').each(function() {
				update_amount(jQuery(this));
			});
			update_amount_total();
			jQuery('.js-cart_select').on('change', select_change);
			if (yalwa.v.skip_shopping_cart_form && jQuery('.js-pf_go_checkout').length) {
				jQuery('.js-pf_go_checkout').trigger('click');
			}
			pub.open_pa_dialog_click_listener();
		};
		
		pub.open_pa_dialog_click_listener = function() {
			jQuery('.js-open_pa_dialog').on('click', () => {
				yalwa.mobile.load_pa_plan_overlay('paf_website_phone');
			});
		}

		pub.init_shopping_cart_badge_update = function() {
			const $cart = jQuery('.js-cart');
			if (parseInt(yalwa.basics.ls_get('cart_count')) !== -1) {
				yalwa.basics.ls_set('cart_count', yalwa.v.shopping_cart_count ? yalwa.v.shopping_cart_count : 0);
			} else {
				if ($cart.length > 0) {
					$cart.remove();
					yalwa.basics.ls_set('cart_count', 0);
				}
			}
		}

		function proceed() {
			var $t = jQuery(this);
			if (!get_selected_features().length) {
				if (jQuery('.js-book_premium_mandatory').length) {
					jQuery('.js-book_premium_plp_mandatory').trigger('plp_show');
					return;
				}
				if (is_paf_confirm()) {
					var $form = jQuery('<form action="" method="post"><input type="hidden" name="msgID" value="' + jQuery('.js-book_premium').data('msgid') + '" /><input type="hidden" name="skip_pf" value="1" /></form>');
					$body.append($form);
					$form.trigger('submit');
				} else {
					yalwa.basics.navigate($t.data('url'));
				}
			} else {
				//cart_set_request().done(function() {
				yalwa.basics.navigate($t.data('url'));
				//});
			}
		}

		function get_item($element) {
			return $element.closest('.js-cart_item');
		}

		function get_feature($element) {
			return $element.closest('.js-pf_feature');
		}

		function get_extension($element) {
			return $element.closest('.js-pf_extension');
		}

		function extension_active($extension) {
			return $extension.find('.js-book_premium_checkbox_extension').is(':checked');
		}

		function check_mutually_exclusive_constrains($extension_clicked) {
			if (extension_active($extension_clicked)) {
				var exclusive_pairs = [[11, 12], [13, 12]];
				for (var i = 0; i < exclusive_pairs.length; i++) {
					var first = exclusive_pairs[i][0];
					var second = exclusive_pairs[i][1];
					var other = null;
					if ($extension_clicked.data('featureid') === first) {
						other = second;
					}
					if ($extension_clicked.data('featureid') === second) {
						other = first;
					}
					if (other) {
						var $other = get_feature($extension_clicked).find('.js-pf_extension').filter('[data-featureid="' + other + '"]');
						if (extension_active($other)) {
							$other.find('.js-book_premium_checkbox_extension').prop('checked', false);
						}
					}
				}
			}
		}

		function checkbox_extension_toggle() {
			var $feature = get_feature(jQuery(this));
			var $extension = get_extension(jQuery(this));
			checkbox_extension_is_category_child_and_checked(jQuery(this));
			check_mutually_exclusive_constrains($extension);
			update_amount($feature);
			update_amount_total();
			if (performance.navigation.type !== 2 || !premium_first_load) {
				cart_set_request_in_book_upgrade();
			}
		}

		function checkbox_extension_is_category_child_and_checked($this) {
			if ($this.hasClass('js-book_premium_checkbox_extension_child')) {
				var $container = $this.closest('.js-book_premium__extension--categoryparent');
				var check_parent = false;
				$container.find('.js-book_premium_checkbox_extension_child').each(function() {
					if (jQuery(this).prop('checked')) {
						check_parent = true;
					}
				});
				$this.closest('.js-book_premium__extension--categoryparent').find('.js-pf_extension_category_parent').prop('checked', check_parent);
			}
		}

		function checkbox_feature_toggle() {
			var $checkbox = jQuery(this);
			var $feature = get_feature($checkbox);
			var $desc = $feature.find('.js-book_premium_description');
			var $select = $feature.find('.js-pf_duration');
			var $extensions = $feature.find('.js-pf_extensions');
			if ($checkbox.is(':checked')) {
				yalwa.basics.hide($desc);
				yalwa.basics.show($select);
				yalwa.basics.show($extensions);
				$select.focus();
			} else {
				yalwa.basics.show($desc);
				yalwa.basics.hide($select);
				yalwa.basics.hide($extensions);
			}
			update_amount($feature);
			update_amount_total();
			if (performance.navigation.type !== 2 || !premium_first_load) {
				cart_set_request_in_book_upgrade();
			}

		}

		function select_change() {
			var $select = jQuery(this);
			var $feature = get_feature($select);
			update_amount($feature);
			update_amount_total();
			if (is_cart()) {
				cart_set_request();
			}
			if (is_book_upgrade && performance.navigation.type !== 2) {
				cart_set_request();
			}
		}

		function update_cart_count(count) {
			jQuery('.js-cart_count').text(count ? parseInt(count, 10) : '');
			yalwa.basics.ls_set('cart_count', String(count && parseInt(count) !== 0 ? parseInt(count, 10) : -1));
		}

		function cart_reset() {
			jQuery('.js-pf_clear_confirm').trigger('plp_show');
			jQuery('.js-pf_clear_confirm .js-plp_confirm').off('click.clear_cart').on('click.clear_cart', function() {
				if (!yalwa.basics.readonly_check()) {
					return false;
				}
				clear_cart_request().done(after_clear_cart);
			});
		}

		function after_clear_cart(response) {
			if (response.redirect_url) {
				yalwa.basics.navigate(response.redirect_url);
			} else {
				if (window.location.search.search('empty=1') === -1) {
					window.location.replace(window.location.href + (window.location.search === '' ? '?' : '&') + 'empty=1');
				}
			}
		}

		function clear_cart_request() {
			return jQuery.ajax({
				url: '/api/cart/empty/',
				data: {},
				dataType: 'json'
			});
		}

		pub.shopping_cart_bfcache_handler = function() {
			const count = yalwa.basics.ls_get('cart_count') ? parseInt(yalwa.basics.ls_get('cart_count')) : -1;
			if (count < 1) {
				jQuery('.js-cart').addClass('hidden');
			} else {
				jQuery('.js-cart_count').text(count ? parseInt(count, 10) : '');
			}
		}

		function feature_is_selected($feature) {
			return !!$feature.find('.js-book_premium_checkbox_feature').is(':checked');
		}

		function extension_is_selected($extension) {
			return !!$extension.find('.js-book_premium_checkbox_extension').is(':checked');
		}

		function feature_get_selected_option($feature) {
			let $pf_duration_container = $feature.find('.js-pf_duration');
			if ($pf_duration_container.is('select')) {
				return $pf_duration_container.find('option:selected');
			}

			return $pf_duration_container;
		}

		function feature_get_msgID($feature) {
			return $feature.closest('.js-pf_feature').data('msgid');
		}

		function feature_get_featureID($feature) {
			return feature_get_selected_option($feature).data('featureid') || $feature.data('featureid');
		}

		function feature_get_touchpointID($feature) {
			return feature_get_selected_option($feature).data('touchpointid') || $feature.data('touchpointid');
		}

		function feature_get_extensions($feature) {
			return feature_get_extensions_wrap($feature).find('.js-pf_extension');
		}

		function feature_get_extensions_wrap($feature) {
			return $feature.find('.js-pf_extensions');
		}

		function feature_has_extensions($feature) {
			return feature_get_extensions_wrap($feature).length;
		}

		function is_paf_confirm() {
			return get_context() === 'paf_confirm';
		}

		function is_cart() {
			return get_routing() === 'cart';
		}

		function is_book_upgrade() {
			return get_routing() === 'book_upgrade';
		}

		function is_category_extension(id) {
			if (id === 10) {
				return true;
			}
			if (typeof (id) === 'string' && id.search('_') !== -1) {
				var tmp = id.split('_');
				return parseInt(tmp[0]) === 10;
			}
			return false;
		}

		function get_multiply($feature) {
			var $area_extensions = $feature.find('.js-pf_extension').filter('[data-featureid="11"],[data-featureid="12"]');
			if (is_cart()) {
				if ($area_extensions.length === 2) {
					$area_extensions.filter('[data-featureid="12"]').data('multiply_area');
				}
				return $area_extensions.length ? $area_extensions.data('multiply_area') : 1;
			} else {
				var $extension = $area_extensions.find('input:checked').closest('.js-pf_extension');
				return $extension.length ? $extension.data('multiply_area') : 1;
			}

		}

		function feature_get_discount($feature) {
			let discount = 0;
			if ($feature.data('offerid') && yalwa.v.shopping_cart_discount) {
				discount = yalwa.v.shopping_cart_discount;
			} else if ($feature.data('discount')) {
				discount = $feature.data('discount') / 100;
			}
			return discount;
		}

		function amount_apply_discount(amount, discount) {
			return (amount * (1 - discount)).toFixed(2);
		}

		function update_amount($feature) {
			var amount = 0;
			var $option = jQuery();
			let old_price = false; // only activate it if larger_payments_bundle_ids_active
			const discount = feature_get_discount($feature);
			if (is_cart() || feature_is_selected($feature)) {
				$option = feature_get_selected_option($feature);
				amount += parseFloat($option.data('number'));
			}
			if ($feature.find('.js-bundle_old_price').length > 0) {
				old_price = parseFloat(jQuery('.js-bundle_old_price').data('old_price'));
			}
			if (feature_has_extensions($feature) && $option.length) {
				feature_get_extensions($feature).each(function() {
					var $extension = jQuery(this);
					var multiply = 1;
					if (is_category_extension($extension.data('featureid'))) {
						multiply = get_multiply($feature);
					}
					var value = parseFloat($option.data('factor')) * parseFloat($extension.data('factor')) * parseFloat(multiply);


					if (discount) {
						$extension.find('.js-pf_extension_amount')
							.attr('data-amount', amount_apply_discount(value, discount))
							.attr('data-amount-without-discount', value)
							.html(format_price(amount_apply_discount(value, discount)) + "<span class='cart__price_old'>" + format_price(value) + "</span>");
					} else {
						$extension.find('.js-pf_extension_amount')
							.attr('data-amount', value)
							.attr('data-amount-without-discount', value)
							.html(format_price(value));
					}
					if (old_price) {
						$feature.find('.js-bundle_old_price').html(format_price(old_price));
					}
				});
			}
			if (old_price) {
				$feature.find('.js-bundle_old_price').html(format_price(old_price));
			}

			if (discount) {
				yalwa.basics.hide($feature.find('.js-bundle_old_price')); // not confuse the user with too much discounts
				$feature.find('.js-pf_feature_amount')
					.attr('data-amount', amount_apply_discount(amount, discount))
					.attr('data-amount-without-discount', amount)
					.html(format_price(amount_apply_discount(amount, discount)) + "<span class='cart__price_old'>" + format_price(amount) + "</span>");
			} else {
				$feature.find('.js-pf_feature_amount')
					.attr('data-amount', amount)
					.attr('data-amount-without-discount', amount)
					.html(format_price(amount));
			}
			update_amount_subtotal(get_item($feature));
		}

		function update_amount_subtotal($item) {
			const total_feature_count = $item.find('.js-pf_feature_amount').length + $item.find('.js-pf_extension_amount').length;
			if (total_feature_count < 2) {
				yalwa.basics.hide($item.find('.js-cart_item_subtotal_wrapper'));
			} else {
				yalwa.basics.show($item.find('.js-cart_item_subtotal_wrapper'));
			}
			let subtotal = 0;
			let subtotal_without_discount = 0;
			$item.find('.js-pf_feature_amount').each(function() {
				if (jQuery(this).attr('data-amount')) {
					subtotal = subtotal + parseFloat(jQuery(this).attr('data-amount'));
					if (jQuery(this).attr('data-amount-without-discount')) {
						subtotal_without_discount += parseFloat(jQuery(this).attr('data-amount-without-discount'));
					}
				}
			})
			$item.find('.js-pf_extension_amount').each(function() {
				if (jQuery(this).attr('data-amount')) {
					subtotal = subtotal + parseFloat(jQuery(this).attr('data-amount'));
					if (jQuery(this).attr('data-amount-without-discount')) {
						subtotal_without_discount += parseFloat(jQuery(this).attr('data-amount-without-discount'));
					}
				}
			});
			if (subtotal_without_discount && subtotal != subtotal_without_discount) {
				$item.find('.js-cart_item_subtotal').html(format_price(subtotal) + "<span class='cart__price_old'>" + format_price(subtotal_without_discount) + "</span>");
			} else {
				$item.find('.js-cart_item_subtotal').html(format_price(subtotal));
			}

		}

		function amount() {
			var $div = jQuery(this);
			var $feature = get_feature($div);
			var value = is_deleted($feature) ? 0 : parseFloat($div.attr('data-amount'));
			return isNaN(value) ? 0 : value;
		}

		function amount_without_discount() {
			var $div = jQuery(this);
			var $feature = get_feature($div);
			var value = is_deleted($feature) ? 0 : parseFloat($div.attr('data-amount-without-discount'));
			return isNaN(value) ? 0 : value;
		}

		function format_price(value) {
			if (!yalwa.basics.is_logged_in()) {
				return false;
			}
			if (jQuery('.js-book_premium').length > 0 && (yalwa.v.currency_symbol === undefined || yalwa.v.currency_precedes === undefined || yalwa.v.currency_sep_by_space === undefined)) {
				yalwa.basics.sentry.submit_error(new Error('missing info for price formatting: ' + jQuery('.js-book_premium').length));
			}
			var string = '';
			if (yalwa.v.currency_precedes) {
				string += yalwa.v.currency_symbol;
				if (yalwa.v.currency_sep_by_space) {
					string += ' ';
				}
			}
			string += format_wrap(value);
			if (!yalwa.v.currency_precedes) {
				if (yalwa.v.currency_sep_by_space) {
					string += ' ';
				}
				string += yalwa.v.currency_symbol;
			}
			return string;
		}

		function number_format(b, a) {
			if (!b || isNaN(+a)) {
				return a;
			}
			var a = b.charAt(0) == "-" ? -a : +a, j = a < 0 ? a = -a : 0, e = b.match(/[^\d\-\+#]/g),
				h = e && e[e.length - 1] || ".", e = e && e[1] && e[0] || ",", b = b.split(h),
				a = a.toFixed(b[1] && b[1].length), a = +a + "", d = b[1] && b[1].lastIndexOf("0"),
				c = a.split(".");
			if (!c[1] || c[1] && c[1].length <= d) {
				a = (+a).toFixed(d + 1);
			}
			d = b[0].split(e);
			b[0] = d.join("");
			var f = b[0] && b[0].indexOf("0");
			if (f > -1) {
				for (; c[0].length < b[0].length - f;) {
					c[0] = "0" + c[0];
				}
			} else {
				+c[0] == 0 && (c[0] = "");
			}
			a = a.split(".");
			a[0] = c[0];
			if (c = d[1] && d[d.length - 1].length) {
				for (var d = a[0], f = "", k = d.length % c, g = 0,
						 i = d.length; g < i; g++) {
					f += d.charAt(g), !((g - k + 1) % c) && g < i - c && (f += e);
				}
				a[0] = f
			}
			a[1] = b[1] && a[1] ? h + a[1] : "";
			return (j ? "-" : "") + a[0] + a[1]
		}

		function format_wrap(value) {
			return number_format(yalwa.v.price_format_payments, value);
		}

		function round_to_two(n) {
			if (typeof n !== "number" || isNaN(n)) {
				return n;
			}
			return Math.round((n + Number.EPSILON) * 100) / 100;
		}

		function update_pa_required_visibility() {
			const $pa_required_wrapper = jQuery('.js-pa_required_button_wrapper');
			if (!$pa_required_wrapper.length) return;

			const has_pa = jQuery('.js-pf_feature[data-is_pa_required="1"]:not(.js-marked_for_delete)').length > 0;
			if (has_pa) {
				yalwa.basics.show($pa_required_wrapper.find('.js-pa_added'));
				yalwa.basics.hide($pa_required_wrapper.find('.js-pa_upgrade'));
			} else {
				yalwa.basics.hide($pa_required_wrapper.find('.js-pa_added'));
				yalwa.basics.show($pa_required_wrapper.find('.js-pa_upgrade'));
			}
		}

		function update_amount_total() {
			update_pa_required_visibility();
			const freebie_in_cart = jQuery('.js-pf_feature[data-freebie=1]').length > 0;
			var totals = jQuery('.js-pf_feature_amount').map(amount);
			var totals_without_discount = jQuery('.js-pf_feature_amount').map(amount_without_discount);
			var totals_without_discount_extensions = jQuery('.js-pf_extension_amount').map(amount_without_discount);
			var total = parseFloat(jQuery('.js-pf_total_sum_add').val()) || 0;
			var total_without_discount = 0;
			for (var i = 0; i < totals.length; i++) {
				total += parseFloat(totals[i]);
			}
			for (var i = 0; i < totals_without_discount.length; i++) {
				total_without_discount += parseFloat(totals_without_discount[i]);
			}
			for (var i = 0; i < totals_without_discount_extensions.length; i++) {
				total_without_discount += parseFloat(totals_without_discount_extensions[i]);
			}
			const extension_totals = jQuery('.js-pf_extension_amount').map(amount);
			var extension_total = 0;
			for (var j = 0; j < extension_totals.length; j++) {
				extension_total += parseFloat(extension_totals[j]);
			}
			total += extension_total;
			total_without_discount = round_to_two(total_without_discount);
			total = round_to_two(total);
			if (total_without_discount && total_without_discount > total) {
				jQuery('.js-pf_amount_total').html(format_price(total) + "<span class='cart__price_old'>" + format_price(total_without_discount) + "</span>");
				const savings = format_price(total_without_discount - total);
				jQuery('.js-sc_discount_savings').html(jQuery('.js-sc_discount_savings').html().replace('%1$s', savings));
				yalwa.basics.show(jQuery('.js-sc_discount_savings'));
			} else {
				jQuery('.js-pf_amount_total').html(format_price(total));
			}

			if (
				total === 0 &&
				is_cart() &&
				!jQuery('.js-cart_is_empty').length &&
				!freebie_in_cart
			) {
				// to show the "empty" view, but give the set-request a bit time
				if (window.location.search.search('empty=1') === -1) {
					window.setTimeout(function() {
						window.location.replace(window.location.href + (window.location.search === '' ? '?' : '&') + 'empty=1');
					}, 200);
				}
			}
		}

		function feature_extract() {
			var $feature = jQuery(this);
			if (!feature_is_selected($feature) && !is_cart()) {
				return null;
			}
			return {
				featureID: feature_get_featureID($feature),
				msgID: feature_get_msgID($feature) || 0,
				amount: is_deleted($feature) ? 0 : feature_get_selected_option($feature).val(),
				touchpointID: feature_get_touchpointID($feature)
			};
		}

		function is_deleted($feature) {
			return $feature.hasClass('js-marked_for_delete');
		}

		function extension_extract() {
			var $extension = jQuery(this);
			if (!extension_is_selected($extension) && !is_cart()) {
				return null;
			}
			var $feature = get_feature($extension);
			return {
				featureID: $extension.data('featureid'),
				msgID: feature_get_msgID($extension),
				amount: (is_deleted($feature) || is_deleted($extension)) ? 0 : feature_get_selected_option($feature).data('factor'),
				touchpointID: feature_get_touchpointID($extension.closest('.js-pf_feature'))
			};
		}

		function get_selected_features() {
			return jQuery('.js-pf_feature').map(feature_extract).get().concat(jQuery('.js-pf_extension').map(extension_extract).get());
		}

		function get_context() {
			return jQuery('.js-book_premium').data('context');
		}

		function cart_set_request() {
			var features = get_selected_features();
			var context = yalwa.v.shopping_cart_source || get_context();
			if (!features.length) {
				return jQuery.Deferred().reject();
			}
			return yalwa.basics.cart_set_ajax(features, context).done(update_cart_count);
		}

		function feature_extract_in_book_upgrade() {
			var $feature = jQuery(this);

			return {
				featureID: feature_get_featureID($feature),
				msgID: feature_get_msgID($feature) || 0,
				amount: !feature_is_selected($feature) ? 0 : feature_get_selected_option($feature).val()
			};
		}

		function extension_extract_in_book_upgrade() {
			var $extension = jQuery(this);
			var $feature = get_feature($extension);
			return {
				featureID: $extension.data('featureid'),
				msgID: feature_get_msgID($extension),
				amount: (!feature_is_selected($feature) || !extension_is_selected($extension)) ? 0 : feature_get_selected_option($feature).data('factor')
			};
		}

		function get_selected_features_in_book_upgrade() {
			return jQuery('.js-pf_feature').map(feature_extract_in_book_upgrade).get().concat(jQuery('.js-pf_extension').map(extension_extract_in_book_upgrade).get());
		}

		function cart_set_request_in_book_upgrade() {
			var features = get_selected_features_in_book_upgrade();
			var context = yalwa.v.shopping_cart_source || get_context();
			if (!features.length) {
				return jQuery.Deferred().reject();
			}
			return yalwa.basics.cart_set_ajax(features, context).done(update_cart_count);
		}

		return pub;

	}(pub.premium));

	pub.gestures = (function(pub) {

		pub = pub || {};

		let last = 0;
		let last_dir;
		let delta;
		let visible;
		let min_delta = 100;
		let always_visible_until = 200;
		let $htabs_cats;

		pub.init = function() {
			if (!$main_col.length || yalwa.basics.get_routing() === 'dol_landing' || yalwa.basics.get_routing() === 'uhp') {
				return;
			}
			$htabs_cats = jQuery('.js-htabs_cats');
			visible = $htabs_cats.hasClass('stuck');
			if ($htabs_cats.length) {
				$window.on('scroll.htabs_cats_throttle', yalwa.basics.throttle(scrolling_htabs_cats, 300));
			}
		};

		pub.fake_next = function() {
			$main_col.velocity('transition.slideRightBigIn', {duration: 250});
		};

		pub.fake_prev = function() {
			$main_col.velocity('transition.slideLeftBigIn', {duration: 250});
		};

		function scrolling_sticky() {
			$htabs_cats.addClass('stuck').velocity(
				{
					translateY: [0, -75],
					translateZ: 0
				}, {
					duration: 270,
					display: 'flex'
				}
			);
			yalwa.basics.show(jQuery('.js-narrow_search'));
			yalwa.basics.hide(jQuery('.js-email_alert_dialog_fixed'));

		}

		function scrolling_sticky_reset() {
			$htabs_cats.removeClass('stuck').velocity(
				{
					translateY: -75,
					translateZ: 0
				}, {
					duration: 270,
					display: 'flex'
				}
			);
			yalwa.basics.hide(jQuery('.js-narrow_search'));
			yalwa.basics.show(jQuery('.js-email_alert_dialog_fixed'));
		}

		function scrolling_htabs_cats() {
			if (yalwa.basics.scroll_is_locked()) {
				return;
			}
			const current = yalwa.mobile.mainscroll_get();
			if (current === last) {
				return;
			}
			if (current < always_visible_until) {
				if (!visible) {
					scrolling_sticky();
					visible = true;
				}
				last = current;
				return;
			}
			if (yalwa.vap) {
				if (!yalwa.v.deleted_ad) {
					scrolling_sticky_reset();
				}
				visible = false;
				last = current;
				return;
			}
			if ((current > last ? 'down' : 'up') === last_dir) {
				delta += Math.abs(current - last);
				if (delta > min_delta) {
					var show = last_dir === 'up';
					if ((show && !visible) || (!show && visible)) {
						if (show) {
							scrolling_sticky();
						} else {
							scrolling_sticky_reset();
						}
						visible = show;
						delta = 0;
					}
				}
			} else {
				delta = Math.abs(current - last);
			}
			last_dir = current > last ? 'down' : 'up';
			last = current;
		}

		return pub;

	}(pub.gestures));

	pub.ali = (function(pub) {
		pub = pub || {};

		var bem = 'ali';

		pub.init = function() {
			const $elements = jQuery('.js-ali_input');
			$elements.not('.js-ali_init_done')
				.on('focus', on_focus)
				.on('blur input change', on_blur);

			// solves chrome's credential autofill issue
			// setTimeout again???
			// actual only way to detect credential autofill is detecting -webkit-autofill css property on input.
			// IntersectionObserver fails: visibility do not change during browser adding the property to input. randomly true or false
			// MutationObserver fails; there is no mutations
			// waiting 100ms solves problem 99%
			setTimeout(function() {
				$elements
					.each(on_blur)
					.addClass('js-ali_init_done');
			}, 100);
		};

		pub.set_to_readonly = function($element) {
			const $container = $element.closest('.js-ali');
			$element.attr('readonly', true);
			$container.addClass(bem + '--readonly');
			yalwa.basics.show($container.find('.yicon'));
			if (!$container.find('.yicon').length) {
				const $lock_icon = yalwa.basics.yicon('lock_closed');
				$container.append($lock_icon);
			}

			$element.blur();
		};

		function on_focus() {
			jQuery(this).closest('.js-ali').addClass(bem + '--infocus');
		}

		function on_blur() {
			const $this = jQuery(this);
			if (
				$this.is(":-webkit-autofill") ||
				$this.val() ||
				($this.prop('type') === 'date' && !yalwa.v.is_ios)
			) {
				on_focus.apply(this);
			} else {
				$this.closest('.js-ali').removeClass(bem + '--infocus');
			}
		}

		return pub;
	}(pub.ali));

	pub.app_rating = (function(pub) {

		pub = pub || {};

		function app_rating_open_store() {
			const url = appstore_market_url();
			if (yalwa.v.is_phonegap && url) {
				yalwa.basics.openwebintent(url);
			}
		}

		function app_rating_later() {
			yalwa.basics.ls_set('app_rating_later', yalwa.basics.unix());
		}

		function appstore_url() {
			if (yalwa.v.is_ios) {
				return yalwa.v.IOS_APP_URL;
			} else if (yalwa.v.ANDROID_APP_URL) {
				return yalwa.v.ANDROID_APP_URL;
			} else {
				yalwa.basics.sentry.submit_error(new Error('appstore link missing'));
				return null;
			}
		}

		function appstore_market_url() {
			const url = appstore_url();
			if (!url || yalwa.v.is_ios) {
				return url;
			}
			const app_id = (url.match(/[?&]id=([^&]+)/) || [])[1];
			return app_id ? 'market://details?id=' + app_id : url;
		}

		function app_rating_dont_ask_again() {
			yalwa.mobile.cordova.cordova_send({action: 'forbid_app_rating', params: {value: true}});
		}

		function app_rating_allow_ask_again() {
			yalwa.mobile.cordova.cordova_send({action: 'forbid_app_rating', params: {value: false}});
		}

		function app_rating_ask_feedback(fl) {
			jQuery('.js-rating').remove();
			yalwa.basics.hide(jQuery('.js-appstore_rating_dialog_body'));
			yalwa.basics.show(jQuery('.js-appstore_rating_dialog_feedback'));
			var $rf = jQuery('.js-rating_feedback');
			yalwa.basics.show($rf);
			$rf.on('click', function() {
				if (yalwa.basics.ls_get('feedback_sent')) {
					fl.close();
					return false;
				}
				var value = jQuery('.js-rating_textarea').val();
				if (value) {
					jQuery('.js-rating_feedback').off('click');
					var $w = $window;
					jQuery.ajax({
						data: {
							feedback_type: 'locanto_app_android',
							page: window.location.href,
							feedback_text: value,
							feedback_mail: '',
							screen_width: $w.width(),
							screen_height: $w.height()
						},
						type: 'POST',
						url: '/' + yalwa.v.path_segment + '/run/feedback/'
					}).done(function(text) {
						if (text) {
							yalwa.basics.toast({message: text, type: 'success'});
							yalwa.basics.ls_set('feedback_sent', true);
						}
						fl.close();
					});
				} else {
					fl.close();
				}
			});
		}

		pub.check_opportunity = function() {
			if (yalwa.basics.ls_get('forbid_app_rating')) {
				return;
			}
			if (!yalwa.v.is_phonegap) {
				return;
			}
			yalwa.mobile.cordova.cordova_send({action: 'get_stats', params: {}});
		};

		pub.app_rating_clicked = function() {
			return pub.show();
		}

		pub.show = function() {
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/featherlight.min.js', function() {
				yalwa.basics.load_css(yalwa.v.css_path + 'featherlight.min.css');
				const is_android = !yalwa.v.is_ios;
				jQuery.ajax({
					data: {
						action: 'rating_dialog',
						os: yalwa.v.is_ios ? 'ios' : 'android'
					},
					type: 'GET',
					dataType: 'html',
					url: '/api/ajax/general'
				}).done(function(html) {
					let step = 'step1';
					let decision_made = false;
					const fl = jQuery.featherlight(html, {
						closeOnClick: is_android ? 'background' : false,
						afterClose: function() {
							if (decision_made) {
								return;
							}
							decision_made = true;
							// closing the confirmation step must restore "ask again later",
							// because the positive tap already set forbid_app_rating
							if (step === 'step2') {
								app_rating_allow_ask_again();
							}
							app_rating_later();
							track('later', step);
						}
					});

					function show_step2() {
						step = 'step2';
						yalwa.basics.hide(jQuery('.js-appstore_rating_dialog_body'));
						yalwa.basics.show(jQuery('.js-appstore_rating_confirm'));
					}

					jQuery('.js-appstore_rating_step1_close, .js-appstore_rating_step2_close').on('click', function() {
						fl.close();
					});

					jQuery('.js-appstore_rating_rate_app').on('click', function() {
						decision_made = true;
						fl.close();
						app_rating_open_store();
						track('rate_app');
					});

					jQuery('.js-rating').on('click', function() {
						const rating = jQuery(this).data('rating');
						if (rating === 'later') {
							decision_made = true;
							fl.close();
							app_rating_later();
							track('later');
						} else if (rating === 'good') {
							app_rating_dont_ask_again();
							track('good');
							if (is_android) {
								show_step2();
							} else {
								decision_made = true;
								fl.close();
								app_rating_open_store();
							}
						} else {
							decision_made = true;
							app_rating_dont_ask_again();
							if (yalwa.basics.ls_get('feedback_sent')) {
								fl.close();
								return false;
							}
							app_rating_ask_feedback(fl);
							track('bad_feedback');
						}
					});
				});
			});
		}

		function track(action, label) {
			let map = {
				'later': 'l',
				'good': 'p',
				'bad_feedback': 'n',
			}
			const decision = map[action];
			if (decision) {
				yalwa.basics.beacon('/api/ajax/track/', {
					t: 'app_rating',
					decision: decision
				});
			}
			yalwa.basics.ga.event({
				category: 'app_rating',
				action: action,
				label: label
			})
		}

		return pub;
	})(pub.app_rating);

	pub.magic_link = (function(pub) {
		pub = pub || {};

		let error_labels = [];

		pub.init = function(labels) {
			error_labels = labels;
			jQuery(document).on('ltabs_login', function() {
				toggle_to_login_form();
			});
			yalwa.mobile.magic_link.init_btns();
		};

		pub.init_btns = function() {
			jQuery('.js-ajax_magic_link_start').on('click', () => {
				yalwa.mobile.magic_link.toggle_to_ml_form();
			});
			jQuery('.js-magic_link_back_link').on('click', () => {
				toggle_to_login_form();
			});
			jQuery('.js-ajax_ml_submit').on('click', () => {
				request_magic_link();
			});
			jQuery('.js_ml_request_form').on('submit', (e) => {
				e.preventDefault();
				request_magic_link();
			});
		};

		pub.toggle_to_ml_form = function() {
			reset_ml_form();
			if(jQuery('.js-login_id').val().length !== 0) {
				jQuery('.js-login_id_ml').val(jQuery('.js-login_id').val());
				jQuery('.js-login_id_ml_ali').addClass('ali--infocus');
			}
			yalwa.basics.hide(jQuery('.js-login_section_form'));
			yalwa.basics.show(jQuery('.js-magic_link_section'));
		};

		function toggle_to_login_form() {
			yalwa.basics.hide(jQuery('.js-magic_link_section'));
			yalwa.basics.show(jQuery('.js-login_section_form'));
		}

		function request_magic_link() {
			let email = jQuery('.js-login_id_ml').val();
			if (email.length > 0) {
				yalwa.basics.ajaxservice({
					type: 'POST',
					resource: 'account',
					action: 'magiclink',
					data: {
						email: email
					},
					is_cross_origin: true
				}).then((response) => {
					if (response.success === true) {
						show_notice('email_sent', email);
					} else {
						show_notice(response.error, response.time_to_wait);
					}
				});
			} else {
				show_notice('invalid_email');
			}
		}

		function show_notice(error_name, value = '') {
			if(!error_name) {
				return false;
			}
			yalwa.basics.hide(jQuery('.js-ml_intro_text'));
			switch (error_name) {
				case 'invalid_email':
					reset_ml_form();
					yalwa.basics.toast({message: (error_labels || yalwa.v.lang).ml_error_invalid, type: 'error'});
					break;
				case 'wait_time':
					reset_ml_form();
					let minutes = Math.floor(value / 60);
					let seconds = String(Math.round(value % 60)).padStart(2, '0');
					yalwa.basics.toast({message: ((error_labels || yalwa.v.lang).ml_error_time).replace('%1$s', minutes).replace('%2$s', seconds), type: 'error'});
					break;
				case 'email_sent':
					reset_ml_form(true);
					let new_label_val = jQuery('.js-email_sent_text').html().replace('%1$s', value);
					jQuery('.js-email_sent_text').html(new_label_val);
					yalwa.basics.hide(jQuery('.js-login_id_ml'))
					yalwa.basics.hide(jQuery('.js-ajax_ml_submit'))
					yalwa.basics.show(jQuery('.js-email_sent'));
					break;
			}
		}

		function reset_ml_form(only_hide = false) {
			jQuery('.js-login_id_ml_ali').removeClass('ali--infocus');
			jQuery('.js-login_id_ml').val('');
			yalwa.basics.hide(jQuery('.js-email_sent'));
			yalwa.basics.show(jQuery('.js-login_id_ml'));
			if(!only_hide) {
				yalwa.basics.show(jQuery('.js-ml_intro_text'));
				yalwa.basics.show(jQuery('.js-ajax_ml_submit'));
			}
		}

		return pub;
	}(pub.magic_link));

	pub.pf_info_plp = (function(pub) {
		pub = pub || {};
		let pf_info_slider;

		pub.init_on_myads = () => {
			init_on_myads();

			//Init button to open the PLP (on My ads)
			jQuery(document).on('click', '.js-list_myadspremiumfeatures_title_icon',  function () {
				track_click();
				const $this = jQuery(this);
				open_plp();
				init_learn_more_click();
				track_plp_view();
				init_plp_close();
				let msg_id = $this.closest('.js-myads_posting').data('msgid');
				if (msg_id > 0) {
					let top_ad_link = jQuery($this.parents().eq(2).find('.js-my_ads_clicks')[0]).attr('href');
					let gallery_ad_link = jQuery($this.parents().eq(2).find('.js-my_ads_clicks')[1]).attr('href');
					let premium_ad_link = jQuery($this.parents().eq(2).find('.js-my_ads_clicks')[2]).attr('href');
					let links = {1 : top_ad_link, 2 : gallery_ad_link, 3: premium_ad_link};
					init_upgrade_button_click(links);
				}
			});

		};
		pub.init_on_interstitial = () => {
			init_slider();
			//Init button to open the PLP (on My ads)
			jQuery('.js-feature_view_example').on_once('click.feature_view_example', function () {
				const $this = jQuery(this);
				let feature_id = $this.data('feature_id')
				init_on_interstitial(feature_id);
			});
			//Open the Priority Lounge info PLP from the extensions modal
			jQuery('.js-priority_lounge_info').on('click', function (event) {
				event.stopPropagation();
				init_priority_lounge_plp();
			});
		};
		function init_learn_more_click() {
			//Track
			jQuery('.js-infocard-content > div > a').on('click', () => {
				yalwa.basics.ga.datalayer({
					event: 'pf_onboarding',
					action: 'learn_more_link'
				});
			})
		}
		function track_click() {
			yalwa.basics.ga.datalayer({
				event: 'pf_onboarding',
				action: 'info_icon_click'
			});
		}
		function track_plp_view() {
			yalwa.basics.ga.datalayer({
				event: 'pf_onboarding',
				action: 'plp_views'
			});
		}

		function init_on_interstitial(feature_id) {
			track_click();
			open_plp();
			init_plp_close();
			init_learn_more_click();
			track_plp_view();
			if (feature_id > 0) {
				let index = feature_id -1;
				pf_info_slider.slide_to(index);
			}

		}
		function init_priority_lounge_plp() {
			track_click();
			const $modal = jQuery('.js-extension_modal');
			if ($modal.length && !$modal.hasClass('hidden')) {
				yalwa.basics.hide($modal);
			}
			const $plp = jQuery('.js-priority_lounge_info_plp');
			$plp.off('plp_hide.priority_lounge').on('plp_hide.priority_lounge', function () {
				if ($modal.length && $modal.hasClass('hidden')) {
					yalwa.basics.show($modal);
				}
			});
			track_plp_view();
			$plp.trigger('plp_show');
		}
		function init_on_myads() {
			init_slider();
		}
		function init_slider() {
			//Init Slider
			const slide_options = {
				css_prefix:'infocard__',
				timeout:7000,
				container_class: 'js-simple_auto_slide_pfinfo',
				bullets : {container_class:  'js-slider_pagination_container'},
				clickable : false,
			};
			pf_info_slider = new yalwa.basics.simple_auto_slide(slide_options);
			pf_info_slider.start();
			init_next_button();

		}
		function init_next_button() {
			jQuery('.js-simple_auto_slider_pfinfo_next').on_once('click.simple_auto_slider_pfinfo_next', function () {
				//Track
				yalwa.basics.ga.datalayer({
					event: 'pf_onboarding',
					action: 'next_click'
				});
				pf_info_slider.slide();
			});
		}
		function init_upgrade_button_click(links) {
			jQuery('.js-pf_info_plp_upgrade').on_once('click.pf_info_plp_upgrade', () => {
				//Track
				yalwa.basics.ga.datalayer({
					event: 'pf_onboarding',
					action: 'upgrade_ad_click'
				});
				yalwa.basics.ls_set('last_premium_touchpoint_name', 'pf_onboarding_purchase');
				let which_slide = pf_info_slider.get_current_index() + 1;
				if (links && links[which_slide]) {
					yalwa.basics.navigate(links[which_slide]);
				}
			});

		}
		function open_plp() {
			jQuery('.js-premium_feature_info_plp').trigger('plp_show', {is_queued : true});
		}
		function init_plp_close() {
			jQuery('.js-pf_info_plp_close').on_once('click.pf_info_plp_close', () => {
				//Track
				yalwa.basics.ga.datalayer({
					event: 'pf_onboarding',
					action: 'close_click'
				});
				jQuery('.js-premium_feature_info_plp').trigger('plp_hide');
			});
		}

		return pub;
	})(pub.pf_info_plp);

    pub.show_chat_limit_reached_plp = function() {
        const is_pa_version = jQuery('.js-go_to_pa_booking_page').length;
        if (is_pa_version) {
            yalwa.basics.ga.datalayer({
                event: 'premium_account_vap_plp',
                premium_account_vap_plp: 'non_pa_user_plp_views'
            });
        } else {
            yalwa.basics.ga.datalayer({
                event: 'premium_account_vap_plp',
                premium_account_vap_plp: 'pa_user_plp_views'
            });
        }
        jQuery('.js-plp_conversation_limit_reached').trigger('plp_show');

        jQuery('.js-plp_conversation_limit_reached .js-plp_close').on_once('click.chat_limit_reached_plp_close', () => {
            yalwa.basics.ga.datalayer({
                event: 'premium_account_vap_plp',
                premium_account_vap_plp: 'plp_close_click'
            });
        });
        if (is_pa_version) {
            jQuery('.js-go_to_pa_booking_page').on('click', function() {
                yalwa.basics.ga.datalayer({
                    event: 'premium_account_vap_plp',
                    premium_account_vap_plp: 'plp_upgrade_click'
                });
                const url = jQuery(this).data('url');
                if (yalwa.mobile.is_mobile_width()) {
                    yalwa.basics.navigate(url);
                } else {
                    yalwa.basics.new_tab(url);
                }

            });
        }
    };

	pub.show_ua_phone_verification_dialog = function() {
		jQuery.ajax({
			type: 'POST',
			url: '/api/ajax/general/',
			dataType: 'html',
			data: {
				action: 'phone_verification',
				type: 'vap'
			}
		}).done(function(html) {
			jQuery('.js-phone_verification_container').html(html);
			yalwa.mobile.check_for_detach(); // needed for pv
			pub.ua_phone_verification_init();
		});
	};

	pub.ua_phone_verification_init = function() {
		yalwa.basics.load_js(yalwa.basics.static_url('js') + 'mobile/phone_verification_generic.js');
	};

	return pub;
}(yalwa.mobile));

yalwa.mobile.init();
